var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object2) {
          if (typeof object2 === "object" && object2 !== null) {
            var $$typeof = object2.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object2.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment4 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object2) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object2) {
          return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object2) {
          return typeOf(object2) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object2) {
          return typeOf(object2) === REACT_PROVIDER_TYPE;
        }
        function isElement2(object2) {
          return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object2) {
          return typeOf(object2) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object2) {
          return typeOf(object2) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object2) {
          return typeOf(object2) === REACT_LAZY_TYPE;
        }
        function isMemo(object2) {
          return typeOf(object2) === REACT_MEMO_TYPE;
        }
        function isPortal(object2) {
          return typeOf(object2) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object2) {
          return typeOf(object2) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object2) {
          return typeOf(object2) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object2) {
          return typeOf(object2) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment4;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement2;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i2 = 0; i2 < 10; i2++) {
          test2["_" + String.fromCharCode(i2)] = i2;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
          return test2[n2];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i2 = 0; i2 < symbols.length; i2++) {
            if (propIsEnumerable.call(from, symbols[i2])) {
              to[symbols[i2]] = from[symbols[i2]];
            }
          }
        }
      }
      return to;
    };
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement2, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y2) {
        if (x === y2) {
          return x !== 0 || 1 / x === 1 / y2;
        } else {
          return x !== x && y2 !== y2;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i2 = 0; i2 < propValue.length; i2++) {
            var error = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement2(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i2 = 0; i2 < expectedValues.length; i2++) {
            if (is(propValue, expectedValues[i2])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker = arrayOfTypeCheckers[i2];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
            var checker2 = arrayOfTypeCheckers[i3];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode2(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode2(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode2);
            }
            if (propValue === null || isValidElement2(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step2;
              if (iteratorFn !== propValue.entries) {
                while (!(step2 = iterator.next()).done) {
                  if (!isNode2(step2.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step2 = iterator.next()).done) {
                  var entry = step2.value;
                  if (entry) {
                    if (!isNode2(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"(exports, module) {
    if (true) {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// packages/_helpers/clickable.tsx
import React4 from "react";

// node_modules/.pnpm/@chbphone55+classnames@2.0.0/node_modules/@chbphone55/classnames/dist/index.m.js
var r = function() {
  for (var t = [], n2 = arguments.length; n2--; )
    t[n2] = arguments[n2];
  return t.reduce(function(t2, n3) {
    return t2.concat("string" == typeof n3 ? n3 : Array.isArray(n3) ? r.apply(void 0, n3) : "object" == typeof n3 && n3 ? Object.keys(n3).map(function(r3) {
      return n3[r3] ? r3 : "";
    }) : "");
  }, []).join(" ");
};

// node_modules/.pnpm/@warp-ds+css@1.9.6/node_modules/@warp-ds/css/component-classes/index.js
var badge = {
  base: "py-4 px-8 border-0 rounded-4 text-xs inline-flex",
  neutral: "bg-[--w-color-badge-neutral-background] s-text",
  info: "bg-[--w-color-badge-info-background] s-text",
  positive: "bg-[--w-color-badge-positive-background] s-text",
  warning: "bg-[--w-color-badge-warning-background] s-text",
  negative: "bg-[--w-color-badge-negative-background] s-text",
  disabled: "s-bg-disabled s-text",
  price: "bg-[--w-black/70] s-text-inverted-static",
  sponsored: "bg-[--w-color-badge-sponsored-background] s-text",
  // Notification badge is deprecated: Do not use! TODO: Remove in v2
  notification: "i-bg-$color-badge-notification-background i-text-$color-badge-notification-text",
  positionBase: "absolute backdrop-blur",
  positionTL: "rounded-tl-0 rounded-tr-0 rounded-bl-0 top-0 left-0",
  positionTR: "rounded-tl-0 rounded-tr-0 rounded-br-0 top-0 right-0",
  positionBR: "rounded-tr-0 rounded-br-0 rounded-bl-0 bottom-0 right-0",
  positionBL: "rounded-tl-0 rounded-br-0 rounded-bl-0 bottom-0 left-0"
};
var slider = {
  wrapper: "touch-pan-y relative w-full h-44 py-2",
  track: "absolute s-bg-disabled-subtle h-4 top-20 rounded-4 w-full ",
  trackDisabled: "pointer-events-none",
  activeTrack: "absolute s-bg-primary h-6 top-[19px] rounded-4",
  activeTrackDisabled: "absolute s-bg-disabled h-6 top-[19px] rounded-4 pointer-events-none",
  thumb: "absolute transition-shadow w-24 h-24 bottom-10 rounded-4 outline-none",
  thumbEnabled: "border-2 shadow-[--w-shadow-slider] cursor-pointer s-bg-primary s-border-primary hover:s-bg-primary-hover hover:s-border-primary-hover hover:shadow-[--w-shadow-slider-handle-hover] active:s-bg-primary-active active:s-border-primary-active active:shadow-[--w-shadow-slider-handle-active] focus:shadow-[--w-shadow-slider-handle-hover] focus:s-border-primary-hover focus:s-bg-primary-hover",
  thumbDisabled: "s-bg-disabled cursor-disabled pointer-events-none"
};
var box = {
  box: "group block relative break-words last-child:mb-0 p-16 rounded-8",
  // Relative here enables w-clickable
  bleed: "-mx-16 sm:mx-0 rounded-l-0 rounded-r-0 sm:rounded-8",
  // We target L and R to override the default rounded-8
  info: "s-bg-info-subtle",
  neutral: "s-surface-sunken",
  bordered: "border-2 s-border s-bg",
  infoClickable: "hover:s-bg-info-subtle-hover active:s-bg-info-subtle-active",
  // Deprecated - Remove in v2 (after removing Clickable prop in the Box components)
  neutralClickable: "hover:s-bg-hover active:s-bg-active",
  // Deprecated - Remove in v2 (after removing Clickable prop in the Box components)
  borderedClickable: "hover:s-bg-hover active:s-bg-active hover:s-border-hover active:s-border-active"
  // Deprecated - Remove in v2 (after removing Clickable prop in the Box components)
};
var pill = {
  pill: "flex items-center",
  button: "inline-flex items-center focusable text-xs transition-all",
  suggestion: "bg-[--w-color-pill-suggestion-background] hover:bg-[--w-color-pill-suggestion-background-hover] active:bg-[--w-color-pill-suggestion-background-active] s-text font-bold",
  filter: "s-bg-primary hover:s-bg-primary-hover active:s-bg-primary-active s-text-inverted",
  label: "pl-12 py-8 rounded-l-full",
  labelWithoutClose: "pr-12 rounded-r-full",
  labelWithClose: "pr-2",
  close: "pr-12 pl-4 py-8 rounded-r-full",
  a11y: "sr-only"
};
var step = {
  step: "group/step",
  stepVertical: "group/stepv grid-rows-[20px_auto] grid grid-flow-col gap-x-16",
  stepVerticalLeft: "grid-cols-[20px_1fr]",
  stepVerticalRight: "grid-cols-[1fr_20px] text-right",
  stepHorizontal: "group/steph grid-rows-[auto_20px] grid-cols-[1fr_20px_1fr] flex-1 grid gap-y-16 items-center",
  stepDot: "rounded-full border-2 h-20 w-20 transition-colors duration-300 s-icon-inverted",
  stepDotVerticalRight: "col-start-2",
  stepDotHorizontal: "row-start-2 justify-self-end",
  stepDotActive: "s-border-primary s-bg-primary",
  stepDotIncomplete: "s-border s-bg",
  stepLine: "group-last/stepv:hidden transition-colors duration-300",
  stepLineVertical: "w-2 h-full justify-self-center",
  stepLineVerticalRight: "col-start-2",
  stepLineHorizontal: "h-2 w-full row-start-2",
  stepLineHorizontalRight: "group-last/steph:bg-transparent",
  stepLineHorizontalLeft: "group-first/steph:bg-transparent",
  stepLineIncomplete: "s-bg-disabled",
  stepLineComplete: "s-bg-primary",
  content: "last:mb-0 group-last/step:last:pb-0",
  contentVertical: "row-span-2 pb-32",
  contentHorizontal: "col-span-3 px-16 row-start-1 text-center"
};
var steps = {
  steps: "w-full",
  stepsHorizontal: "flex"
};
var card = {
  card: "cursor-pointer overflow-hidden relative transition-all",
  cardShadow: "group rounded-8 s-surface-elevated-200 hover:s-surface-elevated-200-hover active:s-surface-elevated-200-active",
  cardUnselected: "",
  // TODO: Remove in v2 - Not used after introducing surface
  cardSelected: "!s-bg-selected !hover:s-bg-selected-hover !active:s-bg-selected-active",
  cardOutline: "absolute border-2 rounded-8 inset-0 transition-all",
  cardOutlineUnselected: "border-transparent group-active:s-border-active",
  cardOutlineSelected: "s-border-selected group-hover:s-border-selected-hover group-active:s-border-selected-active",
  cardFlat: "border-2 rounded-4",
  cardFlatUnselected: "s-bg hover:s-bg-hover active:s-bg-active s-border hover:s-border-hover active:s-border-active",
  cardFlatSelected: "s-bg-selected hover:s-bg-selected-hover active:s-bg-selected-active s-border-selected hover:s-border-selected-hover active:s-border-selected-active",
  a11y: "sr-only"
};
var switchToggle = {
  switch: "",
  // TODO: Remove this in v2
  label: "block relative h-24 w-44 cursor-pointer group",
  labelDisabled: "pointer-events-none",
  track: "absolute top-0 left-0 h-full w-full rounded-full transition-colors",
  trackActive: "s-bg-primary group-hover:s-bg-primary-hover",
  trackInactive: "bg-[--w-color-switch-track-background] group-hover:bg-[--w-color-switch-track-background-hover]",
  trackDisabled: "s-bg-disabled-subtle",
  handle: "absolute transform-gpu h-16 w-16 top-4 left-4 rounded-full transition-transform",
  handleSelected: "translate-x-20",
  handleNotDisabled: "s-bg shadow-s",
  handleDisabled: "s-bg-disabled",
  a11y: "sr-only"
};
var tabs = {
  tabContainer: "inline-grid relative",
  wunderbar: "absolute s-border-selected -bottom-0 border-b-4 transition-all",
  wrapperUnderlined: "border-b border-transparent -mx-16 sm:mx-0 px-4 sm:px-0 mb-32 "
};
var tab = {
  tab: "grid items-center font-bold gap-8 focusable antialias p-16 pb-8 border-b-4 bg-transparent s-text-subtle border-transparent hover:s-text-link hover:s-border-primary",
  tabActive: "s-text-link",
  icon: "mx-auto hover:s-text-link",
  iconUnderlinedActive: "s-text-link",
  content: "flex items-center justify-center gap-8",
  contentUnderlined: "content-underlined",
  // content-underlined is a no-op that prevents a quirk in how Vue handles class bindings
  contentUnderlinedActive: "s-text-link"
};
var gridLayout = {
  cols1: "grid-cols-1",
  cols2: "grid-cols-2",
  cols3: "grid-cols-3",
  cols4: "grid-cols-4",
  cols5: "grid-cols-5",
  cols6: "grid-cols-6",
  cols7: "grid-cols-7",
  cols8: "grid-cols-8",
  cols9: "grid-cols-9"
};
var buttonReset = "focus:outline-none appearance-none cursor-pointer bg-transparent border-0 m-0 p-0 inline-block";
var expandable = {
  expandable: "will-change-height",
  expandableTitle: "font-bold s-text",
  expandableBox: "s-surface-sunken hover:s-bg-hover active:s-bg-active py-0 px-0 " + box.box,
  expandableInfo: "s-bg-info-subtle! hover:s-bg-info-subtle-hover!",
  expandableBleed: box.bleed,
  chevron: "inline-block align-middle s-icon",
  chevronNonBox: "ml-8",
  chevronBox: "",
  chevronTransform: "transform transition-transform transform-gpu ease-in-out",
  chevronExpand: "-rotate-180",
  chevronCollapse: "rotate-180",
  elementsTransformChevronDownPart: "part-[w-icon-chevron-down-16-part]:transform part-[w-icon-chevron-down-16-part]:transition-transform part-[w-icon-chevron-down-16-part]:transform-gpu part-[w-icon-chevron-down-16-part]:ease-in-out",
  elementsChevronDownExpandPart: "part-[w-icon-chevron-down-16-part]:-rotate-180",
  elementsTransformChevronUpPart: "part-[w-icon-chevron-up-16-part]:transform part-[w-icon-chevron-up-16-part]:transition-transform part-[w-icon-chevron-up-16-part]:transform-gpu part-[w-icon-chevron-up-16-part]:ease-in-out",
  elementsChevronUpCollapsePart: "part-[w-icon-chevron-up-16-part]:rotate-180",
  expansion: "overflow-hidden",
  expansionNotExpanded: "h-0 invisible",
  button: buttonReset + " hover:underline focus-visible:underline",
  buttonBox: "w-full text-left relative inline-flex items-center justify-between " + box.box,
  paddingTop: "pt-0",
  title: "flex w-full justify-between items-center",
  titleType: "h4"
};
var buttonDefaultStyling = "font-bold focusable justify-center transition-colors ease-in-out";
var buttonColors = {
  primary: "s-text-inverted bg-[--w-color-button-primary-background] hover:bg-[--w-color-button-primary-background-hover] active:bg-[--w-color-button-primary-background-active]",
  secondary: "s-text-link s-border s-bg hover:s-bg-hover hover:s-border-hover active:s-bg-active",
  utility: "s-text s-bg hover:s-bg-hover active:s-bg-active s-border hover:s-border-hover active:s-border-active",
  destructive: "s-bg-negative s-text-inverted hover:s-bg-negative-hover active:s-bg-negative-active",
  pill: "s-icon hover:s-icon-hover active:s-icon-active bg-transparent hover:bg-[--w-color-button-pill-background-hover] active:bg-[--w-color-button-pill-background-active]",
  disabled: "s-text-inverted s-bg-disabled",
  quiet: "bg-transparent s-text-link hover:s-bg-hover active:s-bg-active",
  utilityQuiet: "s-text bg-transparent hover:s-bg-hover active:s-bg-active",
  negativeQuiet: "bg-transparent s-text-negative hover:s-bg-negative-subtle-hover active:s-bg-negative-subtle-active",
  loading: "s-text s-bg-subtle",
  link: "s-text-link"
};
var buttonTypes = {
  primary: `border-0 rounded-8 ${buttonDefaultStyling}`,
  secondary: `border-2 rounded-8 ${buttonDefaultStyling}`,
  utility: `border rounded-4 ${buttonDefaultStyling}`,
  negative: `border-0 rounded-8 ${buttonDefaultStyling}`,
  pill: `p-4 rounded-full border-0 inline-flex items-center justify-center hover:bg-clip-padding ${buttonDefaultStyling}`,
  link: `bg-transparent focusable ease-in-out inline active:underline hover:underline focus:underline ${buttonColors.link}`
};
var buttonSizes = {
  xsmall: "py-6 px-16",
  small: "py-8 px-16",
  medium: "py-10 px-14",
  large: "py-12 px-16",
  utility: "py-[11px] px-[15px]",
  smallUtility: "py-[7px] px-[15px]",
  pill: "min-h-[44px] min-w-[44px]",
  pillSmall: "min-h-32 min-w-32",
  link: "p-0"
};
var buttonTextSizes = {
  medium: "text-m leading-[24]",
  xsmall: "text-xs"
};
var buttonVariants = {
  inProgress: `border-transparent animate-inprogress pointer-events-none ${buttonColors.loading}`,
  // .button--in-progress, a.button--in-progress:visited
  quiet: `border-0 rounded-8 ${buttonDefaultStyling}`,
  utilityQuiet: `border-0 rounded-4 ${buttonDefaultStyling}`,
  negativeQuiet: `border-0 rounded-8 ${buttonDefaultStyling}`,
  isDisabled: `font-bold justify-center transition-colors ease-in-out cursor-default pointer-events-none ${buttonColors.disabled}`
  // .button:disabled, .button--is-disabled
};
var button = {
  // Buttontypes
  secondary: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  // .button--secondary, .button--default, .button
  secondaryHref: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  secondaryDisabled: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonVariants.isDisabled}`,
  secondarySmall: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  secondarySmallDisabled: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonTypes.secondary} ${buttonVariants.isDisabled}`,
  secondaryQuiet: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  secondaryQuietDisabled: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  secondarySmallQuiet: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  secondarySmallQuietDisabled: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  secondaryLoading: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonVariants.inProgress}`,
  secondarySmallLoading: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall}  ${buttonTypes.secondary} ${buttonVariants.inProgress}`,
  secondarySmallQuietLoading: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  secondaryQuietLoading: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  primary: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.primary} ${buttonColors.primary}`,
  // .button--primary, .button--cta
  primaryDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.isDisabled} ${buttonTypes.primary}`,
  primarySmall: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.primary} ${buttonColors.primary}`,
  primarySmallDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.isDisabled} ${buttonTypes.primary} `,
  primaryQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  primaryQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  primarySmallQuiet: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  primarySmallQuietDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  primaryLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primarySmallLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall}  ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primarySmallQuietLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primaryQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  utility: `${buttonSizes.utility} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonColors.utility}`,
  // .button--utility
  utilityDisabled: `${buttonSizes.utility} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonVariants.isDisabled}`,
  utilityQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.utilityQuiet} ${buttonColors.utilityQuiet}`,
  // .button--utility-flat
  utilityQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.utilityQuiet} ${buttonVariants.isDisabled}`,
  utilitySmall: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonColors.utility}`,
  utilitySmallDisabled: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonVariants.isDisabled}`,
  utilitySmallQuiet: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.utilityQuiet} ${buttonColors.utilityQuiet}`,
  utilitySmallQuietDisabled: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.utilityQuiet} ${buttonVariants.isDisabled}`,
  utilityLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonVariants.inProgress}`,
  utilitySmallLoading: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonVariants.inProgress}`,
  utilityQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.inProgress} ${buttonVariants.utilityQuiet}`,
  utilitySmallQuietLoading: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.inProgress} ${buttonVariants.utilityQuiet}`,
  negative: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonColors.destructive}`,
  // .button--destructive
  negativeDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonVariants.isDisabled}`,
  negativeQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet} ${buttonColors.negativeQuiet}`,
  // .button--destructive-flat
  negativeQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet}${buttonVariants.isDisabled}`,
  negativeSmall: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.negative} ${buttonColors.destructive}`,
  negativeSmallDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.negative} ${buttonVariants.isDisabled}`,
  negativeSmallQuiet: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonColors.negativeQuiet}`,
  negativeSmallQuietDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonVariants.isDisabled}`,
  negativeLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonVariants.inProgress}`,
  negativeSmallLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.inProgress} ${buttonTypes.negative}`,
  negativeQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet} ${buttonTypes.negative} ${buttonVariants.inProgress}`,
  negativeSmallQuietLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonVariants.inProgress}`,
  pill: `${buttonSizes.pill} ${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill}`,
  // .button--pill
  pillSmall: `${buttonSizes.pillSmall} ${buttonTextSizes.xsmall} ${buttonTypes.pill} ${buttonColors.pill}`,
  pillLoading: `${buttonSizes.pill} ${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonVariants.inProgress}`,
  pillSmallLoading: `${buttonSizes.pillSmall} ${buttonTextSizes.xsmall} ${buttonTypes.pill} ${buttonVariants.inProgress}`,
  link: `${buttonSizes.link} ${buttonTextSizes.medium} ${buttonTypes.link}`,
  linkSmall: `${buttonSizes.link} ${buttonTextSizes.xsmall} ${buttonTypes.link}`,
  linkAsButton: "inline-block active:no-underline hover:no-underline focus:no-underline text-center",
  a11y: "sr-only",
  fullWidth: "w-full max-w-full",
  contentWidth: "max-w-max"
};
var modal = {
  transparentBg: "",
  //TODO: Remove in v2 - previously used for opacity before changing to a rgba background in backdrop
  backdrop: "fixed inset-0 flex sm:place-content-center sm:place-items-center items-end z-30 [--w-modal-max-height:80%] [--w-modal-width:640px] bg-[--w-black/25]",
  modal: "pb-safe-[32] shadow-m max-h-[--w-modal-max-height] min-h-[--w-modal-min-height] w-[--w-modal-width] h-[--w-modal-height] relative transition-300 ease-in-out backface-hidden will-change-height rounded-8 mx-0 sm:mx-16 bg-[--w-s-color-surface-elevated-100] flex flex-col overflow-hidden outline-none space-y-16 pt-8 sm:pt-32 sm:pb-32 rounded-b-0 sm:rounded-b-8",
  content: "block overflow-y-auto overflow-x-hidden last-child:mb-0 grow shrink px-16 sm:px-32 relative",
  footer: "flex justify-end shrink-0 px-16 sm:px-32",
  transitionTitle: "transition-all duration-300",
  transitionTitleCenter: "justify-self-center self-center",
  transitionTitleColSpan: "col-span-2",
  title: "py-8 sm:py-0 -mt-4 sm:-mt-8 min-h-40 sm:min-h-48 grid gap-8 sm:gap-16 grid-cols-[auto_1fr_auto] items-start px-16 sm:px-32 border-b sm:border-b-0 shrink-0",
  titleText: "mb-0 h4 sm:h3",
  titleButton: `${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill} sm:min-h-[44px] sm:min-w-[44px] min-h-[32px] min-w-[32px]`,
  titleButtonLeft: "-ml-8 sm:-ml-12 justify-self-start",
  titleButtonRight: "-mr-8 sm:-mr-12 justify-self-end",
  titleButtonIcon: "h-16 w-16 sm:h-24 sm:w-24",
  titleButtonIconRotated: "transform rotate-90"
};
var alert = {
  alert: "flex p-16 border border-l-4 rounded-4 s-text",
  willChangeHeight: "will-change-height",
  textWrapper: "last-child:mb-0 text-s",
  title: "text-s",
  icon: "w-16 mr-8 min-w-16",
  negative: "s-border-negative-subtle s-border-l-negative s-bg-negative-subtle",
  negativeIcon: "s-icon-negative",
  positive: "s-border-positive-subtle s-border-l-positive s-bg-positive-subtle",
  positiveIcon: "s-icon-positive",
  warning: "s-border-warning-subtle s-border-l-warning s-bg-warning-subtle",
  warningIcon: "s-icon-warning",
  info: "s-border-info-subtle s-border-l-info s-bg-info-subtle",
  infoIcon: "s-icon-info"
};
var input = {
  // wrapper classes
  wrapper: "relative",
  // input classes
  base: "block text-m leading-m mb-0 px-8 py-12 rounded-4 w-full focusable focus:[--w-outline-offset:-2px] caret-current",
  // true
  default: "border-1 s-text s-bg s-border hover:s-border-hover active:s-border-selected",
  // !isInvalid && !isDisabled && !isReadOnly
  disabled: "border-1 s-text-disabled s-bg-disabled-subtle s-border-disabled pointer-events-none",
  // !isInvalid && isDisabled && !isReadOnly
  invalid: "border-1 s-text-negative s-bg s-border-negative hover:s-border-negative-hover outline-[--w-s-color-border-negative]!",
  // isInvalid && !isDisabled && !isReadOnly
  readOnly: "pl-0 bg-transparent pointer-events-none",
  // !isInvalid && !isDisabled && isReadOnly
  placeholder: "placeholder:s-text-placeholder",
  suffix: "pr-40",
  prefix: "pl-[var(--w-prefix-width,_40px)]",
  // textarea classes
  textArea: "min-h-[42] sm:min-h-[45]"
};
var select = {
  default: "block text-m mb-0 leading-m s-text s-bg s-border hover:s-border-hover active:s-border-active rounded-4 py-12 px-8 block border-1 w-full focusable focus:[--w-outline-offset:-2px] appearance-none pr-32 cursor-pointer caret-current",
  disabled: "s-bg-disabled-subtle s-border-disabled hover:s-border-disabled! active:s-border-disabled! s-text-disabled pointer-events-none",
  invalid: "s-border-negative hover:s-border-negative-hover! outline-[--w-s-color-border-negative]!",
  readOnly: "pl-0 bg-transparent border-0 pointer-events-none before:hidden",
  wrapper: "relative",
  selectWrapper: `relative before:block before:absolute before:right-0 before:bottom-0 before:w-32 before:h-full before:pointer-events-none `,
  chevron: "absolute top-[30%] block right-0 bottom-0 w-32 h-full s-icon pointer-events-none cursor-pointer",
  chevronDisabled: "opacity-25"
};
var label = {
  label: "antialiased block relative text-s font-bold pb-4 cursor-pointer s-text",
  optional: "pl-8 font-normal text-s s-text-subtle",
  labelInvalid: "s-text-negative"
  // TODO: Remove in v2 - kept for backwards compatibility
};
var helpText = {
  helpText: "text-xs mt-4 block",
  helpTextColor: "s-text-subtle",
  helpTextColorInvalid: "s-text-negative",
  // TODO: Remove below properties in v2 - kept for backwards compatibility
  helpTextValid: "s-text-positive",
  helpTextInvalid: "s-text-negative"
};
var prefixSuffixWrapperBase = "absolute top-0 bottom-0 flex justify-center items-center focusable rounded-4 focus:[--w-outline-offset:-2px] bg-transparent ";
var suffix = {
  wrapper: prefixSuffixWrapperBase + "right-0",
  wrapperWithLabel: "w-max pr-12",
  wrapperWithIcon: "w-40",
  label: "antialiased block relative cursor-default pb-0 font-bold text-xs s-text"
};
var prefix = {
  wrapper: prefixSuffixWrapperBase + "left-0",
  wrapperWithLabel: "w-max pl-12",
  wrapperWithIcon: "w-40",
  label: "antialiased block relative cursor-default pb-0 font-bold text-xs s-text"
};
var breadcrumbs = {
  wrapper: "flex space-x-8",
  text: "s-text",
  link: "s-text-link",
  separator: "select-none s-icon",
  a11y: "sr-only"
};
var toggle = {
  // wrapper classes
  field: "relative text-m",
  // true
  wrapper: "relative py-1",
  // true
  wrapperRadioButtons: "inline-flex font-bold rounded-8 focus-within:focusable",
  // isRadioButton && !isEqualWidth
  wrapperRadioButtonsJustified: "flex font-bold rounded-8 focus-within:focusable",
  // isRadioButton && isEqualWidth,
  // group classes
  radioButtonsGroup: "group",
  // isRadioButton
  radioButtonsGroupJustified: "grow-1 shrink-0 basis-auto",
  // isRadioButton && isEqualWidth
  // input classes
  input: "peer",
  a11y: "sr-only",
  // label classes
  label: "peer-focus:focusable cursor-pointer text-m s-text s-border py-2 pl-28 select-none relative block before:border before:absolute before:transition-all before:left-0 before:w-20 before:h-20 before:top-2",
  // !isRadioButton
  labelBefore: 'before:content-[""] before:block',
  // !isRadioButton && !isIndeterminate
  checkbox: "before:s-bg before:rounded-2 hover:before:s-border-primary hover:before:s-bg-hover peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-border-primary peer-checked:before:s-bg-primary peer-checked:peer-hover:before:s-border-primary-hover peer-checked:peer-hover:before:s-bg-primary-hover",
  // isCheckbox && !isIndeterminate && !isInvalid && !isDisabled
  checkboxInvalid: "before:s-bg before:s-border-negative before:rounded-2 hover:before:s-bg-negative-subtle-hover hover:before:s-border-negative-hover peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-bg-negative peer-checked:before:s-border-negative peer-checked:peer-hover:before:s-bg-negative-hover peer-checked:peer-hover:before:s-border-negative-hover",
  // isCheckbox && !isIndeterminate && isInvalid && !isDisabled
  checkboxDisabled: "before:s-bg-disabled-subtle before:s-border-disabled pointer-events-none before:rounded-2 peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-border-disabled peer-checked:before:s-bg-disabled",
  // isCheckbox && !isIndeterminate && !isInvalid && isDisabled
  indeterminate: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold before:s-icon-inverted peer-indeterminate:before:s-border-primary peer-indeterminate:before:s-bg-primary peer-indeterminate:hover:before:s-border-primary-hover peer-indeterminate:hover:before:s-bg-primary-hover',
  // isCheckbox && isIndeterminate && !isInvalid && !isDisabled
  indeterminateInvalid: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold before:s-icon-inverted peer-indeterminate:before:s-border-negative peer-indeterminate:before:s-bg-negative peer-indeterminate:hover:before:s-border-negative-hover peer-indeterminate:hover:before:s-bg-negative-hover',
  // isCheckbox && isIndeterminate && isInvalid && !isDisabled
  indeterminateDisabled: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold pointer-events-none before:s-icon-inverted peer-indeterminate:before:s-border-disabled peer-indeterminate:before:s-bg-disabled',
  // isCheckbox && isIndeterminate && !isInvalid && isDisabled
  radio: "before:s-bg before:rounded-full peer-checked:before:border-[6] peer-checked:before:s-border-selected peer-checked:peer-hover:before:s-border-selected-hover peer-hover:before:s-border-primary peer-hover:before:s-bg-hover",
  // isRadio && !isDisabled && !isInvalid
  radioInvalid: "before:s-bg before:s-border-negative before:rounded-full peer-checked:before:border-[6] peer-hover:before:s-bg-negative-subtle peer-hover:before:s-border-negative-hover peer-checked:before:s-border-negative peer-checked:peer-hover:before:s-border-negative-hover",
  // isRadio && isInvalid && !isDisabled
  radioDisabled: "before:s-bg-disabled-subtle before:s-border-disabled pointer-events-none before:rounded-full peer-checked:before:border-[6]",
  // isRadio && !isInvalid && isDisabled
  radioButtonsLabel: "peer-hover:peer-not-checked:s-bg-hover peer-checked:s-text-inverted peer-checked:s-bg-primary peer-checked:s-border-primary block relative font-bold cursor-pointer s-text-link text-center s-bg border-2 s-border group-first-of-type:rounded-tl-8 group-first-of-type:rounded-bl-8 group-last-of-type:rounded-tr-8 group-last-of-type:rounded-br-8 group-not-last-of-type:border-r-0 peer-checked:z-10 group-not-first:-ml-2",
  // isRadioButtons
  radioButtonsRegular: "text-s py-8 pl-12 pr-14",
  // isRadioButtons && !isSmall
  radioButtonsSmall: "text-xs py-[5px] px-[8px]"
  // isRadioButtons && isSmall
};
var deadToggle = {
  wrapper: `${toggle.wrapper} h-20 w-20 pointer-events-none`,
  input: `${toggle.input} hidden`,
  inputVue: "hidden",
  labelRadio: `${toggle.label} ${toggle.labelBefore} ${toggle.radio}`,
  labelCheckbox: `${toggle.label} ${toggle.labelBefore} ${toggle.checkbox}`,
  labelVue: "-mt-2"
};
var clickable = {
  toggle: "absolute inset-0 h-full w-full appearance-none cursor-pointer focusable focusable-inset",
  label: `px-12 ${label.label} py-8! cursor-pointer focusable focusable-inset`,
  buttonOrLink: "bg-transparent focusable",
  buttonOrLinkStretch: "inset-0 absolute"
};
var combobox = {
  wrapper: "relative",
  combobox: "absolute left-0 right-0 pb-8 rounded-8 s-bg shadow-m",
  textMatch: "font-bold",
  listbox: "m-0 p-0 select-none list-none",
  option: "block cursor-pointer p-8 hover:s-bg-hover",
  optionSelected: "s-bg-selected hover:s-bg-selected-hover",
  a11y: "sr-only"
};
var attention = {
  base: "border-2 relative flex items-start",
  tooltip: "s-bg-inverted border-[--w-s-color-background-inverted] shadow-m s-text-inverted-static rounded-4 py-6 px-8",
  callout: "bg-[--w-color-callout-background] border-[--w-color-callout-border] s-text py-8 px-16 rounded-8",
  highlight: "bg-[--w-color-callout-background] border-[--w-color-callout-border] s-text py-8 px-16 rounded-8 drop-shadow-m translate-z-0",
  popover: "bg-[--w-s-color-surface-elevated-300] border-[--w-s-color-surface-elevated-300] s-text rounded-8 p-16 drop-shadow-m translate-z-0",
  arrowBase: "absolute h-[14px] w-[14px] border-2 border-b-0 border-r-0 rounded-tl-4 transform",
  arrowDirectionLeftStart: "-left-[8px]",
  arrowDirectionLeft: "-left-[8px]",
  arrowDirectionLeftEnd: "-left-[8px]",
  arrowDirectionRightStart: "-right-[8px]",
  arrowDirectionRight: "-right-[8px]",
  arrowDirectionRightEnd: "-right-[8px]",
  arrowDirectionBottomStart: "-bottom-[8px]",
  arrowDirectionBottom: "-bottom-[8px]",
  arrowDirectionBottomEnd: "-bottom-[8px]",
  arrowDirectionTopStart: "-top-[8px]",
  arrowDirectionTop: "-top-[8px]",
  arrowDirectionTopEnd: "-top-[8px]",
  arrowTooltip: "s-bg-inverted border-[--w-s-color-background-inverted]",
  arrowCallout: "bg-[--w-color-callout-background] border-[--w-color-callout-border]",
  arrowPopover: "bg-[--w-s-color-surface-elevated-300] border-[--w-s-color-surface-elevated-300]",
  arrowHighlight: "bg-[--w-color-callout-background] border-[--w-color-callout-border]",
  content: "last-child:mb-0",
  notCallout: "absolute z-50",
  closeBtn: `${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill} justify-self-end -mr-8 ml-8`
};
var pagination = {
  link: "hover:no-underline focus:no-underline focusable inline-flex justify-center items-center transition-colors ease-in-out min-h-[44px] min-w-[44px] p-4 rounded-full border-0 hover:bg-clip-padding",
  currentPage: "block md:hidden p-8 font-bold",
  icon: "s-icon hover:bg-[--w-color-button-pill-background-hover] active:bg-[--w-color-button-pill-background-active]",
  containerNav: "flex items-center justify-center p-8",
  a11y: "sr-only",
  pages: "hidden md:block s-text-link",
  active: "s-bg-primary s-text-inverted",
  notActive: "hover:bg-[--w-color-button-pill-background-hover] active:bg-[--w-color-button-pill-background-active]"
};

// packages/toggle/src/item.tsx
import React3 from "react";

// packages/utils/src/useElementSizeObserver.ts
import { useCallback, useState } from "react";

// node_modules/.pnpm/resize-observer-polyfill@1.5.1/node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value) {
        var index2 = getIndex(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries = this.__entries__;
        var index2 = getIndex(entries, key);
        if (~index2) {
          entries.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer) {
        return observer.gatherActive(), observer.hasActive();
      });
      activeObservers.forEach(function(observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
      var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  }()
);
var defineConfigurable = function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size2, position) {
    var value = styles["border-" + position + "-width"];
    return size2 + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles["padding-" + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x = _a.x, y2 = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x,
    y: y2,
    width,
    height,
    top: y2,
    right: x + width,
    bottom: height + y2,
    left: x
  });
  return rect;
}
function createRectInit(x, y2, width, height) {
  return { x, y: y2, width, height };
}
var ResizeObservation = (
  /** @class */
  function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  }()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  }()
);
var ResizeObserverSPI = (
  /** @class */
  function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  }()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserver3(callback) {
      if (!(this instanceof ResizeObserver3)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }
    return ResizeObserver3;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method) {
  ResizeObserver2.prototype[method] = function() {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver2;
}();

// packages/utils/src/useIsomorphicLayoutEffect.ts
import { useEffect, useLayoutEffect as useLayoutEffectSafely } from "react";
var useLayoutEffect = typeof window !== "undefined" ? useLayoutEffectSafely : useEffect;

// packages/utils/src/useId.ts
import React2 from "react";
var useReactId = React2.useId;
var safeUseReactId = typeof useReactId === "function" ? () => useReactId().replace(/:/g, "") : () => React2.useState(generateId())[0];
var useId = (hasFallback) => {
  const id = safeUseReactId();
  return hasFallback || id;
};
function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
}

// packages/utils/src/useLogDeprecationWarning.ts
import { useEffect as useEffect2, useRef } from "react";
var useLogDeprecationWarning = ({ condition, message }) => {
  const loggedOnce = useRef(false);
  useEffect2(() => {
    if (loggedOnce.current) {
      return;
    }
    if (condition) {
      console.warn(message);
      loggedOnce.current = true;
    }
  }, [condition, message]);
};

// packages/toggle/src/item.tsx
function Item(_a) {
  var _b = _a, {
    controlled,
    option,
    children,
    label: label2,
    invalid,
    value,
    helpId,
    indeterminate = false,
    checked,
    defaultChecked,
    noVisibleLabel,
    labelClassName,
    inputClassName,
    groupClassName,
    multiple
  } = _b, props = __objRest(_b, [
    "controlled",
    "option",
    "children",
    "label",
    "invalid",
    "value",
    "helpId",
    "indeterminate",
    "checked",
    "defaultChecked",
    "noVisibleLabel",
    "labelClassName",
    "inputClassName",
    "groupClassName",
    "multiple"
  ]);
  const id = useId();
  const checkboxRef = React3.useRef(null);
  const labelContent = !children ? label2 || (option == null ? void 0 : option.label) : children;
  React3.useEffect(() => {
    if (!checkboxRef.current) {
      return;
    }
    checkboxRef.current.indeterminate = indeterminate;
  }, [indeterminate, checkboxRef]);
  const Item2 = /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(
    "input",
    __spreadProps(__spreadValues({
      ref: checkboxRef,
      id,
      checked: controlled ? checked : void 0,
      defaultChecked,
      "aria-invalid": invalid,
      "aria-errormessage": invalid ? helpId : void 0,
      value: label2 ? void 0 : value != null ? value : void 0,
      className: inputClassName
    }, props), {
      onChange: (e) => props.onChange(label2 ? e.target.checked : option ? { label: option == null ? void 0 : option.label, value: option == null ? void 0 : option.value } : false)
    })
  ), /* @__PURE__ */ React3.createElement("label", { htmlFor: id, className: labelClassName }, noVisibleLabel ? /* @__PURE__ */ React3.createElement("span", { className: toggle.a11y }, labelContent) : labelContent));
  if (multiple) {
    return /* @__PURE__ */ React3.createElement("div", { className: groupClassName }, Item2);
  }
  return Item2;
}

// packages/_helpers/clickable.tsx
function Clickable(_a) {
  var _b = _a, { children, radio, checkbox, value } = _b, props = __objRest(_b, ["children", "radio", "checkbox", "value"]);
  const id = useId();
  const type = radio ? "radio" : "checkbox";
  return radio || checkbox ? /* @__PURE__ */ React4.createElement(
    Item,
    {
      labelClassName: r(props.labelClassName),
      className: clickable.toggle,
      type,
      controlled: false,
      onChange: props.onClick ? props.onClick : () => void 0,
      value,
      name: `${props.name || id}:toggle`
    },
    children
  ) : React4.createElement(
    props.href ? "a" : "button",
    __spreadProps(__spreadValues({}, props), {
      className: r(clickable.buttonOrLink, props.className),
      type: props.href ? void 0 : props.type || "button"
    }),
    /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement("span", { className: clickable.buttonOrLinkStretch, "aria-hidden": "true" }), children)
  );
}

// packages/_helpers/dead-toggle.tsx
import React5 from "react";
function DeadToggle(props) {
  const type = props.radio ? "radio" : "checkbox";
  return /* @__PURE__ */ React5.createElement("div", { className: r(props.className, deadToggle.wrapper), "aria-hidden": "true" }, /* @__PURE__ */ React5.createElement(
    Item,
    {
      type,
      inputClassName: deadToggle.input,
      labelClassName: r(props.labelClassName, {
        [deadToggle.labelRadio]: props.radio,
        [deadToggle.labelCheckbox]: props.checkbox
      }),
      name: props.name ? `${props.name}:dead-toggle` : "dead-toggle",
      controlled: true,
      onChange: () => void 0,
      value: props.value,
      checked: props.checked
    }
  ));
}

// packages/_helpers/affix.tsx
import React8 from "react";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/close-16.js
import React6 from "react";
import { i18n as i18n2 } from "@lingui/core";
import { i18n } from "@lingui/core";
var __defProp2 = Object.defineProperty;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp2.call(b2, prop))
      __defNormalProp2(a2, prop, b2[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b2)) {
      if (__propIsEnum2.call(b2, prop))
        __defNormalProp2(a2, prop, b2[prop]);
    }
  return a2;
};
var messages = JSON.parse('{"icon.title.close":"Kryss"}');
var messages2 = JSON.parse('{"icon.title.close":"Cross"}');
var messages3 = JSON.parse('{"icon.title.close":"Rasti"}');
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages410 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n(messages2, messages, messages3);
var title = i18n2.t({ message: `Cross`, id: "icon.title.close", comment: "Title for close icon" });
var IconClose16 = (attrs) => React6.createElement("svg", __spreadValues2({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m12.5 3.5-9 9m0-9 9 9"></path>` } }, attrs));
var close_16_default = IconClose16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/search-16.js
import React7 from "react";
import { i18n as i18n22 } from "@lingui/core";
import { i18n as i18n3 } from "@lingui/core";
var __defProp3 = Object.defineProperty;
var __getOwnPropSymbols3 = Object.getOwnPropertySymbols;
var __hasOwnProp3 = Object.prototype.hasOwnProperty;
var __propIsEnum3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp3 = (obj, key, value) => key in obj ? __defProp3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues3 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp3.call(b2, prop))
      __defNormalProp3(a2, prop, b2[prop]);
  if (__getOwnPropSymbols3)
    for (var prop of __getOwnPropSymbols3(b2)) {
      if (__propIsEnum3.call(b2, prop))
        __defNormalProp3(a2, prop, b2[prop]);
    }
  return a2;
};
var messages4 = JSON.parse('{"icon.title.search":"Forst\xF8rrelsesglass"}');
var messages22 = JSON.parse('{"icon.title.search":"Magnifying glass"}');
var messages32 = JSON.parse('{"icon.title.search":"Suurennuslasi"}');
var supportedLocales2 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale2 = "en";
var detectByBrand2 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost2 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale2;
  }
};
var getSupportedLocale2 = (usedLocale) => {
  return supportedLocales2.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost2();
};
function detectLocale2() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand2();
    return getSupportedLocale2(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost2();
    if (!supportedLocales2.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale2(hostLocale);
    }
    return getSupportedLocale2(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale2;
  }
}
var getMessages2 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n2 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale2();
  const messages410 = getMessages2(locale, enMessages, nbMessages, fiMessages);
  i18n3.load(locale, messages410);
  i18n3.activate(locale);
};
activateI18n2(messages22, messages4, messages32);
var title2 = i18n22.t({ message: `Magnifying glass`, id: "icon.title.search", comment: "Title for search icon" });
var IconSearch16 = (attrs) => React7.createElement("svg", __spreadValues3({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title2}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.905 12.102A6.042 6.042 0 1 0 4.18.981a6.042 6.042 0 0 0 4.726 11.121Zm1.909-1.289L15.5 15.5"></path>` } }, attrs));
var search_16_default = IconSearch16;

// packages/_helpers/affix.tsx
function Affix(props) {
  const classBase = props.prefix ? prefix : suffix;
  return React8.createElement(
    props.label ? "div" : "button",
    {
      "aria-label": !props.label ? props["aria-label"] : void 0,
      type: props.search ? "submit" : props.clear ? "reset" : void 0,
      onClick: props.onClick,
      className: r({
        [classBase.wrapper]: true,
        [classBase.wrapperWithLabel]: props.label,
        [classBase.wrapperWithIcon]: !props.label
      })
    },
    /* @__PURE__ */ React8.createElement(React8.Fragment, null, props.clear && /* @__PURE__ */ React8.createElement(close_16_default, null), props.search && /* @__PURE__ */ React8.createElement(search_16_default, null), props.label && /* @__PURE__ */ React8.createElement("span", { className: classBase.label }, props.label))
  );
}

// packages/_helpers/expand-transition.tsx
import React9, { useEffect as useEffect3, useRef as useRef2, useState as useState2 } from "react";

// node_modules/.pnpm/element-collapse@1.1.0/node_modules/element-collapse/index.js
var windowExists = typeof window !== "undefined";
var prefersMotion = true;
if (windowExists) {
  const query = window.matchMedia("(prefers-reduced-motion: reduce)");
  const callback = ({ matches }) => prefersMotion = !matches;
  if (query.addEventListener)
    query.addEventListener("change", callback);
  callback(query);
}
var removeTransition = (el) => {
  el.style.transition = null;
  el.style.backfaceVisibility = null;
  el.style.overflow = null;
};
var addTransition = (el) => {
  const timing = prefersMotion ? "var(--f-expansion-duration, 0.3s)" : "0.01s";
  el.style.transition = `height ${timing}`;
  el.style.backfaceVisibility = "hidden";
  el.style.overflow = "hidden";
};
var getAfterExpandCallback = (el, done) => () => {
  el.style.height = "auto";
  el.style.overflow = null;
  if (done)
    done();
};
var getAfterCollapseCallback = (done) => () => {
  if (done)
    done();
};
var expand = (el, done) => {
  const returnPromise = (() => {
    if (!done)
      return new Promise((r3) => {
        done = r3;
      });
  })();
  const afterExpandCallback = getAfterExpandCallback(el, done);
  removeTransition(el);
  el.style.height = "auto";
  let dest = el.scrollHeight;
  windowExists && requestAnimationFrame(() => {
    el.addEventListener("transitionend", afterExpandCallback, { once: true });
    el.style.height = "0px";
    el.style.transitionTimingFunction = "ease-out";
    addTransition(el);
    requestAnimationFrame(() => el.style.height = dest + "px");
  });
  if (returnPromise)
    return returnPromise;
};
var collapse = (el, done) => {
  const returnPromise = (() => {
    if (!done)
      return new Promise((r3) => {
        done = r3;
      });
  })();
  const afterCollapseCallback = getAfterCollapseCallback(done);
  removeTransition(el);
  let original = el.scrollHeight;
  windowExists && requestAnimationFrame(() => {
    el.addEventListener("transitionend", afterCollapseCallback, { once: true });
    el.style.height = original + "px";
    el.style.transitionTimingFunction = "ease-in";
    addTransition(el);
    requestAnimationFrame(() => el.style.height = "0px");
  });
  if (returnPromise)
    return returnPromise;
};

// packages/_helpers/expand-transition.tsx
function ExpandTransition({ show, children }) {
  const [removeElement, setRemoveElement] = useState2(!show);
  const expandableRef = useRef2(null);
  const isMounted = useRef2(false);
  const initialShow = useRef2(show === true);
  function collapseElement(el) {
    collapse(el, () => setRemoveElement(true));
  }
  function expandElement(el) {
    expand(el);
  }
  if (show && removeElement) {
    setRemoveElement(false);
  }
  useEffect3(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    if (!expandableRef.current)
      return;
    if (show) {
      expandElement(expandableRef.current);
    } else {
      collapseElement(expandableRef.current);
    }
  }, [show]);
  const initialStyle = !initialShow.current ? "overflow-hidden h-0" : void 0;
  return /* @__PURE__ */ React9.createElement("div", { className: initialStyle, ref: expandableRef, "aria-hidden": !show ? true : void 0, "data-testid": "expand-transition" }, removeElement ? null : children);
}

// packages/_helpers/unstyled-heading.tsx
import React10 from "react";
var UnstyledHeading = (_a) => {
  var _b = _a, {
    level,
    children
  } = _b, attrs = __objRest(_b, [
    "level",
    "children"
  ]);
  if (!level) {
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, children);
  }
  const Heading = `h${level}`;
  return /* @__PURE__ */ React10.createElement(
    Heading,
    __spreadValues({
      style: {
        margin: 0,
        fontWeight: "unset",
        fontSize: "unset",
        lineHeight: "unset"
      }
    }, attrs),
    children
  );
};

// packages/alert/src/component.tsx
import React15 from "react";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/error-16.js
import React11 from "react";
import { i18n as i18n23 } from "@lingui/core";
import { i18n as i18n4 } from "@lingui/core";
var __defProp4 = Object.defineProperty;
var __getOwnPropSymbols4 = Object.getOwnPropertySymbols;
var __hasOwnProp4 = Object.prototype.hasOwnProperty;
var __propIsEnum4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp4 = (obj, key, value) => key in obj ? __defProp4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues4 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp4.call(b2, prop))
      __defNormalProp4(a2, prop, b2[prop]);
  if (__getOwnPropSymbols4)
    for (var prop of __getOwnPropSymbols4(b2)) {
      if (__propIsEnum4.call(b2, prop))
        __defNormalProp4(a2, prop, b2[prop]);
    }
  return a2;
};
var messages5 = JSON.parse('{"icon.title.error":"\xC5ttekant med utropstegn"}');
var messages23 = JSON.parse('{"icon.title.error":"Octagon with exclamation point"}');
var messages33 = JSON.parse('{"icon.title.error":"Kahdeksankulmio, jonka sis\xE4ll\xE4 on huutomerkki"}');
var supportedLocales3 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale3 = "en";
var detectByBrand3 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost3 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale3;
  }
};
var getSupportedLocale3 = (usedLocale) => {
  return supportedLocales3.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost3();
};
function detectLocale3() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand3();
    return getSupportedLocale3(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost3();
    if (!supportedLocales3.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale3(hostLocale);
    }
    return getSupportedLocale3(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale3;
  }
}
var getMessages3 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n3 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale3();
  const messages410 = getMessages3(locale, enMessages, nbMessages, fiMessages);
  i18n4.load(locale, messages410);
  i18n4.activate(locale);
};
activateI18n3(messages23, messages5, messages33);
var title3 = i18n23.t({ message: `Octagon with exclamation point`, id: "icon.title.error", comment: "Title for error icon" });
var IconError16 = (attrs) => React11.createElement("svg", __spreadValues4({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title3}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 11.107 4.748 15.5h6.503l4.248-4.393V4.893L11.252.5H4.748L.5 4.893z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 11.398a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8 8.5V3"></path>` } }, attrs));
var error_16_default = IconError16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/info-16.js
import React12 from "react";
import { i18n as i18n24 } from "@lingui/core";
import { i18n as i18n5 } from "@lingui/core";
var __defProp5 = Object.defineProperty;
var __getOwnPropSymbols5 = Object.getOwnPropertySymbols;
var __hasOwnProp5 = Object.prototype.hasOwnProperty;
var __propIsEnum5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp5 = (obj, key, value) => key in obj ? __defProp5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues5 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp5.call(b2, prop))
      __defNormalProp5(a2, prop, b2[prop]);
  if (__getOwnPropSymbols5)
    for (var prop of __getOwnPropSymbols5(b2)) {
      if (__propIsEnum5.call(b2, prop))
        __defNormalProp5(a2, prop, b2[prop]);
    }
  return a2;
};
var messages6 = JSON.parse('{"icon.title.info":"Informasjonssirkel"}');
var messages24 = JSON.parse('{"icon.title.info":"Information circle"}');
var messages34 = JSON.parse('{"icon.title.info":"Ympyr\xE4, jonka sis\xE4ll\xE4 on i-kirjain"}');
var supportedLocales4 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale4 = "en";
var detectByBrand4 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost4 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale4;
  }
};
var getSupportedLocale4 = (usedLocale) => {
  return supportedLocales4.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost4();
};
function detectLocale4() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand4();
    return getSupportedLocale4(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost4();
    if (!supportedLocales4.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale4(hostLocale);
    }
    return getSupportedLocale4(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale4;
  }
}
var getMessages4 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n4 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale4();
  const messages410 = getMessages4(locale, enMessages, nbMessages, fiMessages);
  i18n5.load(locale, messages410);
  i18n5.activate(locale);
};
activateI18n4(messages24, messages6, messages34);
var title4 = i18n24.t({ message: `Information circle`, id: "icon.title.info", comment: "Title for info icon" });
var IconInfo16 = (attrs) => React12.createElement("svg", __spreadValues5({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title4}</title><path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" d="M8 6.5v5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 4v.5"></path><path stroke="currentColor" stroke-miterlimit="10" d="M8 .5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z"></path>` } }, attrs));
var info_16_default = IconInfo16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/success-16.js
import React13 from "react";
import { i18n as i18n25 } from "@lingui/core";
import { i18n as i18n6 } from "@lingui/core";
var __defProp6 = Object.defineProperty;
var __getOwnPropSymbols6 = Object.getOwnPropertySymbols;
var __hasOwnProp6 = Object.prototype.hasOwnProperty;
var __propIsEnum6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp6 = (obj, key, value) => key in obj ? __defProp6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues6 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp6.call(b2, prop))
      __defNormalProp6(a2, prop, b2[prop]);
  if (__getOwnPropSymbols6)
    for (var prop of __getOwnPropSymbols6(b2)) {
      if (__propIsEnum6.call(b2, prop))
        __defNormalProp6(a2, prop, b2[prop]);
    }
  return a2;
};
var messages7 = JSON.parse('{"icon.title.success":"Sirkel med sjekkmerke"}');
var messages25 = JSON.parse('{"icon.title.success":"Circle with checkmark"}');
var messages35 = JSON.parse('{"icon.title.success":"Ympyr\xE4, jonka sis\xE4ll\xE4 on valintamerkki"}');
var supportedLocales5 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale5 = "en";
var detectByBrand5 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost5 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale5;
  }
};
var getSupportedLocale5 = (usedLocale) => {
  return supportedLocales5.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost5();
};
function detectLocale5() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand5();
    return getSupportedLocale5(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost5();
    if (!supportedLocales5.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale5(hostLocale);
    }
    return getSupportedLocale5(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale5;
  }
}
var getMessages5 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n5 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale5();
  const messages410 = getMessages5(locale, enMessages, nbMessages, fiMessages);
  i18n6.load(locale, messages410);
  i18n6.activate(locale);
};
activateI18n5(messages25, messages7, messages35);
var title5 = i18n25.t({ message: `Circle with checkmark`, id: "icon.title.success", comment: "Title for success icon" });
var IconSuccess16 = (attrs) => React13.createElement("svg", __spreadValues6({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title5}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m4 8.815 1.633 2.318a.7.7 0 0 0 1.138.034l5.228-6.615"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 7.999a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0"></path>` } }, attrs));
var success_16_default = IconSuccess16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/warning-16.js
import React14 from "react";
import { i18n as i18n26 } from "@lingui/core";
import { i18n as i18n7 } from "@lingui/core";
var __defProp7 = Object.defineProperty;
var __getOwnPropSymbols7 = Object.getOwnPropertySymbols;
var __hasOwnProp7 = Object.prototype.hasOwnProperty;
var __propIsEnum7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp7 = (obj, key, value) => key in obj ? __defProp7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues7 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp7.call(b2, prop))
      __defNormalProp7(a2, prop, b2[prop]);
  if (__getOwnPropSymbols7)
    for (var prop of __getOwnPropSymbols7(b2)) {
      if (__propIsEnum7.call(b2, prop))
        __defNormalProp7(a2, prop, b2[prop]);
    }
  return a2;
};
var messages8 = JSON.parse('{"icon.title.warning":"Varseltrekant med utropstegn"}');
var messages26 = JSON.parse('{"icon.title.warning":"Warning triangle with exclamation point"}');
var messages36 = JSON.parse('{"icon.title.warning":"Varoituskolmio, jonka sis\xE4ll\xE4 on huutomerkki"}');
var supportedLocales6 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale6 = "en";
var detectByBrand6 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost6 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale6;
  }
};
var getSupportedLocale6 = (usedLocale) => {
  return supportedLocales6.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost6();
};
function detectLocale6() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand6();
    return getSupportedLocale6(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost6();
    if (!supportedLocales6.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale6(hostLocale);
    }
    return getSupportedLocale6(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale6;
  }
}
var getMessages6 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n6 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale6();
  const messages410 = getMessages6(locale, enMessages, nbMessages, fiMessages);
  i18n7.load(locale, messages410);
  i18n7.activate(locale);
};
activateI18n6(messages26, messages8, messages36);
var title6 = i18n26.t({ message: `Warning triangle with exclamation point`, id: "icon.title.warning", comment: "Title for warning icon" });
var IconWarning16 = (attrs) => React14.createElement("svg", __spreadValues7({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title6}</title><path stroke="currentColor" d="m.712 14.07 6.25-12.994a1 1 0 0 1 1.792-.022l6.635 12.995a1 1 0 0 1-.89 1.455H1.613a1 1 0 0 1-.902-1.434Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 6v4.992M8 13v.333"></path>` } }, attrs));
var warning_16_default = IconWarning16;

// packages/alert/src/component.tsx
function Alert(_a) {
  var _b = _a, { show, type, role = "alert", children } = _b, props = __objRest(_b, ["show", "type", "role", "children"]);
  const variantClasses2 = alert[type];
  const iconVariantClasses = alert[`${type}Icon`];
  return /* @__PURE__ */ React15.createElement(ExpandTransition, { show }, /* @__PURE__ */ React15.createElement("div", { role, className: r(props.className, `${alert.alert} ${variantClasses2}`), style: props.style }, /* @__PURE__ */ React15.createElement("div", { className: `${alert.icon} ${iconVariantClasses}` }, iconMap[type]), /* @__PURE__ */ React15.createElement("div", { className: alert.textWrapper }, children)));
}
var iconMap = {
  negative: /* @__PURE__ */ React15.createElement(error_16_default, null),
  positive: /* @__PURE__ */ React15.createElement(success_16_default, null),
  warning: /* @__PURE__ */ React15.createElement(warning_16_default, null),
  info: /* @__PURE__ */ React15.createElement(info_16_default, null)
};

// packages/attention/src/component.tsx
import React16, { forwardRef, useEffect as useEffect5, useMemo, useRef as useRef3, useState as useState3 } from "react";
import { i18n as i18n10 } from "@lingui/core";

// node_modules/.pnpm/@floating-ui+utils@0.2.2/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sides = ["top", "right", "bottom", "left"];
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side2, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side2) {
    case "top":
    case "bottom":
      if (rtl)
        return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side2) => side2 + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side2) => oppositeSideMap[side2]);
}
function expandPaddingObject(padding) {
  return __spreadValues({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y: y2,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y2,
    left: x,
    right: x + width,
    bottom: y2 + height,
    x,
    y: y2
  };
}

// node_modules/.pnpm/@floating-ui+core@1.6.2/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref2, placement, rtl) {
  let {
    reference,
    floating
  } = _ref2;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side2 = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side2) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
var computePosition = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y2 = nextY != null ? nextY : y2;
    middlewareData = __spreadProps(__spreadValues({}, middlewareData), {
      [name]: __spreadValues(__spreadValues({}, middlewareData[name]), data)
    });
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
var arrow = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y: y2
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset3 = clamp(min$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset3 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: __spreadValues({
        [axis]: offset3,
        centerOffset: center - offset3 - alignmentOffset
      }, shouldAddOffset && {
        alignmentOffset
      }),
      reset: shouldAddOffset
    };
  }
});
var flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const _a = evaluate(options, state), {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true
      } = _a, detectOverflowOptions = __objRest(_a, [
        "mainAxis",
        "crossAxis",
        "fallbackPlacements",
        "fallbackStrategy",
        "fallbackAxisSideDirection",
        "flipAlignment"
      ]);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side2 = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side2]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side3) => side3 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$map$so;
              const placement2 = (_overflowsData$map$so = overflowsData.map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side2) => overflow[side2] >= 0);
}
var hide = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const _a = evaluate(options, state), {
        strategy = "referenceHidden"
      } = _a, detectOverflowOptions = __objRest(_a, [
        "strategy"
      ]);
      switch (strategy) {
        case "referenceHidden": {
          const overflow = await detectOverflow(state, __spreadProps(__spreadValues({}, detectOverflowOptions), {
            elementContext: "reference"
          }));
          const offsets = getSideOffsets(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped(offsets)
            }
          };
        }
        case "escaped": {
          const overflow = await detectOverflow(state, __spreadProps(__spreadValues({}, detectOverflowOptions), {
            altBoundary: true
          }));
          const offsets = getSideOffsets(overflow, rects.floating);
          return {
            data: {
              escapedOffsets: offsets,
              escaped: isAnySideFullyClipped(offsets)
            }
          };
        }
        default: {
          return {};
        }
      }
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side2 = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side2) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : __spreadValues({
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null
  }, rawValue);
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
var offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y2 + diffCoords.y,
        data: __spreadProps(__spreadValues({}, diffCoords), {
          placement
        })
      };
    }
  };
};

// node_modules/.pnpm/@floating-ui+utils@0.2.2/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function getNodeName(node2) {
  if (isNode(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node2) {
  var _ref2;
  return (_ref2 = (isNode(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref2.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle2(element);
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports)
    return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node2) {
  return ["html", "body", "#document"].includes(getNodeName(node2));
}
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot(node2) && node2.host || // Fallback.
    getDocumentElement(node2)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node2) {
  const parentNode = getParentNode(node2);
  if (isLastTraversableNode(parentNode)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node2, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

// node_modules/.pnpm/@floating-ui+dom@1.6.5/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css = getComputedStyle2(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y2 = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x,
    y: y2
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y2 += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y: y2
  });
}
var topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element) {
  return topLayerSelectors.some((selector) => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref2) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref2;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle2(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y: y2
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y: y2
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y2 = top * scale.y;
  return {
    width,
    height,
    x,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = __spreadProps(__spreadValues({}, clippingAncestor), {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    });
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle2(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref2) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref2;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y2 = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle2(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle2(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle2(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, __spreadProps(__spreadValues({}, options), {
        // Handle <iframe>s
        root: root.ownerDocument
      }));
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref2) => {
      let [firstEntry] = _ref2;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var offset2 = offset;
var flip2 = flip;
var hide2 = hide;
var arrow2 = arrow;
var computePosition2 = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = __spreadValues({
    platform
  }, options);
  const platformWithCache = __spreadProps(__spreadValues({}, mergedOptions.platform), {
    _c: cache
  });
  return computePosition(reference, floating, __spreadProps(__spreadValues({}, mergedOptions), {
    platform: platformWithCache
  }));
};

// node_modules/.pnpm/@warp-ds+core@1.1.3_@floating-ui+dom@1.6.5/node_modules/@warp-ds/core/dist/attention/utils/helpers.js
var TOP_START = "top-start";
var TOP = "top";
var TOP_END = "top-end";
var RIGHT_START = "right-start";
var RIGHT = "right";
var RIGHT_END = "right-end";
var BOTTOM_START = "bottom-start";
var BOTTOM = "bottom";
var BOTTOM_END = "bottom-end";
var LEFT_START = "left-start";
var LEFT = "left";
var LEFT_END = "left-end";
var opposites = {
  [TOP_START]: BOTTOM_START,
  [TOP]: BOTTOM,
  [TOP_END]: BOTTOM_END,
  [BOTTOM_START]: TOP_START,
  [BOTTOM]: TOP,
  [BOTTOM_END]: TOP_END,
  [LEFT_START]: RIGHT_START,
  [LEFT]: RIGHT,
  [LEFT_END]: RIGHT_END,
  [RIGHT_START]: LEFT_START,
  [RIGHT]: LEFT,
  [RIGHT_END]: LEFT_END
};
var rotation = {
  [LEFT_START]: -45,
  [LEFT]: -45,
  [LEFT_END]: -45,
  [TOP_START]: 45,
  [TOP]: 45,
  [TOP_END]: 45,
  [RIGHT_START]: 135,
  [RIGHT]: 135,
  [RIGHT_END]: 135,
  [BOTTOM_START]: -135,
  [BOTTOM]: -135,
  [BOTTOM_END]: -135
};
var arrowDirectionClassname = (dir) => {
  let direction;
  if (/-/.test(dir)) {
    direction = dir.split("-").map((d2) => d2.charAt(0).toUpperCase() + d2.slice(1)).join("");
  } else {
    direction = dir.charAt(0).toUpperCase() + dir.slice(1);
  }
  return direction;
};
var side = (dir) => dir.split("-")[0];
var staticSide = (dir) => opposites[side(dir)];
var arrowDirection = (dir) => opposites[dir];
var arrowRotation = (dir) => rotation[arrowDirection(dir)];
var applyArrowStyles = (arrowEl, arrowRotation2, dir) => {
  Object.assign(arrowEl == null ? void 0 : arrowEl.style, {
    borderTopLeftRadius: "4px",
    zIndex: 1,
    // border alignment is off by a fraction of a pixel, this fixes it
    [`margin${arrowDirectionClassname(staticSide(dir))}`]: "-0.5px",
    transform: `rotate(${arrowRotation2}deg)`
  });
};
async function useRecompute(state) {
  var _a, _b, _c;
  if (!(state == null ? void 0 : state.isShowing))
    return;
  if (state == null ? void 0 : state.waitForDOM) {
    await (state == null ? void 0 : state.waitForDOM());
  }
  if (!(state == null ? void 0 : state.targetEl) || !(state == null ? void 0 : state.attentionEl))
    return;
  let targetEl = state == null ? void 0 : state.targetEl;
  const attentionEl = state.attentionEl;
  computePosition2(targetEl, attentionEl, {
    placement: (_a = state == null ? void 0 : state.directionName) != null ? _a : BOTTOM,
    middleware: [
      offset2({ mainAxis: (_b = state == null ? void 0 : state.distance) != null ? _b : 8, crossAxis: (_c = state == null ? void 0 : state.skidding) != null ? _c : 0 }),
      (state == null ? void 0 : state.flip) && flip2({
        // when flip is set to true it will move the attentionEl's placement to its opposite side or to the preferred placements if fallbackPlacements has a value
        crossAxis: state == null ? void 0 : state.crossAxis,
        fallbackPlacements: state == null ? void 0 : state.fallbackPlacements
      }),
      !(state == null ? void 0 : state.noArrow) && (state == null ? void 0 : state.arrowEl) && arrow2({ element: state == null ? void 0 : state.arrowEl }),
      hide2()
      // will hide the attentionEl when it appears detached from the targetEl. Can be called multiple times in the middleware-array if you want to use several strategies. Default strategy is 'referenceHidden'.
    ]
  }).then(({ x, y: y2, middlewareData, placement }) => {
    state.actualDirection = placement;
    if (!(state == null ? void 0 : state.isCallout)) {
      Object.assign(attentionEl.style, {
        left: `${x}px`,
        top: `${y2}px`
      });
    }
    if ((middlewareData == null ? void 0 : middlewareData.hide) && !(state == null ? void 0 : state.isCallout)) {
      const { referenceHidden } = middlewareData.hide;
      Object.assign(attentionEl.style, {
        visibility: referenceHidden ? "hidden" : ""
      });
    }
    const isRtl = window.getComputedStyle(attentionEl).direction === "rtl";
    const arrowPlacement = arrowDirection(placement).split("-")[1];
    if ((middlewareData == null ? void 0 : middlewareData.arrow) && (state == null ? void 0 : state.arrowEl)) {
      const arrowEl = state == null ? void 0 : state.arrowEl;
      const { x: arrowX, y: arrowY } = middlewareData.arrow;
      let top = "";
      let right = "";
      let bottom = "";
      let left = "";
      if (arrowPlacement === "start") {
        const value = typeof arrowX === "number" ? `calc(24px - ${arrowEl.offsetWidth / 2}px)` : "";
        top = typeof arrowY === "number" ? `calc(24px -  ${arrowEl.offsetWidth / 2}px)` : "";
        right = isRtl ? value : "";
        left = isRtl ? "" : value;
      } else if (arrowPlacement === "end") {
        const value = typeof arrowX === "number" ? `calc(24px - ${arrowEl.offsetWidth / 2}px)` : "";
        right = isRtl ? "" : value;
        left = isRtl ? value : "";
        bottom = typeof arrowY === "number" ? `calc(24px - ${arrowEl.offsetWidth / 2}px)` : "";
      } else {
        left = typeof arrowX === "number" ? `${arrowX}px` : "";
        top = typeof arrowY === "number" ? `${arrowY}px` : "";
      }
      Object.assign(arrowEl.style, {
        top,
        right,
        bottom,
        left
      });
      applyArrowStyles(arrowEl, arrowRotation(placement), placement);
    }
  });
  return state;
}
var autoUpdatePosition = (state) => {
  if (!(state == null ? void 0 : state.targetEl) || !(state == null ? void 0 : state.attentionEl) || (state == null ? void 0 : state.isCallout))
    return;
  return autoUpdate(state == null ? void 0 : state.targetEl, state == null ? void 0 : state.attentionEl, () => {
    useRecompute(state);
  });
};

// packages/_helpers/attention.tsx
import { useCallback as useCallback2, useEffect as useEffect4 } from "react";
import { i18n as i18n8 } from "@lingui/core";
var getVariant = (variantProps, variantClasses2) => Object.keys(variantClasses2).find((b2) => !!variantProps[b2]) || "";
var pointingAtDirection = (actualDirection) => {
  switch (opposites[actualDirection]) {
    case "top-start":
    case "top":
    case "top-end":
      return i18n8._({
        id: "attention.aria.pointingUp",
        message: "pointing up",
        comment: "Default screenreader message for top direction in the attention component"
      });
    case "right-start":
    case "right":
    case "right-end":
      return i18n8._({
        id: "attention.aria.pointingRight",
        message: "pointing right",
        comment: "Default screenreader message for right direction in the attention component"
      });
    case "bottom-start":
    case "bottom":
    case "bottom-end":
      return i18n8._({
        id: "attention.aria.pointingDown",
        message: "pointing down",
        comment: "Default screenreader message for bottom direction in the attention component"
      });
    case "left-start":
    case "left":
    case "left-end":
      return i18n8._({
        id: "attention.aria.pointingLeft",
        message: "pointing left",
        comment: "Default screenreader message for left direction in the attention component"
      });
    default:
      return "";
  }
};
var activeAttentionType = (props) => {
  switch (true) {
    case props.tooltip:
      return i18n8._({
        id: "attention.aria.tooltip",
        message: "tooltip",
        comment: "Default screenreader message for tooltip in the attention component"
      });
    case props.callout:
      return i18n8._({
        id: "attention.aria.callout",
        message: "callout speech bubble",
        comment: "Default screenreader message for callout speech bubble in the attention component"
      });
    case props.popover:
      return i18n8._({
        id: "attention.aria.popover",
        message: "popover speech bubble",
        comment: "Default screenreader message for popover speech bubble in the attention component"
      });
    case props.highlight:
      return i18n8._({
        id: "attention.aria.highlight",
        message: "highlighted speech bubble",
        comment: "Default screenreader message for highlighted speech bubble in the attention component"
      });
    default:
      return "";
  }
};
var useAutoUpdatePosition = (targetEl, isShowing, attentionEl, attentionState) => {
  const memoizedAutoUpdatePosition = useCallback2(() => autoUpdatePosition(attentionState), [attentionState]);
  useEffect4(() => {
    if (isShowing && (targetEl == null ? void 0 : targetEl.current) && (attentionEl == null ? void 0 : attentionEl.current)) {
      const cleanup = memoizedAutoUpdatePosition();
      return cleanup;
    }
    return () => {
    };
  }, [targetEl, isShowing, attentionEl, memoizedAutoUpdatePosition]);
};

// packages/i18n.ts
import { i18n as i18n9 } from "@lingui/core";
var supportedLocales7 = ["en", "nb", "fi"];
var defaultLocale7 = "en";
var getSupportedLocale7 = (usedLocale) => supportedLocales7.find((locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)) || defaultLocale7;
function detectLocale7() {
  if (typeof window === "undefined") {
    const serverLocale = process.env.NMP_LANGUAGE || Intl.DateTimeFormat().resolvedOptions().locale;
    return getSupportedLocale7(serverLocale);
  }
  try {
    const htmlLocale = document.documentElement.lang;
    return getSupportedLocale7(htmlLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale7;
  }
}
var getMessages7 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n7 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale7();
  const messages65 = getMessages7(locale, enMessages, nbMessages, fiMessages);
  i18n9.load(locale, messages65);
  i18n9.activate(locale);
};

// packages/attention/src/locales/en/messages.mjs
var messages9 = JSON.parse('{"attention.aria.callout":"A green speech bubble introducing something new","attention.aria.close":"Close","attention.aria.highlight":"An attention speech bubble with important information","attention.aria.pointingDown":"pointing down","attention.aria.pointingLeft":"pointing left","attention.aria.pointingRight":"pointing right","attention.aria.pointingUp":"pointing up","attention.aria.popover":"A white speech bubble providing additional information","attention.aria.tooltip":"A black speech bubble providing complementary information"}');

// packages/attention/src/locales/fi/messages.mjs
var messages10 = JSON.parse('{"attention.aria.callout":"Vihre\xE4 puhekupla, joka esittelee jotain uutta","attention.aria.close":"Sulje","attention.aria.highlight":"Puhekupla, joka sis\xE4lt\xE4\xE4 t\xE4rke\xE4\xE4 tietoa","attention.aria.pointingDown":"osoittaa alas","attention.aria.pointingLeft":"osoittaa vasemmalle","attention.aria.pointingRight":"osoittaa oikealle","attention.aria.pointingUp":"osoittaa yl\xF6s","attention.aria.popover":"Valkoinen puhekupla, joka tarjoaa lis\xE4tietoa","attention.aria.tooltip":"Musta puhekupla, joka tarjoaa t\xE4ydent\xE4v\xE4\xE4 tietoa"}');

// packages/attention/src/locales/nb/messages.mjs
var messages11 = JSON.parse('{"attention.aria.callout":"Gr\xF8nn taleboble som introduserer noe nytt","attention.aria.close":"Lukk","attention.aria.highlight":"En uthevet taleboble med viktig informasjon","attention.aria.pointingDown":"peker ned","attention.aria.pointingLeft":"peker til venstre","attention.aria.pointingRight":"peker til h\xF8yre","attention.aria.pointingUp":"peker opp","attention.aria.popover":"En hvit taleboble som gir tilleggsinformasjon","attention.aria.tooltip":"En svart taleboble som forklarer konteksten"}');

// packages/attention/src/component.tsx
var variantClasses = {
  callout: {
    wrapper: attention.callout,
    arrow: attention.arrowCallout
  },
  highlight: {
    wrapper: attention.highlight,
    arrow: attention.arrowHighlight
  },
  tooltip: {
    wrapper: attention.tooltip,
    arrow: attention.arrowTooltip
  },
  popover: {
    wrapper: attention.popover,
    arrow: attention.arrowPopover
  }
};
function Attention(props) {
  let _a = props, {
    noArrow,
    isShowing,
    children,
    role,
    "aria-label": ariaLabel,
    placement = "bottom",
    targetEl: initialTargetEl,
    className,
    canClose,
    onDismiss,
    distance = 8,
    skidding = 0,
    flip: flip3 = false,
    crossAxis = false,
    fallbackPlacements
  } = _a, rest = __objRest(_a, [
    "noArrow",
    "isShowing",
    "children",
    "role",
    "aria-label",
    "placement",
    "targetEl",
    "className",
    "canClose",
    "onDismiss",
    "distance",
    "skidding",
    "flip",
    "crossAxis",
    "fallbackPlacements"
  ]);
  activateI18n7(messages9, messages11, messages10);
  const wrapperClasses = r(attention.base, variantClasses[getVariant(rest, variantClasses)].wrapper);
  const [actualDirection, setActualDirection] = useState3(placement);
  const [isVisible, setIsVisible] = useState3(false);
  const isMounted = useRef3(true);
  const attentionEl = useRef3(null);
  const arrowEl = useRef3(null);
  const targetElRef = useRef3((initialTargetEl == null ? void 0 : initialTargetEl.current) || null);
  const attentionState = useMemo(
    () => ({
      get isShowing() {
        return isShowing;
      },
      get isCallout() {
        return rest.callout;
      },
      get actualDirection() {
        return actualDirection;
      },
      set actualDirection(v) {
        setActualDirection(v);
      },
      get directionName() {
        return placement;
      },
      get arrowEl() {
        return arrowEl.current;
      },
      get attentionEl() {
        return attentionEl.current;
      },
      set attentionEl(v) {
        attentionEl.current = v;
      },
      get targetEl() {
        return targetElRef == null ? void 0 : targetElRef.current;
      },
      get noArrow() {
        return props.noArrow;
      },
      get distance() {
        return distance;
      },
      get skidding() {
        return skidding;
      },
      get flip() {
        return flip3;
      },
      get crossAxis() {
        return crossAxis;
      },
      get fallbackPlacements() {
        return fallbackPlacements;
      }
    }),
    [
      isShowing,
      rest.callout,
      actualDirection,
      placement,
      arrowEl,
      attentionEl,
      targetElRef,
      props.noArrow,
      distance,
      skidding,
      flip3,
      crossAxis,
      fallbackPlacements
    ]
  );
  const defaultAriaLabel = () => `${activeAttentionType(props)} ${!props.noArrow ? pointingAtDirection(actualDirection) : ""}`;
  useEffect5(() => {
    if (props.callout && initialTargetEl === void 0) {
      targetElRef.current = document == null ? void 0 : document.createElement("div");
    } else {
      targetElRef.current = (initialTargetEl == null ? void 0 : initialTargetEl.current) || null;
    }
  }, [props.callout, initialTargetEl]);
  useEffect5(() => {
    useRecompute(attentionState);
  }, [attentionState]);
  useEffect5(() => {
    if (isMounted.current) {
      isMounted.current = false;
      if (isShowing || props.callout) {
        setIsVisible(isShowing);
      }
    } else {
      setIsVisible(isShowing);
    }
  }, [isShowing, props.callout]);
  useAutoUpdatePosition(targetElRef, isShowing, attentionEl, attentionState);
  return !props.callout && initialTargetEl === void 0 ? null : /* @__PURE__ */ React16.createElement(
    "div",
    {
      "data-testid": "attention-el",
      className: r(
        {
          [attention.notCallout]: !props.callout,
          invisible: !isVisible && !props.callout,
          hidden: !isVisible && !props.tooltip
        },
        className
      ),
      ref: attentionEl
    },
    /* @__PURE__ */ React16.createElement(
      "div",
      {
        role: props.role === "" ? void 0 : props.tooltip ? "tooltip" : "img",
        "aria-label": ariaLabel === "" ? void 0 : ariaLabel != null ? ariaLabel : defaultAriaLabel(),
        className: wrapperClasses,
        id: props.id
      },
      !props.noArrow && /* @__PURE__ */ React16.createElement(Arrow, __spreadProps(__spreadValues({}, props), { ref: arrowEl, direction: actualDirection })),
      /* @__PURE__ */ React16.createElement("div", { className: attention.content }, props.children),
      canClose && /* @__PURE__ */ React16.createElement(
        "button",
        {
          type: "button",
          "aria-label": i18n10._(
            /*i18n*/
            {
              id: "attention.aria.close",
              message: "Close",
              comment: "Aria label for the close button in attention"
            }
          ),
          onClick: onDismiss,
          onKeyDown: (event) => {
            if (!props.onDismiss)
              return;
            if (event.key === "Escape") {
              props.onDismiss();
            }
          },
          className: attention.closeBtn
        },
        /* @__PURE__ */ React16.createElement(close_16_default, null)
      )
    )
  );
}
var Arrow = forwardRef((_a, ref) => {
  var _b = _a, { direction } = _b, rest = __objRest(_b, ["direction"]);
  const arrowDirection2 = opposites[direction];
  const arrowClasses = r(
    attention.arrowBase,
    attention[`arrowDirection${arrowDirectionClassname(arrowDirection2)}`],
    variantClasses[getVariant(rest, variantClasses)].arrow
  );
  return /* @__PURE__ */ React16.createElement("div", { "data-testid": "attention-arrow-el", ref, className: arrowClasses });
});

// packages/badge/src/component.tsx
import React17 from "react";
function Badge(props) {
  const _a = props, { children, as = "div", variant = "neutral", position } = _a, rest = __objRest(_a, ["children", "as", "variant", "position"]);
  return React17.createElement(
    as,
    __spreadProps(__spreadValues({}, rest), {
      className: r(
        badge.base,
        badge[variant],
        {
          [badge.positionBase]: !!position,
          [badge.positionTL]: position === "top-left",
          [badge.positionTR]: position === "top-right",
          [badge.positionBR]: position === "bottom-right",
          [badge.positionBL]: position === "bottom-left"
        },
        props.className
      )
    }),
    children
  );
}

// packages/box/src/component.tsx
import React18 from "react";
function Box(props) {
  const _a = props, { children, as = "div", bleed, clickable: clickable2, neutral, bordered, info, role } = _a, rest = __objRest(_a, ["children", "as", "bleed", "clickable", "neutral", "bordered", "info", "role"]);
  return React18.createElement(
    as,
    __spreadProps(__spreadValues({}, rest), {
      role: role != null ? role : "region",
      className: r(
        box.box,
        {
          [box.bleed]: bleed,
          [box.info]: info,
          [box.neutral]: neutral,
          [box.bordered]: bordered,
          [box.infoClickable]: clickable2 && info,
          [box.neutralClickable]: clickable2 && neutral,
          [box.borderedClickable]: clickable2 && bordered
        },
        props.className
      )
    }),
    children
  );
}

// packages/breadcrumbs/src/component.tsx
import * as React19 from "react";
import { i18n as i18n11 } from "@lingui/core";

// node_modules/.pnpm/@warp-ds+core@1.1.3_@floating-ui+dom@1.6.5/node_modules/@warp-ds/core/dist/breadcrumbs/index.js
function interleave(array, separator) {
  return array.flatMap((el) => [el, separator]).slice(0, -1);
}

// packages/breadcrumbs/src/locales/en/messages.mjs
var messages12 = JSON.parse('{"breadcrumbs.ariaLabel":"You are here"}');

// packages/breadcrumbs/src/locales/fi/messages.mjs
var messages13 = JSON.parse('{"breadcrumbs.ariaLabel":"Olet t\xE4ss\xE4"}');

// packages/breadcrumbs/src/locales/nb/messages.mjs
var messages14 = JSON.parse('{"breadcrumbs.ariaLabel":"Her er du"}');

// packages/breadcrumbs/src/component.tsx
var Breadcrumbs = (props) => {
  const _a = props, { children, className } = _a, rest = __objRest(_a, ["children", "className"]);
  activateI18n7(messages12, messages14, messages13);
  const ariaLabel = props["aria-label"] || i18n11._(
    /*i18n*/
    {
      id: "breadcrumbs.ariaLabel",
      message: "You are here",
      comment: "Default screenreader message for the breadcrumb component"
    }
  );
  const flattenedChildren = children.flat(Infinity);
  const styledChildren = flattenedChildren.map((child, index2) => {
    if (React19.isValidElement(child)) {
      const ccClasses = child.type === "a" ? breadcrumbs.link : breadcrumbs.text;
      const newClasses = child.props.className ? `${child.props.className} ${ccClasses}` : ccClasses;
      const styledChild = React19.cloneElement(child, { className: newClasses });
      return styledChild;
    }
    const isLastEl = index2 === flattenedChildren.length - 1;
    return /* @__PURE__ */ React19.createElement("span", { className: breadcrumbs.text, "aria-current": isLastEl ? "page" : void 0 }, child);
  });
  return /* @__PURE__ */ React19.createElement("nav", __spreadValues({ className, "aria-labelledby": "breadCrumbLabel" }, rest), /* @__PURE__ */ React19.createElement("h2", { id: "breadCrumbLabel", className: breadcrumbs.a11y }, ariaLabel), /* @__PURE__ */ React19.createElement("div", { className: breadcrumbs.wrapper }, interleave(styledChildren, /* @__PURE__ */ React19.createElement("span", { className: breadcrumbs.separator }, "/")).map((element, index2) => /* @__PURE__ */ React19.createElement(React19.Fragment, { key: index2 }, element))));
};

// packages/button/src/component.tsx
import React20, { forwardRef as forwardRef2 } from "react";
import { i18n as i18n12 } from "@lingui/core";

// packages/button/src/locales/en/messages.mjs
var messages15 = JSON.parse('{"button.aria.loading":"Loading..."}');

// packages/button/src/locales/fi/messages.mjs
var messages16 = JSON.parse('{"button.aria.loading":"Ladataan\u2026"}');

// packages/button/src/locales/nb/messages.mjs
var messages17 = JSON.parse('{"button.aria.loading":"Laster..."}');

// packages/button/src/component.tsx
var buttonVariants2 = ["primary", "secondary", "negative", "utility", "pill", "link"];
var Button = forwardRef2((props, ref) => {
  const _a = props, { primary, secondary, negative, utility, quiet, small, link, pill: pill2, loading, fullWidth } = _a, rest = __objRest(_a, ["primary", "secondary", "negative", "utility", "quiet", "small", "link", "pill", "loading", "fullWidth"]);
  const defaultVariant = secondary || !buttonVariants2.find((b2) => !!props[b2]);
  const classes = r(props.className, {
    [button.secondary]: defaultVariant && !small && !quiet && !loading && !props.disabled,
    [button.secondaryDisabled]: defaultVariant && !small && !quiet && !loading && props.disabled,
    [button.secondarySmall]: defaultVariant && small && !quiet && !loading && !props.disabled,
    [button.secondarySmallDisabled]: defaultVariant && small && !quiet && !loading && props.disabled,
    [button.secondarySmallLoading]: defaultVariant && small && !quiet && loading,
    [button.secondarySmallQuiet]: defaultVariant && small && quiet && !loading && !props.disabled,
    [button.secondarySmallQuietDisabled]: defaultVariant && small && quiet && !loading && props.disabled,
    [button.secondarySmallQuietLoading]: defaultVariant && small && quiet && loading,
    [button.secondaryQuiet]: defaultVariant && !small && quiet && !loading && !props.disabled,
    [button.secondaryQuietDisabled]: defaultVariant && !small && quiet && !loading && props.disabled,
    [button.secondaryQuietLoading]: defaultVariant && !small && quiet && loading,
    [button.secondaryLoading]: defaultVariant && !small && !quiet && loading,
    [button.primary]: primary && !small && !quiet && !loading && !props.disabled,
    [button.primaryDisabled]: primary && !small && !quiet && !loading && props.disabled,
    [button.primarySmall]: primary && small && !quiet && !loading && !props.disabled,
    [button.primarySmallDisabled]: primary && small && !quiet && !loading && props.disabled,
    [button.primarySmallQuiet]: primary && small && quiet && !loading && !props.disabled,
    [button.primarySmallQuietDisabled]: primary && small && quiet && !loading && props.disabled,
    [button.primarySmallLoading]: primary && small && !quiet && loading,
    [button.primarySmallQuietLoading]: primary && small && quiet && loading,
    [button.primaryQuiet]: primary && !small && quiet && !loading && !props.disabled,
    [button.primaryQuietDisabled]: primary && !small && quiet && !loading && props.disabled,
    [button.primaryQuietLoading]: primary && !small && quiet && loading,
    [button.primaryLoading]: primary && !small && !quiet && loading,
    [button.utility]: utility && !small && !quiet && !loading && !props.disabled,
    [button.utilityDisabled]: utility && !small && !quiet && !loading && props.disabled,
    [button.utilitySmall]: utility && small && !quiet && !loading && !props.disabled,
    [button.utilitySmallDisabled]: utility && small && !quiet && !loading && props.disabled,
    [button.utilitySmallQuiet]: utility && small && quiet && !loading && !props.disabled,
    [button.utilitySmallQuietDisabled]: utility && small && quiet && !loading && props.disabled,
    [button.utilitySmallLoading]: utility && small && !quiet && loading,
    [button.utilitySmallQuietLoading]: utility && small && quiet && loading,
    [button.utilityQuiet]: utility && !small && quiet && !loading && !props.disabled,
    [button.utilityQuietDisabled]: utility && !small && quiet && !loading && props.disabled,
    [button.utilityQuietLoading]: utility && !small && quiet && loading,
    [button.utilityLoading]: utility && !small && !quiet && loading,
    [button.negative]: negative && !small && !quiet && !loading && !props.disabled,
    [button.negativeDisabled]: negative && !small && !quiet && !loading && props.disabled,
    [button.negativeSmall]: negative && small && !quiet && !loading && !props.disabled,
    [button.negativeSmallDisabled]: negative && small && !quiet && !loading && props.disabled,
    [button.negativeSmallQuiet]: negative && small && quiet && !loading && !props.disabled,
    [button.negativeSmallQuietDisabled]: negative && small && quiet && !loading && props.disabled,
    [button.negativeSmallLoading]: negative && small && !quiet && loading,
    [button.negativeSmallQuietLoading]: negative && small && quiet && loading,
    [button.negativeQuiet]: negative && !small && quiet && !loading && !props.disabled,
    [button.negativeQuietDisabled]: negative && !small && quiet && !loading && props.disabled,
    [button.negativeQuietLoading]: negative && !small && quiet && loading,
    [button.negativeLoading]: negative && !small && !quiet && loading,
    [button.pill]: pill2 && !small && !loading,
    [button.pillSmall]: pill2 && small && !loading,
    [button.pillLoading]: pill2 && !small && loading,
    [button.pillSmallLoading]: pill2 && small && loading,
    [button.link]: link && !small,
    [button.linkSmall]: link && small,
    [button.linkAsButton]: !!props.href,
    [button.fullWidth]: fullWidth,
    [button.contentWidth]: !fullWidth
  });
  const handleClick = (e) => {
    if (props.onClick) {
      props.onClick(e);
    }
  };
  activateI18n7(messages15, messages17, messages16);
  const ariaValueTextLoading = i18n12._(
    /*i18n*/
    {
      id: "button.aria.loading",
      message: "Loading...",
      comment: "Screenreader message for buttons that are loading"
    }
  );
  return /* @__PURE__ */ React20.createElement(React20.Fragment, null, props.href ? /* @__PURE__ */ React20.createElement(
    "a",
    {
      onClick: handleClick,
      "aria-current": props["aria-current"],
      href: props.disabled ? void 0 : props.href,
      target: props.target,
      rel: props.target === "_blank" ? props.rel || "noopener" : void 0,
      ref,
      className: classes,
      role: "button",
      "aria-disabled": props.disabled
    },
    props.children
  ) : /* @__PURE__ */ React20.createElement(
    "button",
    __spreadProps(__spreadValues({}, rest), {
      type: props.type || "button",
      ref,
      className: classes,
      role: props.link ? "link" : "button"
    }),
    props.children
  ), props.loading ? /* @__PURE__ */ React20.createElement("span", { className: "sr-only", role: "progressbar", "aria-valuenow": 0, "aria-valuetext": ariaValueTextLoading }) : null);
});

// packages/card/src/component.tsx
import React21 from "react";
function Card(props) {
  const _a = props, { as = "div", children, flat } = _a, rest = __objRest(_a, ["as", "children", "flat"]);
  useLogDeprecationWarning({
    condition: !!props.onClick,
    message: "'onClick' prop in Card is deprecated. Use Clickable component to handle click events in Cards."
  });
  return React21.createElement(
    as,
    __spreadProps(__spreadValues({}, rest), {
      className: r(props.className, {
        [card.card]: true,
        [card.cardShadow]: !props.flat,
        [card.cardSelected]: !props.flat && props.selected,
        [card.cardFlat]: props.flat,
        [props.selected ? card.cardFlatSelected : card.cardFlatUnselected]: props.flat
      }),
      // @balbinak(08.11.22): onClick support in Card is deprecated. Remove when Fabric React users are ready for this major change
      tabIndex: props.onClick ? 0 : void 0,
      onKeyDown: props.onClick ? (e) => {
        if (typeof props.onClick === "function" && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          props.onClick();
        }
      } : void 0
    }),
    /* @__PURE__ */ React21.createElement(React21.Fragment, null, props.onClick && /* @__PURE__ */ React21.createElement("button", { className: "sr-only", "aria-pressed": props.selected, tabIndex: -1, type: "button" }, "Velg"), !props.flat && /* @__PURE__ */ React21.createElement("div", { className: r([card.cardOutline, props.selected ? card.cardOutlineSelected : card.cardOutlineUnselected]) }), children)
  );
}

// packages/combobox/src/component.tsx
import React23, {
  forwardRef as forwardRef4,
  useEffect as useEffect6,
  useRef as useRef4,
  useState as useState4
} from "react";

// packages/textfield/src/component.tsx
import React22, { forwardRef as forwardRef3 } from "react";
import { i18n as i18n13 } from "@lingui/core";

// packages/textfield/src/locales/en/messages.mjs
var messages18 = JSON.parse('{"textfield.label.optional":"(optional)"}');

// packages/textfield/src/locales/fi/messages.mjs
var messages19 = JSON.parse('{"textfield.label.optional":"(vapaaehtoinen)"}');

// packages/textfield/src/locales/nb/messages.mjs
var messages20 = JSON.parse('{"textfield.label.optional":"(valgfritt)"}');

// packages/textfield/src/component.tsx
var TextField = forwardRef3((props, ref) => {
  const _a = props, {
    className,
    disabled,
    id: providedId,
    children,
    invalid,
    error,
    helpText: helpText2,
    label: label2,
    readOnly,
    type = "text",
    style,
    optional
  } = _a, rest = __objRest(_a, [
    "className",
    "disabled",
    "id",
    "children",
    "invalid",
    "error",
    "helpText",
    "label",
    "readOnly",
    "type",
    "style",
    "optional"
  ]);
  activateI18n7(messages18, messages20, messages19);
  const id = useId(providedId);
  const helpId = helpText2 ? `${id}__hint` : void 0;
  const isInvalid = invalid || error;
  const suffix2 = React22.Children.toArray(children).find((child) => React22.isValidElement(child) && child.props.suffix);
  const prefix2 = React22.Children.toArray(children).find((child) => React22.isValidElement(child) && child.props.prefix);
  return /* @__PURE__ */ React22.createElement("div", { className, style }, label2 && /* @__PURE__ */ React22.createElement("label", { htmlFor: id, className: label.label }, label2, optional && /* @__PURE__ */ React22.createElement("span", { className: label.optional }, i18n13._(
    /*i18n*/
    {
      id: "textfield.label.optional",
      message: "(optional)",
      comment: "Shown behind label when marked as optional"
    }
  ))), /* @__PURE__ */ React22.createElement("div", { className: input.wrapper }, prefix2, /* @__PURE__ */ React22.createElement(
    "input",
    __spreadProps(__spreadValues({
      className: r({
        [input.base]: true,
        [input.default]: !isInvalid && !disabled && !readOnly,
        [input.invalid]: isInvalid && !disabled && !readOnly,
        [input.disabled]: !isInvalid && disabled && !readOnly,
        [input.readOnly]: !isInvalid && !disabled && readOnly,
        [input.placeholder]: !!props.placeholder,
        [input.suffix]: !!suffix2,
        [input.prefix]: !!prefix2
      })
    }, rest), {
      "aria-describedby": helpId,
      "aria-errormessage": isInvalid && helpId ? helpId : void 0,
      "aria-invalid": isInvalid,
      disabled,
      id,
      readOnly,
      ref,
      type
    })
  ), suffix2), helpText2 && /* @__PURE__ */ React22.createElement(
    "div",
    {
      className: r({
        [helpText.helpText]: true,
        [helpText.helpTextColor]: !isInvalid,
        [helpText.helpTextColorInvalid]: isInvalid
      }),
      id: helpId
    },
    helpText2
  ));
});

// packages/combobox/src/locales/en/messages.mjs
var messages21 = JSON.parse('{"combobox.aria.pluralResults":[["numResults","plural",{"one":["#"," result"],"other":["#"," results"]}]],"combobox.aria.noResults":"No results"}');

// packages/combobox/src/locales/fi/messages.mjs
var messages27 = JSON.parse('{"combobox.aria.pluralResults":[["numResults","plural",{"one":["#"," tulos"],"other":["#"," tulosta"]}]],"combobox.aria.noResults":"Ei tuloksia"}');

// packages/combobox/src/locales/nb/messages.mjs
var messages28 = JSON.parse('{"combobox.aria.pluralResults":[["numResults","plural",{"one":["#"," resultat"],"other":["#"," resultater"]}]],"combobox.aria.noResults":"Ingen resultater"}');

// packages/combobox/src/utils.ts
import { i18n as i18n14 } from "@lingui/core";
function createOptionsWithIdAndMatch(options, currentInputValue) {
  return options.map((option) => __spreadProps(__spreadValues({}, option), {
    id: generateId(),
    currentInputValue
  }));
}
function getAriaText(options, value) {
  if (!options)
    return;
  const filteredOptionsByInputValue = options.filter((option) => option.value.toLowerCase().includes(value.toLowerCase()));
  const pluralResults = i18n14._(
    /*i18n*/
    {
      id: "combobox.aria.pluralResults",
      message: "{numResults, plural, one {# result} other {# results}}",
      comment: "Aria text for combobox when one or more results",
      values: { numResults: filteredOptionsByInputValue.length }
    }
  );
  const noResults = i18n14._(
    /*i18n*/
    {
      id: "combobox.aria.noResults",
      message: "No results.....",
      comment: "Aria text for combobox when no results"
    }
  );
  return filteredOptionsByInputValue.length ? pluralResults : noResults;
}

// packages/combobox/src/component.tsx
var OPTION_CLASS_NAME = "w-react-combobox-option";
var MATCH_SEGMENTS_CLASS_NAME = "w-react-combobox-match";
var Combobox = forwardRef4((_a, forwardRef9) => {
  var _b = _a, { id: pid } = _b, props = __objRest(_b, ["id"]);
  const id = useId(pid);
  const listboxId = `${id}-listbox`;
  const inputRef = useRef4(null);
  const inputContainerRef = useRef4(null);
  const containerRef = useRef4(null);
  activateI18n7(messages21, messages28, messages27);
  const [isOpen, setOpen] = useState4(false);
  const [navigationOption, setNavigationOption] = useState4(null);
  const [currentOptions, setCurrentOptions] = useState4([]);
  const _a2 = props, {
    options,
    value,
    label: label2,
    invalid,
    helpText: helpText2,
    placeholder,
    openOnFocus,
    selectOnBlur = true,
    className,
    listClassName,
    disableStaticFiltering = false,
    matchTextSegments,
    children,
    highlightValueMatch,
    onSelect,
    onChange,
    onFocus: onFocus3,
    onBlur: onBlur3,
    optional
  } = _a2, rest = __objRest(_a2, [
    "options",
    "value",
    "label",
    "invalid",
    "helpText",
    "placeholder",
    "openOnFocus",
    "selectOnBlur",
    "className",
    "listClassName",
    "disableStaticFiltering",
    "matchTextSegments",
    "children",
    "highlightValueMatch",
    "onSelect",
    "onChange",
    "onFocus",
    "onBlur",
    "optional"
  ]);
  const navigationValueOrInputValue = (navigationOption == null ? void 0 : navigationOption.value) || value;
  useEffect6(() => {
    setCurrentOptions(
      createOptionsWithIdAndMatch(options, value).filter(
        (option) => !disableStaticFiltering ? option.value.toLocaleLowerCase().includes(value.toLowerCase()) : true
      )
    );
  }, [options, disableStaticFiltering]);
  useEffect6(() => {
    if (disableStaticFiltering && currentOptions.length && currentOptions.length === 1 && !currentOptions.some((o) => o.value === value)) {
      setOpen(true);
    }
  }, [currentOptions, value, disableStaticFiltering]);
  function handlekeyDown(e) {
    const isNavigationKey = ["ArrowDown", "ArrowUp", "PageUp", "PageDown", "Home", "End"].includes(e.key);
    const ignoreList = ["ArrowDown", "ArrowLeft", "ArrowUp", "ArrowRight"];
    if (isNavigationKey && !isOpen) {
      return setOpen(true);
    } else if (isNavigationKey && isOpen) {
      findAndSetActiveOption(e, {
        setNavigationOption,
        navigationOption,
        currentOptions
      });
    } else if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) {
      return;
    }
    switch (e.key) {
      case "Enter":
        if (navigationOption) {
          e.preventDefault();
          handleSelect(navigationOption);
        }
        setOpen(false);
        break;
      case "Tab":
      case "Delete":
        setOpen(false);
        break;
      case "Escape":
        if (isOpen) {
          setOpen(false);
        } else {
          onChange("");
        }
        setNavigationOption(null);
        break;
      case "Backspace":
        onChange(navigationValueOrInputValue);
        setNavigationOption(null);
        setOpen(true);
        break;
      default:
        if (ignoreList.includes(e.key)) {
          break;
        }
        setOpen(true);
        if (navigationOption) {
          onChange(navigationOption.value);
          setNavigationOption(null);
        } else {
          onChange(value);
        }
        break;
    }
  }
  useEffect6(() => {
    if (!inputRef.current)
      return;
    const input2 = inputRef.current;
    input2.addEventListener("keydown", handlekeyDown);
    return () => {
      input2.removeEventListener("keydown", handlekeyDown);
    };
  });
  function handleSelect(option) {
    onSelect && onSelect(option.value);
    setOpen(false);
    setNavigationOption(null);
    if (disableStaticFiltering) {
      setCurrentOptions([]);
    }
  }
  const TextFieldProps = __spreadValues({
    id,
    value: navigationValueOrInputValue,
    label: label2,
    optional,
    invalid,
    helpText: helpText2,
    placeholder,
    role: "combobox",
    "aria-label": props["aria-label"],
    "aria-labelledby": props["aria-labelledby"],
    "aria-autocomplete": "list",
    "aria-expanded": isOpen && currentOptions.length !== 0,
    "aria-activedescendant": isOpen ? navigationOption == null ? void 0 : navigationOption.id : void 0,
    "aria-controls": listboxId,
    onChange: function(e) {
      onChange(e.target.value);
    },
    onFocus: function() {
      if (!openOnFocus)
        return;
      onFocus3 && onFocus3();
      setOpen(true);
    },
    onBlur: function(e) {
      handleInputBlur(containerRef, inputContainerRef, e, setOpen);
      selectOnBlur && (navigationOption || !navigationOption && currentOptions.findIndex((o) => o.value === value) !== -1) && onSelect && onSelect((navigationOption == null ? void 0 : navigationOption.value) || value);
      setNavigationOption(null);
      onBlur3 && onBlur3(navigationValueOrInputValue);
    },
    ref: function(node2) {
      inputRef.current = node2;
      if (forwardRef9) {
        if (typeof forwardRef9 === "function") {
          forwardRef9(node2);
        } else {
          forwardRef9.current = node2;
        }
      }
    }
  }, rest);
  return /* @__PURE__ */ React23.createElement("div", { className: r(className, combobox.wrapper), onBlur: (e) => handleContainerBlur(e, setOpen), ref: containerRef }, /* @__PURE__ */ React23.createElement("div", { ref: inputContainerRef }, children ? (
    // @ts-ignore
    /* @__PURE__ */ React23.createElement(TextField, __spreadValues({}, TextFieldProps), children)
  ) : (
    // @ts-ignore
    /* @__PURE__ */ React23.createElement(TextField, __spreadValues({}, TextFieldProps))
  )), /* @__PURE__ */ React23.createElement("span", { className: combobox.a11y, role: "status" }, getAriaText(currentOptions, value)), /* @__PURE__ */ React23.createElement(
    "div",
    {
      hidden: !isOpen || !currentOptions.length,
      className: r(listClassName, combobox.combobox),
      style: {
        zIndex: 3
        // Force popover above misc. page content (mobile safari issue)
      }
    },
    /* @__PURE__ */ React23.createElement(
      "ul",
      {
        id: listboxId,
        role: "listbox",
        className: r(combobox.listbox, {
          [MATCH_SEGMENTS_CLASS_NAME]: matchTextSegments
        })
      },
      currentOptions.map((option) => {
        const display = option.label || option.value;
        let match = [];
        if (matchTextSegments && !highlightValueMatch) {
          const startIdx = display.toLowerCase().indexOf(option.currentInputValue.toLowerCase());
          if (startIdx !== -1) {
            const endIdx = startIdx + option.currentInputValue.length;
            match = /* @__PURE__ */ React23.createElement(React23.Fragment, null, display.substring(0, startIdx), /* @__PURE__ */ React23.createElement("span", { "data-combobox-text-match": true, className: combobox.textMatch }, display.substring(startIdx, endIdx)), display.substring(endIdx));
          } else {
            match = /* @__PURE__ */ React23.createElement("span", null, display);
          }
        } else if (highlightValueMatch) {
          match = highlightValueMatch(display, value);
        }
        return /* @__PURE__ */ React23.createElement(
          "li",
          {
            key: option.id,
            id: option.id,
            role: "option",
            "aria-selected": (navigationOption == null ? void 0 : navigationOption.id) === option.id,
            tabIndex: -1,
            onClick: () => {
              new Promise((res) => res(setNavigationOption(option))).then(() => {
                handleSelect(option);
              });
            },
            className: r({
              [`${combobox.option} ${OPTION_CLASS_NAME}`]: true,
              [combobox.optionSelected]: (navigationOption == null ? void 0 : navigationOption.id) === option.id
            })
          },
          matchTextSegments || highlightValueMatch ? match : display
        );
      })
    )
  ));
});
function findAndSetActiveOption(e, {
  setNavigationOption,
  navigationOption,
  currentOptions
}) {
  e.preventDefault();
  const currIndex = currentOptions.findIndex((option) => option.id === (navigationOption == null ? void 0 : navigationOption.id));
  const nextIndex = currIndex + 1;
  const prevIndex = currIndex - 1;
  switch (e.key) {
    case "ArrowDown":
      setNavigationOption(nextIndex > currentOptions.length ? null : currentOptions[nextIndex]);
      break;
    case "ArrowUp":
      setNavigationOption(prevIndex === -2 ? currentOptions[currentOptions.length - 1] : prevIndex < 0 ? null : currentOptions[prevIndex]);
      break;
    case "PageUp":
      setNavigationOption(currIndex - 10 < 0 ? currentOptions[0] : currentOptions[currIndex - 10]);
      break;
    case "PageDown":
      setNavigationOption(
        currIndex + 10 > currentOptions.length ? currentOptions[currentOptions.length - 1] : currentOptions[currIndex + 10]
      );
      break;
    case "Home":
      setNavigationOption(currentOptions[0]);
      break;
    case "End":
      setNavigationOption(currentOptions[currentOptions.length - 1]);
      break;
  }
}
function handleContainerBlur(e, setOpen) {
  const isClickOutsideContainer = !e.currentTarget.contains(e.relatedTarget);
  if (isClickOutsideContainer) {
    setOpen(false);
  }
}
function handleInputBlur(containerRef, inputContainerRef, e, setOpen) {
  var _a, _b;
  if (!containerRef.current)
    return;
  const isClickOutsideContainer = !((_a = containerRef.current) == null ? void 0 : _a.contains(e.relatedTarget)) || ((_b = inputContainerRef.current) == null ? void 0 : _b.contains(e.relatedTarget));
  if (isClickOutsideContainer) {
    setOpen(false);
  }
}

// packages/expandable/src/component.tsx
import React26 from "react";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-down-16.js
import React24 from "react";
import { i18n as i18n27 } from "@lingui/core";
import { i18n as i18n15 } from "@lingui/core";
var __defProp8 = Object.defineProperty;
var __getOwnPropSymbols8 = Object.getOwnPropertySymbols;
var __hasOwnProp8 = Object.prototype.hasOwnProperty;
var __propIsEnum8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp8 = (obj, key, value) => key in obj ? __defProp8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues8 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp8.call(b2, prop))
      __defNormalProp8(a2, prop, b2[prop]);
  if (__getOwnPropSymbols8)
    for (var prop of __getOwnPropSymbols8(b2)) {
      if (__propIsEnum8.call(b2, prop))
        __defNormalProp8(a2, prop, b2[prop]);
    }
  return a2;
};
var messages29 = JSON.parse('{"icon.title.chevron-down":"Nedoverpil"}');
var messages210 = JSON.parse('{"icon.title.chevron-down":"Downward arrow"}');
var messages37 = JSON.parse('{"icon.title.chevron-down":"Nuoli alasp\xE4in"}');
var supportedLocales8 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale8 = "en";
var detectByBrand7 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost7 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale8;
  }
};
var getSupportedLocale8 = (usedLocale) => {
  return supportedLocales8.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost7();
};
function detectLocale8() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand7();
    return getSupportedLocale8(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost7();
    if (!supportedLocales8.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale8(hostLocale);
    }
    return getSupportedLocale8(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale8;
  }
}
var getMessages8 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n8 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale8();
  const messages410 = getMessages8(locale, enMessages, nbMessages, fiMessages);
  i18n15.load(locale, messages410);
  i18n15.activate(locale);
};
activateI18n8(messages210, messages29, messages37);
var title7 = i18n27.t({ message: `Downward arrow`, id: "icon.title.chevron-down", comment: "Title for chevron-down icon" });
var IconChevronDown16 = (attrs) => React24.createElement("svg", __spreadValues8({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title7}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2.667 5.333 5.5 5.5 5.5-5.5"></path>` } }, attrs));
var chevron_down_16_default = IconChevronDown16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-up-16.js
import React25 from "react";
import { i18n as i18n28 } from "@lingui/core";
import { i18n as i18n16 } from "@lingui/core";
var __defProp9 = Object.defineProperty;
var __getOwnPropSymbols9 = Object.getOwnPropertySymbols;
var __hasOwnProp9 = Object.prototype.hasOwnProperty;
var __propIsEnum9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp9 = (obj, key, value) => key in obj ? __defProp9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues9 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp9.call(b2, prop))
      __defNormalProp9(a2, prop, b2[prop]);
  if (__getOwnPropSymbols9)
    for (var prop of __getOwnPropSymbols9(b2)) {
      if (__propIsEnum9.call(b2, prop))
        __defNormalProp9(a2, prop, b2[prop]);
    }
  return a2;
};
var messages30 = JSON.parse('{"icon.title.chevron-up":"Oppoverpil"}');
var messages211 = JSON.parse('{"icon.title.chevron-up":"Upward arrow"}');
var messages38 = JSON.parse('{"icon.title.chevron-up":"Nuoli yl\xF6sp\xE4in"}');
var supportedLocales9 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale9 = "en";
var detectByBrand8 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost8 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale9;
  }
};
var getSupportedLocale9 = (usedLocale) => {
  return supportedLocales9.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost8();
};
function detectLocale9() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand8();
    return getSupportedLocale9(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost8();
    if (!supportedLocales9.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale9(hostLocale);
    }
    return getSupportedLocale9(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale9;
  }
}
var getMessages9 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n9 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale9();
  const messages410 = getMessages9(locale, enMessages, nbMessages, fiMessages);
  i18n16.load(locale, messages410);
  i18n16.activate(locale);
};
activateI18n9(messages211, messages30, messages38);
var title8 = i18n28.t({ message: `Upward arrow`, id: "icon.title.chevron-up", comment: "Title for chevron-up icon" });
var IconChevronUp16 = (attrs) => React25.createElement("svg", __spreadValues9({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title8}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 11 8 5.5l5.5 5.5"></path>` } }, attrs));
var chevron_up_16_default = IconChevronUp16;

// packages/expandable/src/component.tsx
function Expandable(props) {
  const _a = props, { children, expanded = false, title: title14 = "", info = false, box: box2 = false, bleed = false, buttonClass = "", contentClass = "", className, onChange, chevron = true, animated, headingLevel } = _a, rest = __objRest(_a, ["children", "expanded", "title", "info", "box", "bleed", "buttonClass", "contentClass", "className", "onChange", "chevron", "animated", "headingLevel"]);
  const [stateExpanded, setStateExpanded] = React26.useState(expanded);
  const [showChevronUp, setShowChevronUp] = React26.useState(expanded);
  React26.useEffect(() => {
    setStateExpanded(expanded);
  }, [expanded]);
  const toggleExpandable = (state) => {
    setStateExpanded(!state);
    setTimeout(() => {
      setShowChevronUp(!state);
    }, 200);
    if (onChange)
      onChange(!state);
  };
  return /* @__PURE__ */ React26.createElement(
    "div",
    __spreadProps(__spreadValues({}, rest), {
      className: r(className, {
        [expandable.expandable]: true,
        [expandable.expandableBox]: box2,
        [expandable.expandableBleed]: bleed
      })
    }),
    /* @__PURE__ */ React26.createElement(UnstyledHeading, { level: headingLevel }, /* @__PURE__ */ React26.createElement(
      "button",
      {
        type: "button",
        "aria-expanded": stateExpanded,
        className: r({
          [buttonClass || ""]: true,
          [expandable.button]: true,
          [expandable.buttonBox]: box2
        }),
        onClick: () => toggleExpandable(stateExpanded)
      },
      /* @__PURE__ */ React26.createElement("div", { className: expandable.title }, typeof title14 === "string" ? /* @__PURE__ */ React26.createElement("span", { className: expandable.titleType }, title14) : title14, chevron && /* @__PURE__ */ React26.createElement(
        "div",
        {
          className: r({
            [expandable.chevron]: true,
            [expandable.chevronBox]: box2,
            [expandable.chevronNonBox]: !box2
          })
        },
        showChevronUp ? /* @__PURE__ */ React26.createElement(
          chevron_up_16_default,
          {
            className: r({
              [expandable.chevronTransform]: true,
              [expandable.chevronCollapse]: !stateExpanded && showChevronUp
            })
          }
        ) : /* @__PURE__ */ React26.createElement(
          chevron_down_16_default,
          {
            className: r({
              [expandable.chevronTransform]: true,
              [expandable.chevronExpand]: stateExpanded && !showChevronUp
            })
          }
        )
      ))
    )),
    /* @__PURE__ */ React26.createElement(ExpansionBehaviour, { animated, stateExpanded }, /* @__PURE__ */ React26.createElement(
      "div",
      {
        className: r({
          [contentClass || ""]: true,
          [box.box]: box2,
          [expandable.paddingTop]: box2 && title14
        })
      },
      children
    ))
  );
}
function ExpansionBehaviour({ animated, stateExpanded, children }) {
  return animated ? /* @__PURE__ */ React26.createElement(ExpandTransition, { show: stateExpanded }, children) : /* @__PURE__ */ React26.createElement(
    "div",
    {
      className: r({
        [expandable.expansion]: true,
        [expandable.expansionNotExpanded]: !stateExpanded
      }),
      "data-testid": "expandable-content",
      "aria-hidden": !stateExpanded ? true : void 0
    },
    children
  );
}

// packages/modal/src/component.tsx
import React34, { useEffect as useEffect10, useRef as useRef6 } from "react";
import { i18n as i18n18 } from "@lingui/core";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/arrow-left-16.js
import React27 from "react";
import { i18n as i18n29 } from "@lingui/core";
import { i18n as i18n17 } from "@lingui/core";
var __defProp10 = Object.defineProperty;
var __getOwnPropSymbols10 = Object.getOwnPropertySymbols;
var __hasOwnProp10 = Object.prototype.hasOwnProperty;
var __propIsEnum10 = Object.prototype.propertyIsEnumerable;
var __defNormalProp10 = (obj, key, value) => key in obj ? __defProp10(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues10 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp10.call(b2, prop))
      __defNormalProp10(a2, prop, b2[prop]);
  if (__getOwnPropSymbols10)
    for (var prop of __getOwnPropSymbols10(b2)) {
      if (__propIsEnum10.call(b2, prop))
        __defNormalProp10(a2, prop, b2[prop]);
    }
  return a2;
};
var messages31 = JSON.parse('{"icon.title.arrow-left":"Pil som peker mot venstre"}');
var messages212 = JSON.parse('{"icon.title.arrow-left":"Leftward-pointing arrow"}');
var messages39 = JSON.parse('{"icon.title.arrow-left":"Vasemmalle osoittava nuoli"}');
var supportedLocales10 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale10 = "en";
var detectByBrand9 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost9 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale10;
  }
};
var getSupportedLocale10 = (usedLocale) => {
  return supportedLocales10.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost9();
};
function detectLocale10() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand9();
    return getSupportedLocale10(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost9();
    if (!supportedLocales10.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale10(hostLocale);
    }
    return getSupportedLocale10(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale10;
  }
}
var getMessages10 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n10 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale10();
  const messages410 = getMessages10(locale, enMessages, nbMessages, fiMessages);
  i18n17.load(locale, messages410);
  i18n17.activate(locale);
};
activateI18n10(messages212, messages31, messages39);
var title9 = i18n29.t({ message: `Leftward-pointing arrow`, id: "icon.title.arrow-left", comment: "Title for table arrow left icon" });
var IconArrowLeft16 = (attrs) => React27.createElement("svg", __spreadValues10({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title9}</title><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M5.222 8h6.667"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.444 11.75 4.111 8l3.333-3.75"></path>` } }, attrs));
var arrow_left_16_default = IconArrowLeft16;

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0)
        continue;
      target[key] = source[key];
    }
  }
  return target;
}

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Combination.js
import * as React33 from "react";

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Lock.js
var import_prop_types2 = __toESM(require_prop_types());
import * as React30 from "react";

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/constants.js
var FOCUS_GROUP = "data-focus-lock";
var FOCUS_DISABLED = "data-focus-lock-disabled";
var FOCUS_ALLOW = "data-no-focus-lock";
var FOCUS_AUTO = "data-autofocus-inside";
var FOCUS_NO_AUTOFOCUS = "data-no-autofocus";

// node_modules/.pnpm/use-callback-ref@1.3.2_@types+react@18.3.2_react@18.2.0/node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

// node_modules/.pnpm/use-callback-ref@1.3.2_@types+react@18.3.2_react@18.2.0/node_modules/use-callback-ref/dist/es2015/useRef.js
import { useState as useState5 } from "react";
function useCallbackRef(initialValue, callback) {
  var ref = useState5(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}

// node_modules/.pnpm/use-callback-ref@1.3.2_@types+react@18.3.2_react@18.2.0/node_modules/use-callback-ref/dist/es2015/useMergeRef.js
import * as React28 from "react";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React28.useLayoutEffect : React28.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Lock.js
import { useEffect as useEffect9 } from "react";

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/FocusGuard.js
var import_prop_types = __toESM(require_prop_types());
import * as React29 from "react";
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
var InFocusGuard = function InFocusGuard2(_ref2) {
  var _ref$children = _ref2.children, children = _ref$children === void 0 ? null : _ref$children;
  return /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /* @__PURE__ */ React29.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};
InFocusGuard.propTypes = true ? {
  children: import_prop_types.default.node
} : {};

// node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t[p2] = s[p2];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// node_modules/.pnpm/use-sidecar@1.1.2_@types+react@18.3.2_react@18.2.0/node_modules/use-sidecar/dist/es2015/medium.js
function ItoI(a2) {
  return a2;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x) {
          return cb(x);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/medium.js
var mediumFocus = createMedium({}, function(_ref2) {
  var target = _ref2.target, currentTarget = _ref2.currentTarget;
  return {
    target,
    currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true
});

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Lock.js
var emptyArray = [];
var FocusLock = /* @__PURE__ */ React30.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;
  var _React$useState = React30.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
  var observed = React30.useRef();
  var isActive = React30.useRef(false);
  var originalFocusedElement = React30.useRef(null);
  var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
  var _React$useState2 = React30.useState({}), id = _React$useState2[0];
  var onActivation = React30.useCallback(function() {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = React30.useCallback(function() {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  useEffect9(function() {
    if (!disabled) {
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = React30.useCallback(function(allowDefer) {
    var returnFocusTo = originalFocusedElement.current;
    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : void 0;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function() {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus3 = React30.useCallback(function(event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur3 = mediumBlur.useMedium;
  var setObserveNode = React30.useCallback(function(newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (true) {
    if (typeof allowTextSelection !== "undefined") {
      console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default");
    }
    React30.useEffect(function() {
      if (!observed.current && typeof Container !== "string") {
        console.error("FocusLock: could not obtain ref to internal node");
      }
    }, []);
  }
  var lockProps = _extends((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && "disabled", _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return /* @__PURE__ */ React30.createElement(React30.Fragment, null, hasLeadingGuards && [
    /* @__PURE__ */ React30.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }),
    hasPositiveIndices ? /* @__PURE__ */ React30.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !disabled && /* @__PURE__ */ React30.createElement(SideCar, {
    id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled,
    persistentFocus,
    crossFrame,
    autoFocus,
    whiteList,
    shards,
    onActivation,
    onDeactivation,
    returnFocus,
    focusOptions
  }), /* @__PURE__ */ React30.createElement(Container, _extends({
    ref: mergedRef
  }, lockProps, {
    className,
    onBlur: onBlur3,
    onFocus: onFocus3
  }), children), hasTailingGuards && /* @__PURE__ */ React30.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = true ? {
  children: import_prop_types2.node,
  disabled: import_prop_types2.bool,
  returnFocus: (0, import_prop_types2.oneOfType)([import_prop_types2.bool, import_prop_types2.object, import_prop_types2.func]),
  focusOptions: import_prop_types2.object,
  noFocusGuards: import_prop_types2.bool,
  hasPositiveIndices: import_prop_types2.bool,
  allowTextSelection: import_prop_types2.bool,
  autoFocus: import_prop_types2.bool,
  persistentFocus: import_prop_types2.bool,
  crossFrame: import_prop_types2.bool,
  group: import_prop_types2.string,
  className: import_prop_types2.string,
  whiteList: import_prop_types2.func,
  shards: (0, import_prop_types2.arrayOf)(import_prop_types2.any),
  as: (0, import_prop_types2.oneOfType)([import_prop_types2.string, import_prop_types2.func, import_prop_types2.object]),
  lockProps: import_prop_types2.object,
  onActivation: import_prop_types2.func,
  onDeactivation: import_prop_types2.func,
  sideCar: import_prop_types2.any.isRequired
} : {};
var Lock_default = FocusLock;

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Trap.js
var import_prop_types3 = __toESM(require_prop_types());
import * as React32 from "react";

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t, r3) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i2 = e.call(t, r3 || "default");
    if ("object" != _typeof(i2))
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t);
}

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
  var i2 = toPrimitive(t, "string");
  return "symbol" == _typeof(i2) ? i2 : i2 + "";
}

// node_modules/.pnpm/@babel+runtime@7.24.5/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// node_modules/.pnpm/react-clientside-effect@1.2.6_react@18.2.0/node_modules/react-clientside-effect/lib/index.es.js
import React31, { PureComponent } from "react";
function withSideEffect(reducePropsToState2, handleStateChangeOnClient2) {
  if (true) {
    if (typeof reducePropsToState2 !== "function") {
      throw new Error("Expected reducePropsToState to be a function.");
    }
    if (typeof handleStateChangeOnClient2 !== "function") {
      throw new Error("Expected handleStateChangeOnClient to be a function.");
    }
  }
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }
  return function wrap(WrappedComponent) {
    if (true) {
      if (typeof WrappedComponent !== "function") {
        throw new Error("Expected WrappedComponent to be a React component.");
      }
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState2(mountedInstances.map(function(instance) {
        return instance.props;
      }));
      handleStateChangeOnClient2(state);
    }
    var SideEffect = /* @__PURE__ */ function(_PureComponent) {
      _inheritsLoose(SideEffect2, _PureComponent);
      function SideEffect2() {
        return _PureComponent.apply(this, arguments) || this;
      }
      SideEffect2.peek = function peek() {
        return state;
      };
      var _proto = SideEffect2.prototype;
      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index2 = mountedInstances.indexOf(this);
        mountedInstances.splice(index2, 1);
        emitChange();
      };
      _proto.render = function render() {
        return /* @__PURE__ */ React31.createElement(WrappedComponent, this.props);
      };
      return SideEffect2;
    }(PureComponent);
    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
    return SideEffect;
  };
}
var index_es_default = withSideEffect;

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/array.js
var toArray = function(a2) {
  var ret = Array(a2.length);
  for (var i2 = 0; i2 < a2.length; ++i2) {
    ret[i2] = a2[i2];
  }
  return ret;
};
var asArray = function(a2) {
  return Array.isArray(a2) ? a2 : [a2];
};
var getFirst = function(a2) {
  return Array.isArray(a2) ? a2[0] : a2;
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/is.js
var isElementHidden = function(node2) {
  if (node2.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  var computedStyle = window.getComputedStyle(node2, null);
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var getParentNode2 = function(node2) {
  return node2.parentNode && node2.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    node2.parentNode.host
  ) : node2.parentNode;
};
var isTopNode = function(node2) {
  return node2 === document || node2 && node2.nodeType === Node.DOCUMENT_NODE;
};
var isInert = function(node2) {
  return node2.hasAttribute("inert");
};
var isVisibleUncached = function(node2, checkParent) {
  return !node2 || isTopNode(node2) || !isElementHidden(node2) && !isInert(node2) && checkParent(getParentNode2(node2));
};
var isVisibleCached = function(visibilityCache, node2) {
  var cached = visibilityCache.get(node2);
  if (cached !== void 0) {
    return cached;
  }
  var result = isVisibleUncached(node2, isVisibleCached.bind(void 0, visibilityCache));
  visibilityCache.set(node2, result);
  return result;
};
var isAutoFocusAllowedUncached = function(node2, checkParent) {
  return node2 && !isTopNode(node2) ? isAutoFocusAllowed(node2) ? checkParent(getParentNode2(node2)) : false : true;
};
var isAutoFocusAllowedCached = function(cache, node2) {
  var cached = cache.get(node2);
  if (cached !== void 0) {
    return cached;
  }
  var result = isAutoFocusAllowedUncached(node2, isAutoFocusAllowedCached.bind(void 0, cache));
  cache.set(node2, result);
  return result;
};
var getDataset = function(node2) {
  return node2.dataset;
};
var isHTMLButtonElement = function(node2) {
  return node2.tagName === "BUTTON";
};
var isHTMLInputElement = function(node2) {
  return node2.tagName === "INPUT";
};
var isRadioElement = function(node2) {
  return isHTMLInputElement(node2) && node2.type === "radio";
};
var notHiddenInput = function(node2) {
  return !((isHTMLInputElement(node2) || isHTMLButtonElement(node2)) && (node2.type === "hidden" || node2.disabled));
};
var isAutoFocusAllowed = function(node2) {
  var attribute = node2.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![true, "true", ""].includes(attribute);
};
var isGuard = function(node2) {
  var _a;
  return Boolean(node2 && ((_a = getDataset(node2)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var isNotAGuard = function(node2) {
  return !isGuard(node2);
};
var isDefined = function(x) {
  return Boolean(x);
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/tabOrder.js
var tabSort = function(a2, b2) {
  var aTab = Math.max(0, a2.tabIndex);
  var bTab = Math.max(0, b2.tabIndex);
  var tabDiff = aTab - bTab;
  var indexDiff = a2.index - b2.index;
  if (tabDiff) {
    if (!aTab) {
      return 1;
    }
    if (!bTab) {
      return -1;
    }
  }
  return tabDiff || indexDiff;
};
var getTabIndex = function(node2) {
  if (node2.tabIndex < 0) {
    if (!node2.hasAttribute("tabindex")) {
      return 0;
    }
  }
  return node2.tabIndex;
};
var orderByTabIndex = function(nodes, filterNegative, keepGuards) {
  return toArray(nodes).map(function(node2, index2) {
    var tabIndex = getTabIndex(node2);
    return {
      node: node2,
      index: index2,
      tabIndex: keepGuards && tabIndex === -1 ? (node2.dataset || {}).focusGuard ? 0 : -1 : tabIndex
    };
  }).filter(function(data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/tabbables.js
var tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
];

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/tabUtils.js
var queryTabbables = tabbables.join(",");
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function(parent, withGuards) {
  return toArray((parent.shadowRoot || parent).children).reduce(function(acc, child) {
    return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
  }, []);
};
var getFocusablesWithIFrame = function(parent, withGuards) {
  var _a;
  if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
    return getFocusables([parent.contentDocument.body], withGuards);
  }
  return [parent];
};
var getFocusables = function(parents, withGuards) {
  return parents.reduce(function(acc, parent) {
    var _a;
    var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
    var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node2) {
      return getFocusablesWithIFrame(node2, withGuards);
    }));
    return acc.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      focusableWithIframes,
      // add if node is tabbable itself
      parent.parentNode ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function(node2) {
        return node2 === parent;
      }) : []
    );
  }, []);
};
var getParentAutofocusables = function(parent) {
  var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray(parentFocus).map(function(node2) {
    return getFocusables([node2]);
  }).reduce(function(acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/DOMutils.js
var filterFocusable = function(nodes, visibilityCache) {
  return toArray(nodes).filter(function(node2) {
    return isVisibleCached(visibilityCache, node2);
  }).filter(function(node2) {
    return notHiddenInput(node2);
  });
};
var filterAutoFocusable = function(nodes, cache) {
  if (cache === void 0) {
    cache = /* @__PURE__ */ new Map();
  }
  return toArray(nodes).filter(function(node2) {
    return isAutoFocusAllowedCached(cache, node2);
  });
};
var getFocusableNodes = function(topNodes, visibilityCache) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
var parentAutofocusables = function(topNode, visibilityCache) {
  return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
var contains = function(scope, element) {
  if (scope.shadowRoot) {
    return contains(scope.shadowRoot, element);
  } else {
    if (Object.getPrototypeOf(scope).contains !== void 0 && Object.getPrototypeOf(scope).contains.call(scope, element)) {
      return true;
    }
    return toArray(scope.children).some(function(child) {
      var _a;
      if (child instanceof HTMLIFrameElement) {
        var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
        if (iframeBody) {
          return contains(iframeBody, element);
        }
        return false;
      }
      return contains(child, element);
    });
  }
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/all-affected.js
var filterNested = function(nodes) {
  var contained = /* @__PURE__ */ new Set();
  var l = nodes.length;
  for (var i2 = 0; i2 < l; i2 += 1) {
    for (var j = i2 + 1; j < l; j += 1) {
      var position = nodes[i2].compareDocumentPosition(nodes[j]);
      if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
        contained.add(j);
      }
      if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
        contained.add(i2);
      }
    }
  }
  return nodes.filter(function(_, index2) {
    return !contained.has(index2);
  });
};
var getTopParent = function(node2) {
  return node2.parentNode ? getTopParent(node2.parentNode) : node2;
};
var getAllAffectedNodes = function(node2) {
  var nodes = asArray(node2);
  return nodes.filter(Boolean).reduce(function(acc, currentNode) {
    var group = currentNode.getAttribute(FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(group, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [currentNode]);
    return acc;
  }, []);
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function(cb) {
  try {
    return cb();
  } catch (e) {
    return void 0;
  }
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
var getActiveElement = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  if (!inDocument || !inDocument.activeElement) {
    return void 0;
  }
  var activeElement = inDocument.activeElement;
  return activeElement.shadowRoot ? getActiveElement(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && safeProbe(function() {
    return activeElement.contentWindow.document;
  }) ? getActiveElement(activeElement.contentWindow.document) : activeElement;
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/focusInside.js
var focusInFrame = function(frame, activeElement) {
  return frame === activeElement;
};
var focusInsideIframe = function(topNode, activeElement) {
  return Boolean(toArray(topNode.querySelectorAll("iframe")).some(function(node2) {
    return focusInFrame(node2, activeElement);
  }));
};
var focusInside = function(topNode, activeElement) {
  if (activeElement === void 0) {
    activeElement = getActiveElement(getFirst(topNode).ownerDocument);
  }
  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).some(function(node2) {
    return contains(node2, activeElement) || focusInsideIframe(node2, activeElement);
  });
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/focusIsHidden.js
var focusIsHidden = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  var activeElement = getActiveElement(inDocument);
  if (!activeElement) {
    return false;
  }
  return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(node2) {
    return contains(node2, activeElement);
  });
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/correctFocus.js
var findSelectedRadio = function(node2, nodes) {
  return nodes.filter(isRadioElement).filter(function(el) {
    return el.name === node2.name;
  }).filter(function(el) {
    return el.checked;
  })[0] || node2;
};
var correctNode = function(node2, nodes) {
  if (isRadioElement(node2) && node2.name) {
    return findSelectedRadio(node2, nodes);
  }
  return node2;
};
var correctNodes = function(nodes) {
  var resultSet = /* @__PURE__ */ new Set();
  nodes.forEach(function(node2) {
    return resultSet.add(correctNode(node2, nodes));
  });
  return nodes.filter(function(node2) {
    return resultSet.has(node2);
  });
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/firstFocus.js
var pickFirstFocus = function(nodes) {
  if (nodes[0] && nodes.length > 1) {
    return correctNode(nodes[0], nodes);
  }
  return nodes[0];
};
var pickFocusable = function(nodes, node2) {
  return nodes.indexOf(correctNode(node2, nodes));
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/solver.js
var NEW_FOCUS = "NEW_FOCUS";
var newFocus = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);
  if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
    return void 0;
  }
  var activeIndex = activeElement !== void 0 ? outerNodes.indexOf(activeElement) : -1;
  var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
  var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
  if (activeIndex === -1) {
    if (lastNodeInside !== -1) {
      return lastNodeInside;
    }
    return NEW_FOCUS;
  }
  if (lastNodeInside === -1) {
    return NEW_FOCUS;
  }
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);
  var correctedNodes = correctNodes(outerNodes);
  var correctedIndex = activeElement !== void 0 ? correctedNodes.indexOf(activeElement) : -1;
  var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  if (innerTabbables.length === 0) {
    return lastNodeInside;
  }
  var returnFirstNode = pickFocusable(innerNodes, innerTabbables[0]);
  var returnLastNode = pickFocusable(innerNodes, innerTabbables[innerTabbables.length - 1]);
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
    return lastNodeInside;
  }
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  return void 0;
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/auto-focus.js
var findAutoFocused = function(autoFocusables) {
  return function(node2) {
    var _a;
    var autofocus = (_a = getDataset(node2)) === null || _a === void 0 ? void 0 : _a.autofocus;
    return (
      // @ts-expect-error
      node2.autofocus || //
      autofocus !== void 0 && autofocus !== "false" || //
      autoFocusables.indexOf(node2) >= 0
    );
  };
};
var pickAutofocus = function(nodesIndexes, orderedNodes, groups) {
  var nodes = nodesIndexes.map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
  if (autoFocusable && autoFocusable.length) {
    return pickFirstFocus(autoFocusable);
  }
  return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/utils/parenting.js
var getParents = function(node2, parents) {
  if (parents === void 0) {
    parents = [];
  }
  parents.push(node2);
  if (node2.parentNode) {
    getParents(node2.parentNode.host || node2.parentNode, parents);
  }
  return parents;
};
var getCommonParent = function(nodeA, nodeB) {
  var parentsA = getParents(nodeA);
  var parentsB = getParents(nodeB);
  for (var i2 = 0; i2 < parentsA.length; i2 += 1) {
    var currentParent = parentsA[i2];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};
var getTopCommonParent = function(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = false;
  leftEntries.filter(Boolean).forEach(function(entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function(subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || contains(common, topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};
var allParentAutofocusables = function(entries, visibilityCache) {
  return entries.reduce(function(acc, node2) {
    return acc.concat(parentAutofocusables(node2, visibilityCache));
  }, []);
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/focusSolver.js
var reorderNodes = function(srcNodes, dstNodes) {
  var remap = /* @__PURE__ */ new Map();
  dstNodes.forEach(function(entity) {
    return remap.set(entity.node, entity);
  });
  return srcNodes.map(function(node2) {
    return remap.get(node2);
  }).filter(isDefined);
};
var focusSolver = function(topNode, lastNode) {
  var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
  var visibilityCache = /* @__PURE__ */ new Map();
  var anyFocusable = getFocusableNodes(entries, visibilityCache);
  var innerElements = anyFocusable.filter(function(_a) {
    var node2 = _a.node;
    return isNotAGuard(node2);
  });
  if (!innerElements[0]) {
    return void 0;
  }
  var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerFocusables = orderedInnerElements.map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  var innerTabbable = orderedInnerElements.filter(function(_a) {
    var tabIndex = _a.tabIndex;
    return tabIndex >= 0;
  }).map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  var newId = newFocus(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
  if (newId === NEW_FOCUS) {
    var focusNode = (
      // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
      pickAutofocus(anyFocusable, innerTabbable, allParentAutofocusables(entries, visibilityCache)) || pickAutofocus(anyFocusable, innerFocusables, allParentAutofocusables(entries, visibilityCache))
    );
    if (focusNode) {
      return { node: focusNode };
    } else {
      console.warn("focus-lock: cannot find any node to move focus into");
      return void 0;
    }
  }
  if (newId === void 0) {
    return newId;
  }
  return orderedInnerElements[newId];
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/focusables.js
var expandFocusableNodes = function(topNode) {
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
  var innerElements = getFocusables(entries, false);
  return outerNodes.map(function(_a) {
    var node2 = _a.node, index2 = _a.index;
    return {
      node: node2,
      index: index2,
      lockItem: innerElements.indexOf(node2) >= 0,
      guard: isGuard(node2)
    };
  });
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/commands.js
var focusOn = function(target, focusOptions) {
  if (!target) {
    return;
  }
  if ("focus" in target) {
    target.focus(focusOptions);
  }
  if ("contentWindow" in target && target.contentWindow) {
    target.contentWindow.focus();
  }
};

// node_modules/.pnpm/focus-lock@1.3.5/node_modules/focus-lock/dist/es2015/moveFocusInside.js
var guardCount = 0;
var lockDisabled = false;
var moveFocusInside = function(topNode, lastNode, options) {
  if (options === void 0) {
    options = {};
  }
  var focusable = focusSolver(topNode, lastNode);
  if (lockDisabled) {
    return;
  }
  if (focusable) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
      lockDisabled = true;
      setTimeout(function() {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node, options.focusOptions);
    guardCount--;
  }
};

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  setTimeout(action, 1);
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Trap.js
var focusOnBody = function focusOnBody2() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus2() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist2() {
  return true;
};
var focusWhitelisted = function focusWhitelisted2(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal2(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode,
    portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair2(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step2, allNodes) {
  var lastGuard = null;
  var i2 = startIndex;
  do {
    var item = allNodes[i2];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i2 !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i2 += step2) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var extractRef = function extractRef2(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var focusWasOutside = function focusWasOutside2(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === "meanwhile";
};
var checkInHost = function checkInHost2(check, el, boundary) {
  return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost2(check, el.parentNode, boundary));
};
var withinHost = function withinHost2(activeElement, workingArea) {
  return workingArea.some(function(area) {
    return checkInHost(activeElement, area, area);
  });
};
var activateTrap = function activateTrap2() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions
              });
              lastPortaledElement = {};
            }
          }
          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }
      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function(_ref2) {
          var node2 = _ref2.node;
          return node2;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function(_ref2) {
            var guard = _ref2.guard, node2 = _ref2.node;
            return guard && node2.dataset.focusAutoGuard;
          }).forEach(function(_ref3) {
            var node2 = _ref3.node;
            return node2.removeAttribute("tabIndex");
          });
          autoGuard(focusedIndex, allNodes.length, 1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap2(event) {
  if (activateTrap() && event) {
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur2() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus2(event) {
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher2() {
  return null;
};
var FocusTrap = function FocusTrap2(_ref4) {
  var children = _ref4.children;
  return /* @__PURE__ */ React32.createElement("div", {
    onBlur,
    onFocus
  }, children);
};
FocusTrap.propTypes = true ? {
  children: import_prop_types3.default.node.isRequired
} : {};
var onWindowBlur = function onWindowBlur2() {
  focusWasOutsideWindow = "just";
  deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
};
var attachHandler = function attachHandler2() {
  document.addEventListener("focusin", onTrap);
  document.addEventListener("focusout", onBlur);
  window.addEventListener("blur", onWindowBlur);
};
var detachHandler = function detachHandler2() {
  document.removeEventListener("focusin", onTrap);
  document.removeEventListener("focusout", onBlur);
  window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function(_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function(_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }
    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(cb) {
  return cb({
    moveFocusInside,
    focusInside
  });
});
var Trap_default = index_es_default(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Combination.js
var FocusLockCombination = /* @__PURE__ */ React33.forwardRef(function FocusLockUICombination(props, ref) {
  return /* @__PURE__ */ React33.createElement(Lock_default, _extends({
    sideCar: Trap_default,
    ref
  }, props));
});
var _ref = Lock_default.propTypes || {};
var sideCar = _ref.sideCar;
var propTypes = _objectWithoutPropertiesLoose(_ref, ["sideCar"]);
FocusLockCombination.propTypes = true ? propTypes : {};
var Combination_default = FocusLockCombination;

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.3.2_react@18.2.0/node_modules/react-focus-lock/dist/es2015/index.js
var es2015_default = Combination_default;

// node_modules/.pnpm/scroll-doctor@2.0.2/node_modules/scroll-doctor/dist/scroll-doctor.js
var n = [];
var c = { documentElement: {}, body: {} };
var i = Object.freeze({
  // html
  documentElement: {
    "scrollbar-gutter": "stable"
  },
  body: {
    overflow: "hidden",
    position: "relative",
    height: "100%"
  }
});
var r2 = (t) => {
  var _a;
  t.touches.length > 1 || ((_a = t.preventDefault) == null ? void 0 : _a.call(t));
};
var h = (t) => ([e, s]) => {
  c[t][e] = document[t].style[e], document[t].style[e] = s;
};
var a = () => Object.entries(i).forEach(([t, e]) => {
  Object.entries(e).forEach(h(t));
});
var d = (t) => ([e, s]) => {
  document[t].style[e] = c[t][e];
};
var f = () => Object.entries(c).forEach(([t, e]) => {
  Object.entries(e).forEach(d(t));
});
var m = (t) => t.scrollHeight - Math.abs(t.scrollTop) === t.clientHeight;
function y(t) {
  let e = -1;
  const s = (o) => {
    if (o.targetTouches.length !== 1)
      return;
    const l = o.targetTouches[0].clientY - e;
    return t.scrollTop === 0 && l > 0 || m(t) && l < 0 ? r2(o) : (o.stopPropagation(), true);
  };
  t.ontouchstart = (o) => {
    o.targetTouches.length === 1 && (e = o.targetTouches[0].clientY);
  }, t.ontouchmove = s;
}
function p(t) {
  t.ontouchstart = null, t.ontouchmove = null;
}
var u = (t) => () => document[t ? "addEventListener" : "removeEventListener"]("touchmove", r2, { passive: false });
var b = u(true);
var g = u();
function E(t) {
  if (!t)
    throw Error("Could not run setup, an element must be provided");
  n.some((e) => e === t) || (n.length || (a(), b()), y(t), n.push(t));
}
function T() {
  n.forEach(p), g(), f(), n = [];
}

// packages/modal/src/locales/en/messages.mjs
var messages40 = JSON.parse('{"modal.aria.back":"Back","modal.aria.close":"Close"}');

// packages/modal/src/locales/fi/messages.mjs
var messages41 = JSON.parse('{"modal.aria.back":"Takaisin","modal.aria.close":"Sulje"}');

// packages/modal/src/locales/nb/messages.mjs
var messages42 = JSON.parse('{"modal.aria.back":"Tilbake","modal.aria.close":"Lukk"}');

// packages/modal/src/component.tsx
var Modal = (_a) => {
  var _b = _a, { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy } = _b, props = __objRest(_b, ["aria-label", "aria-labelledby"]);
  const contentRef = useRef6(null);
  const id = useId(props.id);
  const closeButtonRef = useRef6(null);
  activateI18n7(messages40, messages42, messages41);
  useEffect10(
    () => (
      // Cleanup scroll lock if component unmounts before it receives an updated
      // open prop and is closed. Can happen if the host conditionally renders the
      // modal.
      () => T()
    ),
    []
  );
  useEffect10(() => {
    T();
    if (!contentRef.current)
      return;
    props.open && E(contentRef.current);
  }, [props.open, contentRef]);
  useEffect10(() => {
    var _a2, _b2;
    if (!props.initialFocusRef) {
      props.right && ((_a2 = closeButtonRef.current) == null ? void 0 : _a2.focus());
    } else {
      (_b2 = props.initialFocusRef.current) == null ? void 0 : _b2.focus();
    }
  }, [props.open, props.initialFocusRef, props.right]);
  if (!props.open)
    return /* @__PURE__ */ React34.createElement(React34.Fragment, null);
  return /* @__PURE__ */ React34.createElement(es2015_default, null, /* @__PURE__ */ React34.createElement("div", { onClick: props.onDismiss, className: r(props.className, modal.backdrop), style: __spreadValues({}, props.style) }, /* @__PURE__ */ React34.createElement(
    "div",
    {
      role: "dialog",
      "aria-modal": "true",
      id,
      onClick: (e) => {
        e.stopPropagation();
      },
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy != null ? ariaLabelledBy : props.title && !ariaLabel ? `${id}__title` : void 0,
      onKeyDown: (event) => {
        if (!props.onDismiss)
          return;
        if (event.key === "Escape") {
          props.onDismiss();
        }
      },
      className: modal.modal,
      tabIndex: -1
    },
    /* @__PURE__ */ React34.createElement("div", { className: modal.title }, typeof props.left === "boolean" && props.left ? /* @__PURE__ */ React34.createElement(
      "button",
      {
        type: "button",
        "aria-label": i18n18._(
          /*i18n*/
          {
            id: "modal.aria.back",
            message: "Back",
            comment: "Aria label for the back button in modal"
          }
        ),
        className: r(modal.transitionTitle, modal.titleButton, modal.titleButtonLeft),
        onClick: props.onLeftClick ? props.onLeftClick : props.onDismiss
      },
      /* @__PURE__ */ React34.createElement(arrow_left_16_default, { className: r(modal.titleButtonIcon) })
    ) : props.left, /* @__PURE__ */ React34.createElement(
      "div",
      {
        id: `${id}__title`,
        className: r(
          modal.transitionTitle,
          !!props.left ? modal.transitionTitleCenter : modal.transitionTitleColSpan
        )
      },
      typeof props.title === "string" ? /* @__PURE__ */ React34.createElement("h1", { className: modal.titleText }, props.title) : props.title
    ), typeof props.right === "boolean" && props.right ? /* @__PURE__ */ React34.createElement(
      "button",
      {
        ref: closeButtonRef,
        type: "button",
        "aria-label": i18n18._(
          /*i18n*/
          {
            id: "modal.aria.close",
            message: "Close",
            comment: "Aria label for the close button in modal"
          }
        ),
        onClick: props.onDismiss,
        className: r(modal.transitionTitle, modal.titleButton, modal.titleButtonRight)
      },
      /* @__PURE__ */ React34.createElement(close_16_default, { className: modal.titleButtonIcon })
    ) : props.right),
    /* @__PURE__ */ React34.createElement("div", { ref: contentRef, className: modal.content }, props.children),
    !!props.footer && /* @__PURE__ */ React34.createElement("div", { className: modal.footer }, props.footer)
  )));
};

// packages/pill/src/component.tsx
import React35 from "react";
import { i18n as i18n19 } from "@lingui/core";

// packages/pill/src/locales/en/messages.mjs
var messages43 = JSON.parse('{"pill.aria.openFilter":"Open filter","pill.aria.removeFilter":["Remove filter ",["label"]]}');

// packages/pill/src/locales/fi/messages.mjs
var messages44 = JSON.parse('{"pill.aria.openFilter":"Avaa suodatin","pill.aria.removeFilter":["Tyhjenn\xE4 suodatin ",["label"]]}');

// packages/pill/src/locales/nb/messages.mjs
var messages45 = JSON.parse('{"pill.aria.openFilter":"\xC5pne filter","pill.aria.removeFilter":["Fjern filter ",["label"]]}');

// packages/pill/src/component.tsx
function Pill(props) {
  activateI18n7(messages43, messages45, messages44);
  return /* @__PURE__ */ React35.createElement("div", { className: pill.pill }, /* @__PURE__ */ React35.createElement(
    "button",
    {
      type: "button",
      onClick: props.onClick,
      className: r(!props.canClose ? props.className : "", {
        [pill.button]: true,
        [props.suggestion ? pill.suggestion : pill.filter]: true,
        [pill.label]: true,
        [props.canClose ? pill.labelWithClose : pill.labelWithoutClose]: true
      })
    },
    /* @__PURE__ */ React35.createElement("span", { className: pill.a11y }, props.openSRLabel || i18n19._(
      /*i18n*/
      {
        id: "pill.aria.openFilter",
        message: "Open filter",
        comment: "Fallback screenreader message for open filter",
        values: { label: props.label }
      }
    )),
    props.icon || /* @__PURE__ */ React35.createElement("span", null, props.label)
  ), props.canClose && /* @__PURE__ */ React35.createElement(
    "button",
    {
      type: "button",
      className: r(props.className, {
        [pill.button]: true,
        [props.suggestion ? pill.suggestion : pill.filter]: true,
        [pill.close]: true
      }),
      onClick: props.onClose
    },
    /* @__PURE__ */ React35.createElement("span", { className: pill.a11y }, props.closeSRLabel || i18n19._(
      /*i18n*/
      {
        id: "pill.aria.removeFilter",
        message: "Remove filter {label}",
        comment: "Fallback screenreader message for removal of the filter",
        values: { label: props.label }
      }
    )),
    /* @__PURE__ */ React35.createElement(close_16_default, null)
  ));
}

// packages/select/src/component.tsx
import * as React36 from "react";
import { i18n as i18n20 } from "@lingui/core";

// packages/select/src/locales/en/messages.mjs
var messages46 = JSON.parse('{"select.label.optional":"(optional)"}');

// packages/select/src/locales/fi/messages.mjs
var messages47 = JSON.parse('{"select.label.optional":"(vapaaehtoinen)"}');

// packages/select/src/locales/nb/messages.mjs
var messages48 = JSON.parse('{"select.label.optional":"(valgfritt)"}');

// packages/select/src/component.tsx
var setup = (props) => {
  const _a = props, { className, invalid, id, hint, always, label: label2, style, optional, readOnly, disabled } = _a, rest = __objRest(_a, ["className", "invalid", "id", "hint", "always", "label", "style", "optional", "readOnly", "disabled"]);
  activateI18n7(messages46, messages48, messages47);
  const helpId = hint ? `${id}__hint` : void 0;
  return {
    attrs: {
      div: {
        style
      },
      label: {
        htmlFor: id,
        children: label2
      },
      select: __spreadProps(__spreadValues({}, rest), {
        "aria-describedby": helpId,
        "aria-errormessage": invalid && helpId ? helpId : void 0,
        "aria-invalid": invalid,
        disabled,
        id
      }),
      optional,
      help: always || invalid ? {
        children: hint,
        id: helpId
      } : null
    },
    wrapperClasses: r(select.wrapper, className),
    selectClasses: r({
      [select.default]: true,
      [select.invalid]: invalid,
      [select.disabled]: disabled,
      [select.readOnly]: readOnly
    }),
    selectWrapperClasses: r({
      [select.selectWrapper]: true
    }),
    helpTextClasses: r({
      [helpText.helpText]: true,
      [helpText.helpTextColor]: !invalid,
      [helpText.helpTextColorInvalid]: invalid
    }),
    chevronClasses: r({
      [select.chevron]: true,
      [select.chevronDisabled]: disabled
    })
  };
};
function Select(props, ref) {
  const id = useId(props.id);
  const { attrs, wrapperClasses, selectClasses, selectWrapperClasses, helpTextClasses, chevronClasses } = setup(__spreadProps(__spreadValues({}, props), { id }));
  const { div, label: label2, select: select2, help, optional } = attrs;
  return /* @__PURE__ */ React36.createElement("div", __spreadValues({ className: wrapperClasses }, div), label2.children && /* @__PURE__ */ React36.createElement("label", { htmlFor: label2.htmlFor, className: label.label }, label2.children, optional && /* @__PURE__ */ React36.createElement("span", { className: label.optional }, i18n20._(
    /*i18n*/
    {
      id: "select.label.optional",
      message: "(optional)",
      comment: "Shown behind label when marked as optional"
    }
  ))), /* @__PURE__ */ React36.createElement("div", { className: selectWrapperClasses }, /* @__PURE__ */ React36.createElement("select", __spreadProps(__spreadValues({ ref }, select2), { className: selectClasses })), /* @__PURE__ */ React36.createElement("div", { className: r(chevronClasses) }, /* @__PURE__ */ React36.createElement(chevron_down_16_default, null))), help && /* @__PURE__ */ React36.createElement("div", __spreadValues({ className: helpTextClasses }, help)));
}
var _Select = React36.forwardRef(Select);

// packages/slider/src/component.tsx
import React37, { useEffect as useEffect11, useMemo as useMemo2, useRef as useRef7, useState as useState7 } from "react";

// node_modules/.pnpm/@warp-ds+core@1.1.3_@floating-ui+dom@1.6.5/node_modules/@warp-ds/core/dist/slider/utils/helpers.js
var useDimensions = () => {
  let observer;
  const useOnResize = (updateDimensions) => (entries) => {
    const { left, width: w } = entries[0].target.getBoundingClientRect();
    updateDimensions({ left, width: w - 24 });
  };
  const mountedHook = (sliderLineEl, updateDimensions) => {
    updateDimensions(sliderLineEl.getBoundingClientRect());
    observer = new ResizeObserver(useOnResize(updateDimensions));
    observer.observe(sliderLineEl);
  };
  const unmountedHook = () => {
    observer.disconnect();
  };
  return { mountedHook, unmountedHook };
};
var validKeys = Object.freeze({
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight",
  end: "End",
  home: "Home",
  pageup: "PageUp",
  pagedown: "PageDown"
});
var validKeyCodes = Object.values(validKeys);
var eventOptions = { passive: true };
function roundDecimals(n2, decimals = 2) {
  const rounding = decimals ? Math.pow(10, decimals) : 1;
  return Math.round(n2 * rounding) / rounding;
}
var isNumber = (e) => Number.isFinite(parseFloat(e));
var clamp2 = (v, { min: min2, max: max2 }) => isNumber(v) ? Math.min(Math.max(Number(v), min2), max2) : min2;

// node_modules/.pnpm/@warp-ds+core@1.1.3_@floating-ui+dom@1.6.5/node_modules/@warp-ds/core/dist/slider/utils/handlers.js
var keydownRepeat = {
  counter: 0,
  repeatsBeforeAcceleration: 3
};
function createHandlers({ props, sliderState }) {
  const clampedChange = (n2) => clamp2(n2, { max: props.max, min: props.min });
  function getCoordinates(e) {
    const { left: offsetLeft, width: trackWidth } = sliderState.dimensions;
    const clientX = "touches" in e ? e.touches[0].clientX : e.clientX;
    let left = Math.min(Math.max((clientX - offsetLeft - 16) / trackWidth, 0), 1) || 0;
    const value = props.min + left * (props.max - props.min);
    return { value };
  }
  const getThumbPosition = () => (sliderState.position - props.min) / (props.max - props.min) * 100;
  const getThumbTransform = () => getThumbPosition() / 100 * sliderState.dimensions.width;
  const getShiftedChange = (n2) => {
    const r3 = 1 / sliderState.step;
    return Math.floor(n2 * r3) / r3;
  };
  function handleKeyDown(e) {
    const key = e.key;
    if (props.disabled || !validKeyCodes.includes(key))
      return;
    e.preventDefault();
    switch (key) {
      case validKeys.left:
      case validKeys.right:
      case validKeys.up:
      case validKeys.down: {
        const direction = key === validKeys.right || key === validKeys.up ? 1 : -1;
        let stepsToMove = sliderState.step;
        if (!props.preventAcceleration) {
          if (e.repeat) {
            keydownRepeat.counter++;
            const acceleratedStepPercentage = Math.min((keydownRepeat.counter - keydownRepeat.repeatsBeforeAcceleration) / 100, 0.2);
            stepsToMove = Math.max(sliderState.step, Math.ceil((direction > 0 ? props.max - sliderState.val : sliderState.val - props.min) * acceleratedStepPercentage));
          } else {
            keydownRepeat.counter = 0;
          }
        }
        sliderState.position = clampedChange(sliderState.val + direction * stepsToMove);
        break;
      }
      case validKeys.home:
        sliderState.position = props.min;
        break;
      case validKeys.end:
        sliderState.position = props.max;
        break;
      case validKeys.pageup:
      case validKeys.pagedown: {
        const direction = key === validKeys.pageup ? 1 : -1;
        const minStepMultiplier = 2;
        const maxStepMultiplier = 50;
        sliderState.position = clampedChange(sliderState.val + direction * sliderState.step * Math.max(minStepMultiplier, Math.min(maxStepMultiplier, Math.ceil((props.max - props.min) / 10 / sliderState.step))));
        break;
      }
      default:
        break;
    }
  }
  function handleFocus() {
  }
  function handleBlur() {
  }
  function handleMouseDown(e) {
    sliderState.sliderPressed = true;
    if ("touches" in e) {
      window.addEventListener("touchmove", handleMouseChange, eventOptions);
      window.addEventListener("touchend", handleMouseUp, { once: true });
    } else {
      window.addEventListener("mousemove", handleMouseChange, eventOptions);
      window.addEventListener("mouseup", handleMouseUp, { once: true });
    }
    e.stopPropagation();
    e.preventDefault();
  }
  function handleMouseUp() {
    sliderState.sliderPressed = false;
    window.removeEventListener("touchmove", handleMouseChange);
    window.removeEventListener("mousemove", handleMouseChange);
  }
  function handleClick(e) {
    handleMouseChange(e);
  }
  function handleMouseChange(e) {
    var _a;
    const { value } = getCoordinates(e);
    const n2 = roundDecimals(value);
    (_a = sliderState.thumbEl) == null ? void 0 : _a.focus();
    if (sliderState.position !== n2)
      sliderState.position = n2;
  }
  return {
    handleKeyDown,
    handleFocus,
    handleBlur,
    handleMouseDown,
    handleClick,
    getThumbPosition,
    getThumbTransform,
    getShiftedChange
  };
}

// packages/slider/src/component.tsx
function Slider(_a) {
  var _b = _a, { min: min2 = 0, max: max2 = 100 } = _b, rest = __objRest(_b, ["min", "max"]);
  const { disabled, onChange, onChangeAfter } = rest;
  const sliderLine = useRef7(null);
  const thumbRef = useRef7(null);
  const { mountedHook, unmountedHook } = useDimensions();
  useEffect11(() => {
    if (!sliderLine.current)
      return;
    mountedHook(sliderLine.current, setDimensions);
    return () => unmountedHook();
  }, [sliderLine]);
  const [value, setValue] = useState7(rest.value);
  const [finalValue, setFinalValue] = useState7(rest.value);
  const [position, setPosition] = useState7(rest.value);
  const [dimensions, setDimensions] = useState7({ left: 0, width: 0 });
  const [sliderPressed, setSliderPressed] = useState7(false);
  useEffect11(() => {
    if (value === rest.value)
      return;
    onChange == null ? void 0 : onChange(value);
  }, [rest.value, value, onChange]);
  useEffect11(() => {
    if (sliderPressed)
      return;
    if (value === finalValue)
      return;
    setFinalValue(value);
    onChangeAfter == null ? void 0 : onChangeAfter(value);
  }, [onChangeAfter, sliderPressed, value, finalValue]);
  const step2 = useMemo2(() => rest.step || 1, [rest]);
  const sliderState = {
    get position() {
      return position;
    },
    set position(v) {
      setPosition(v);
    },
    get sliderPressed() {
      return sliderPressed;
    },
    set sliderPressed(v) {
      setSliderPressed(v);
    },
    get val() {
      return value;
    },
    set val(v) {
      setValue(v);
    },
    get thumbEl() {
      return thumbRef.current;
    },
    get dimensions() {
      return dimensions;
    },
    get step() {
      return step2;
    }
  };
  const { handleKeyDown, handleFocus, handleBlur, handleMouseDown, handleClick, getThumbPosition, getThumbTransform, getShiftedChange } = createHandlers({ props: __spreadValues({ min: min2, max: max2 }, rest), sliderState });
  const thumbPosition = useMemo2(getThumbPosition, [getThumbPosition]);
  const sliderActiveStyle = useMemo2(
    () => ({
      left: 0,
      right: 100 - thumbPosition + "%"
    }),
    [thumbPosition]
  );
  const transformValue = useMemo2(getThumbTransform, [getThumbTransform]);
  const thumbStyles = useMemo2(
    () => ({
      transform: "translateX(" + transformValue + "px)"
    }),
    [transformValue]
  );
  useEffect11(() => {
    if (position === rest.value)
      return;
    const nextVal = rest.step ? getShiftedChange(position) : position;
    setValue(nextVal);
  }, [position, rest.value, rest.step]);
  useEffect11(() => {
    if (sliderPressed || position === rest.value || value === rest.value) {
      return;
    }
    setPosition(rest.value);
  }, [sliderPressed, rest.value]);
  return /* @__PURE__ */ React37.createElement("div", { className: slider.wrapper }, /* @__PURE__ */ React37.createElement(
    "div",
    {
      ref: sliderLine,
      className: r({
        [slider.track]: true,
        [slider.trackDisabled]: disabled
      }),
      onClick: handleClick
    }
  ), /* @__PURE__ */ React37.createElement(
    "div",
    {
      className: r({
        [slider.activeTrack]: !disabled,
        [slider.activeTrackDisabled]: disabled
      }),
      style: sliderActiveStyle,
      onClick: handleClick
    }
  ), /* @__PURE__ */ React37.createElement(
    "div",
    {
      role: "slider",
      tabIndex: 0,
      className: r({
        [slider.thumb]: true,
        [slider.thumbDisabled]: disabled,
        [slider.thumbEnabled]: !disabled
      }),
      ref: thumbRef,
      style: thumbStyles,
      "aria-label": rest["aria-label"],
      "aria-labelledby": rest["aria-labelledby"],
      "aria-valuemin": min2,
      "aria-valuemax": max2,
      "aria-valuenow": value,
      "aria-valuetext": rest["aria-valuetext"],
      onMouseDown: (e) => {
        handleMouseDown(e);
      },
      onTouchStart: (e) => {
        handleMouseDown(e);
      },
      onBlur: handleBlur,
      onFocus: handleFocus,
      onKeyDown: (e) => {
        handleKeyDown(e);
      }
    }
  ));
}

// packages/steps/src/component.tsx
import React38, { createContext } from "react";
var StepsContext = createContext({
  horizontal: void 0,
  right: void 0
});
function Steps({ horizontal, right, className, children }) {
  return /* @__PURE__ */ React38.createElement(
    StepsContext.Provider,
    {
      value: {
        horizontal,
        right
      }
    },
    /* @__PURE__ */ React38.createElement(
      "ul",
      {
        className: r(className, {
          [steps.steps]: true,
          [steps.stepsHorizontal]: horizontal
        })
      },
      children
    )
  );
}

// packages/steps/src/step.tsx
import React40, { useContext } from "react";
import { i18n as i18n30 } from "@lingui/core";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/check-16.js
import React39 from "react";
import { i18n as i18n210 } from "@lingui/core";
import { i18n as i18n21 } from "@lingui/core";
var __defProp11 = Object.defineProperty;
var __getOwnPropSymbols11 = Object.getOwnPropertySymbols;
var __hasOwnProp11 = Object.prototype.hasOwnProperty;
var __propIsEnum11 = Object.prototype.propertyIsEnumerable;
var __defNormalProp11 = (obj, key, value) => key in obj ? __defProp11(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues11 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp11.call(b2, prop))
      __defNormalProp11(a2, prop, b2[prop]);
  if (__getOwnPropSymbols11)
    for (var prop of __getOwnPropSymbols11(b2)) {
      if (__propIsEnum11.call(b2, prop))
        __defNormalProp11(a2, prop, b2[prop]);
    }
  return a2;
};
var messages49 = JSON.parse('{"icon.title.check":"Sjekkmerke"}');
var messages213 = JSON.parse('{"icon.title.check":"Checkmark"}');
var messages310 = JSON.parse('{"icon.title.check":"Valintamerkki"}');
var supportedLocales11 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale11 = "en";
var detectByBrand10 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost10 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale11;
  }
};
var getSupportedLocale11 = (usedLocale) => {
  return supportedLocales11.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost10();
};
function detectLocale11() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand10();
    return getSupportedLocale11(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost10();
    if (!supportedLocales11.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale11(hostLocale);
    }
    return getSupportedLocale11(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale11;
  }
}
var getMessages11 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n11 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale11();
  const messages410 = getMessages11(locale, enMessages, nbMessages, fiMessages);
  i18n21.load(locale, messages410);
  i18n21.activate(locale);
};
activateI18n11(messages213, messages49, messages310);
var title10 = i18n210.t({ message: `Checkmark`, id: "icon.title.check", comment: "Title for check icon" });
var IconCheck16 = (attrs) => React39.createElement("svg", __spreadValues11({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title10}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.83 7.667 7.163 11l5.334-6"></path>` } }, attrs));
var check_16_default = IconCheck16;

// packages/steps/src/locales/en/messages.mjs
var messages50 = JSON.parse('{"steps.aria.emptyCircle":"Empty circle","steps.aria.active":"Step indicator active circle","steps.aria.completed":"Step indicator completed circle"}');

// packages/steps/src/locales/fi/messages.mjs
var messages51 = JSON.parse('{"steps.aria.emptyCircle":"Tyhj\xE4 ympyr\xE4","steps.aria.active":"Vaiheilmaisin aktiivinen ympyr\xE4","steps.aria.completed":"Vaiheilmaisin valmis ympyr\xE4"}');

// packages/steps/src/locales/nb/messages.mjs
var messages52 = JSON.parse('{"steps.aria.emptyCircle":"Tom sirkel","steps.aria.active":"Stegindikator aktiv sirkel","steps.aria.completed":"Stegindikator hel sirkel"}');

// packages/steps/src/step.tsx
var availableAriaLabels = {
  completed: i18n30._(
    /*i18n*/
    {
      id: "steps.aria.completed",
      message: "Step indicator completed circle",
      comment: "Completed circle"
    }
  ),
  active: i18n30._(
    /*i18n*/
    {
      id: "steps.aria.active",
      message: "Step indicator active circle",
      comment: "Active circle"
    }
  ),
  default: i18n30._(
    /*i18n*/
    {
      id: "steps.aria.emptyCircle",
      message: "Empty circle",
      comment: "Empty circle"
    }
  )
};
var getAriaLabel = (props) => {
  const ariaLabel = Object.keys(availableAriaLabels).find((a2) => props[a2]);
  return ariaLabel ? availableAriaLabels[ariaLabel] : availableAriaLabels.default;
};
function Step(props) {
  activateI18n7(messages50, messages52, messages51);
  const { active, completed, children } = props;
  const StepsProps = useContext(StepsContext);
  const vertical = !StepsProps.horizontal;
  const left = !StepsProps.right;
  const stepClasses = r({
    [step.stepVertical]: vertical,
    [step.stepVerticalLeft]: vertical && left,
    [step.stepVerticalRight]: vertical && !left,
    [step.stepHorizontal]: !vertical
  });
  const stepLineHorizontalClasses = r({
    [step.stepLine]: true,
    [step.stepLineHorizontalLeft]: true,
    [step.stepLineHorizontal]: !vertical,
    [step.stepLineIncomplete]: !active && !completed,
    [step.stepLineComplete]: active || completed
  });
  const stepDotClasses = r({
    [step.stepDot]: true,
    [step.stepDotVerticalRight]: vertical && !left,
    [step.stepDotHorizontal]: !vertical,
    [step.stepDotIncomplete]: !(active || completed),
    [step.stepDotActive]: active || completed
  });
  const stepLineClasses = r({
    [step.stepLine]: true,
    [step.stepLineHorizontalRight]: true,
    [step.stepLineVertical]: vertical,
    [step.stepLineVerticalRight]: vertical && !left,
    [step.stepLineHorizontal]: !vertical,
    [step.stepLineIncomplete]: !completed,
    [step.stepLineComplete]: completed
  });
  const stepContentClasses = r({
    [step.content]: true,
    [step.contentVertical]: vertical,
    [step.contentHorizontal]: !vertical
  });
  return /* @__PURE__ */ React40.createElement("li", { className: stepClasses }, !vertical && /* @__PURE__ */ React40.createElement("div", { className: stepLineHorizontalClasses }), /* @__PURE__ */ React40.createElement("div", __spreadValues({ className: stepDotClasses, role: "img", "aria-label": getAriaLabel(props) }, active && { "aria-current": "step" }), completed && /* @__PURE__ */ React40.createElement(check_16_default, { "data-testid": "completed-icon" })), /* @__PURE__ */ React40.createElement("div", { className: stepLineClasses }), /* @__PURE__ */ React40.createElement("div", { className: stepContentClasses }, children));
}

// packages/switch/src/component.tsx
import React41 from "react";
function Switch(_a) {
  var _b = _a, { id, value, onClick, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy } = _b, attrs = __objRest(_b, ["id", "value", "onClick", "aria-label", "aria-labelledby"]);
  const switchFocus = "focusable rounded-full";
  return /* @__PURE__ */ React41.createElement("div", { className: switchToggle.switch }, /* @__PURE__ */ React41.createElement(
    "button",
    __spreadValues({
      id,
      type: "button",
      role: "switch",
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "aria-checked": value,
      onClick,
      className: r([switchToggle.label, switchFocus])
    }, attrs),
    /* @__PURE__ */ React41.createElement("span", { "data-testid": "track", className: r([switchToggle.track, value ? switchToggle.trackActive : switchToggle.trackInactive]) }),
    /* @__PURE__ */ React41.createElement(
      "span",
      {
        "data-testid": "handle",
        className: r([switchToggle.handle, switchToggle.handleNotDisabled], {
          [switchToggle.handleSelected]: value
        })
      }
    )
  ));
}

// packages/tabs/src/component-tab.tsx
import React42 from "react";
var setup2 = (_a) => {
  var _b = _a, { className, isActive, setActive } = _b, rest = __objRest(_b, ["className", "isActive", "setActive"]);
  return {
    tab: r(tab.tab, {
      [className]: !!className,
      [tab.tabActive]: isActive
    }),
    icon: r(tab.icon, {
      [tab.iconUnderlinedActive]: isActive
    }),
    content: r(tab.contentUnderlined, {
      [tab.contentUnderlinedActive]: isActive
    }),
    attrs: __spreadValues({}, rest)
  };
};
function Tab(props) {
  const { children, label: label2, setActive = () => {
  }, name, onClick, isActive } = props;
  const { tab: tab2, icon, content, attrs } = setup2(props);
  const _a = attrs, { over } = _a, rest = __objRest(_a, ["over"]);
  const handleClick = (e) => {
    setActive(name);
    onClick && onClick(e);
  };
  return /* @__PURE__ */ React42.createElement(
    "button",
    __spreadProps(__spreadValues({
      type: "button"
    }, rest), {
      role: "tab",
      "aria-selected": isActive ? "true" : "false",
      "aria-controls": isActive ? `warp-tabpanel-${name}` : void 0,
      id: `warp-tab-${name}`,
      tabIndex: isActive ? 0 : -1,
      className: tab2,
      onClick: handleClick
    }),
    !children && /* @__PURE__ */ React42.createElement("span", { className: content }, label2),
    children && over && /* @__PURE__ */ React42.createElement(React42.Fragment, null, /* @__PURE__ */ React42.createElement("span", { className: icon }, children), /* @__PURE__ */ React42.createElement("span", { className: content }, label2)),
    children && !over && /* @__PURE__ */ React42.createElement("div", { className: tab.content }, children, label2)
  );
}

// packages/tabs/src/component-tab-panel.tsx
import React43 from "react";
function TabPanel(props) {
  var _b, _c;
  const _a = props, { children, name, hidden } = _a, rest = __objRest(_a, ["children", "name", "hidden"]);
  return /* @__PURE__ */ React43.createElement(
    "div",
    __spreadProps(__spreadValues({
      tabIndex: -1
    }, rest), {
      role: "tabpanel",
      "aria-labelledby": `warp-tab-${name}`,
      id: `warp-tabpanel-${name}`,
      hidden: hidden === void 0 && typeof document === "object" ? !((_c = (_b = document == null ? void 0 : document.getElementById(`warp-tab-${name}`)) == null ? void 0 : _b.classList) == null ? void 0 : _c.contains(tab.tabActive)) : hidden
    }),
    children
  );
}

// packages/tabs/src/component-tabs.tsx
import React44, { Children, cloneElement as cloneElement2, useEffect as useEffect12, useRef as useRef8, useState as useState8 } from "react";

// packages/tabs/src/utils.ts
function debounce(func2, wait = 200, immediate = false) {
  let timeout;
  return function() {
    var later = () => {
      timeout = null;
      if (!immediate)
        func2.apply(this, arguments);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow)
      func2.apply(this, arguments);
  };
}

// packages/tabs/src/component-tabs.tsx
var setup3 = (_a, tabsRef, wunderbarRef) => {
  var _b = _a, { className, children, onClick, active } = _b, rest = __objRest(_b, ["className", "children", "onClick", "active"]);
  return {
    nav: r(tabs.wrapperUnderlined, {
      [className]: !!className
    }),
    div: r(tabs.tabContainer, {
      [gridLayout[`cols${children.length}`]]: true
    }),
    wunderbar: r(tabs.wunderbar),
    attrs: rest,
    updateWunderbar: () => {
      window.requestAnimationFrame(() => {
        if (tabsRef.current && wunderbarRef.current) {
          const activeEl = tabsRef.current.querySelector('button[role="tab"][aria-selected="true"]');
          if (activeEl) {
            const parentLeft = tabsRef.current.getBoundingClientRect().left;
            const { left, width } = activeEl.getBoundingClientRect();
            wunderbarRef.current.style.left = `${left - parentLeft}px`;
            wunderbarRef.current.style.width = `${width}px`;
          }
        }
      });
    }
  };
};
var Tabs = (props) => {
  const isBrowser2 = Boolean(typeof document === "object" && (document == null ? void 0 : document.createElement));
  const tabsRef = useRef8(null);
  const wunderbarRef = useRef8(null);
  const { children, onChange } = props;
  const { nav, div, wunderbar, attrs, updateWunderbar } = setup3(props, tabsRef, wunderbarRef);
  useEffect12(() => {
    isBrowser2 && updatePanels();
    updateWunderbar();
    const updateDebounced = debounce(updateWunderbar, 100);
    window.addEventListener("resize", updateDebounced);
    return () => window.removeEventListener("resize", updateDebounced);
  });
  const findActive = () => {
    var _a;
    if (props.active) {
      return String(props.active);
    } else if (Children.count(children) > 0) {
      const childrenArray = Children.toArray(children);
      const activeChild = (childrenArray == null ? void 0 : childrenArray.find(
        // @ts-ignore: semantic error
        (child) => {
          var _a2;
          return (_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.isActive;
        }
      )) || childrenArray[0];
      return String(((_a = activeChild == null ? void 0 : activeChild.props) == null ? void 0 : _a.name) || "");
    }
    return "";
  };
  const [active, setActive] = useState8(findActive());
  const updatePanels = () => {
    Children.forEach(children, (child) => {
      var _a, _b;
      if (typeof child === "object") {
        const panel = document.getElementById(
          // @ts-ignore: semantic error
          `warp-tabpanel-${(_a = child == null ? void 0 : child.props) == null ? void 0 : _a.name}`
        );
        if (panel) {
          panel.hidden = ((_b = child == null ? void 0 : child.props) == null ? void 0 : _b.name) !== active;
        }
      }
    });
  };
  const change = (name) => {
    setActive(name);
    updateWunderbar();
    onChange && onChange(name);
  };
  const handleKeyDown = (event) => {
    var _a, _b, _c;
    if (!event.altKey && !event.ctrlKey && !event.shiftKey && ["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
      const tabs2 = Array.from((_b = (_a = tabsRef == null ? void 0 : tabsRef.current) == null ? void 0 : _a.querySelectorAll('button[role="tab"]')) != null ? _b : []);
      const activeTabIndex = tabs2.findIndex((tab2) => tab2.name === active);
      if (activeTabIndex >= 0) {
        const nextIndex = (() => {
          switch (event.key) {
            case "Home":
              return 0;
            case "End":
              return tabs2.length - 1;
            case "ArrowLeft":
              return Math.max(0, activeTabIndex - 1);
            case "ArrowRight":
              return Math.min(tabs2.length - 1, activeTabIndex + 1);
            default:
              return activeTabIndex;
          }
        })();
        if (activeTabIndex !== nextIndex && ((_c = tabs2[nextIndex]) == null ? void 0 : _c.name)) {
          event.preventDefault();
          change(tabs2[nextIndex].name);
          tabs2[nextIndex].focus();
        }
      }
    }
  };
  return /* @__PURE__ */ React44.createElement("div", __spreadProps(__spreadValues({}, attrs), { className: nav }), /* @__PURE__ */ React44.createElement("div", { role: "tablist", className: div, ref: tabsRef, onKeyDown: handleKeyDown }, Children.map(
    children,
    (child) => {
      var _a;
      return child && cloneElement2(child, {
        setActive: change,
        isActive: ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.name) === active
      });
    }
  ), /* @__PURE__ */ React44.createElement("span", { className: wunderbar, ref: wunderbarRef })));
};

// packages/textarea/src/component.tsx
import React46, { forwardRef as forwardRef8, useRef as useRef10 } from "react";
import { i18n as i18n31 } from "@lingui/core";

// packages/textarea/src/locales/en/messages.mjs
var messages53 = JSON.parse('{"textarea.label.optional":"(optional)"}');

// packages/textarea/src/locales/fi/messages.mjs
var messages54 = JSON.parse('{"textarea.label.optional":"(valinnainen)"}');

// packages/textarea/src/locales/nb/messages.mjs
var messages55 = JSON.parse('{"textarea.label.optional":"(valgfritt)"}');

// packages/textarea/src/useTextAreaHeight.ts
import { useEffect as useEffect13, useRef as useRef9 } from "react";
function useTextAreaHeight({ ref, value, minimumRows, maximumRows }) {
  const minHeight = useRef9(-Infinity);
  const maxHeight = useRef9(Infinity);
  const isControlled = value !== void 0;
  function resize(textarea) {
    textarea.style.setProperty("height", "auto");
    let height = Math.max(minHeight.current, textarea.scrollHeight);
    height = Math.min(maxHeight.current, height);
    textarea.style.setProperty("height", height + "px");
  }
  useLayoutEffect(() => {
    if (ref.current && (minimumRows || maximumRows)) {
      const style = getComputedStyle(ref.current);
      const lineHeight = parseFloat(style.getPropertyValue("line-height"));
      const topPadding = parseFloat(style.getPropertyValue("padding-top"));
      const bottomPadding = parseFloat(style.getPropertyValue("padding-bottom"));
      const bottomBorder = parseFloat(style.getPropertyValue("border-bottom-width"));
      const offset3 = topPadding + bottomPadding + bottomBorder;
      if (minimumRows) {
        minHeight.current = lineHeight * minimumRows + offset3;
      }
      if (maximumRows) {
        maxHeight.current = lineHeight * maximumRows + offset3;
      }
    }
  }, [ref, maximumRows, minimumRows]);
  useLayoutEffect(() => {
    if (ref.current) {
      resize(ref.current);
    }
  }, [ref, value]);
  useEffect13(() => {
    if (!ref.current && isControlled)
      return;
    const textarea = ref.current;
    const handleInput = () => {
      resize(textarea);
    };
    textarea.addEventListener("input", handleInput);
    return () => textarea.removeEventListener("input", handleInput);
  }, [ref, isControlled]);
}

// packages/textarea/src/component.tsx
var TextArea = forwardRef8((props, forwardRef9) => {
  const _a = props, {
    className,
    disabled,
    error,
    helpText: helpText2,
    id: providedId,
    invalid,
    label: label2,
    maximumRows,
    minimumRows,
    readOnly,
    style,
    value,
    optional,
    placeholder
  } = _a, rest = __objRest(_a, [
    "className",
    "disabled",
    "error",
    "helpText",
    "id",
    "invalid",
    "label",
    "maximumRows",
    "minimumRows",
    "readOnly",
    "style",
    "value",
    "optional",
    "placeholder"
  ]);
  activateI18n7(messages53, messages55, messages54);
  const id = useId(providedId);
  const ref = useRef10(null);
  const helpId = helpText2 ? `${id}__hint` : void 0;
  const isInvalid = invalid != null ? invalid : error;
  useTextAreaHeight({
    ref,
    value,
    maximumRows,
    minimumRows
  });
  return /* @__PURE__ */ React46.createElement("div", { className, style }, label2 && /* @__PURE__ */ React46.createElement("label", { htmlFor: id, className: label.label }, label2, optional && /* @__PURE__ */ React46.createElement("span", { className: label.optional }, i18n31._(
    /*i18n*/
    {
      id: "textarea.label.optional",
      message: "(optional)",
      comment: "Shown behind label when marked as optional"
    }
  ))), /* @__PURE__ */ React46.createElement(
    "textarea",
    __spreadProps(__spreadValues({
      className: r({
        [`${input.base} ${input.textArea}`]: true,
        [input.placeholder]: !!placeholder,
        [input.default]: !isInvalid && !disabled && !readOnly,
        [input.invalid]: isInvalid && !disabled && !readOnly,
        [input.disabled]: !isInvalid && disabled && !readOnly,
        [input.readOnly]: !isInvalid && !disabled && readOnly
      })
    }, rest), {
      placeholder,
      "aria-describedby": helpId,
      "aria-errormessage": isInvalid && helpId ? helpId : void 0,
      "aria-invalid": isInvalid,
      disabled,
      id,
      ref: (node2) => {
        ref.current = node2;
        if (forwardRef9) {
          if (typeof forwardRef9 === "function") {
            forwardRef9(node2);
          } else {
            forwardRef9.current = node2;
          }
        }
      },
      readOnly,
      value
    })
  ), helpText2 && /* @__PURE__ */ React46.createElement(
    "div",
    {
      className: r({
        [helpText.helpText]: true,
        [helpText.helpTextColor]: !isInvalid,
        [helpText.helpTextColorInvalid]: isInvalid
      }),
      id: helpId
    },
    helpText2
  ));
});

// packages/toggle/src/component.tsx
import React47 from "react";
import { i18n as i18n32 } from "@lingui/core";

// packages/toggle/src/locales/en/messages.mjs
var messages56 = JSON.parse('{"toggle.label.optional":"(optional)"}');

// packages/toggle/src/locales/fi/messages.mjs
var messages57 = JSON.parse('{"toggle.label.optional":"(vapaaehtoinen)"}');

// packages/toggle/src/locales/nb/messages.mjs
var messages58 = JSON.parse('{"toggle.label.optional":"(valgfritt)"}');

// packages/toggle/src/component.tsx
function Title({ id, title: title14, optional }) {
  activateI18n7(messages56, messages58, messages57);
  return /* @__PURE__ */ React47.createElement("legend", { id: `${id}__title`, className: label.label }, title14, optional && /* @__PURE__ */ React47.createElement("span", { className: label.optional }, i18n32._(
    /*i18n*/
    {
      id: "toggle.label.optional",
      message: "(optional)",
      comment: "Shown behind label when marked as optional"
    }
  )));
}
function HelpText({ isInvalid, helpId, helpText: helpText2 }) {
  return /* @__PURE__ */ React47.createElement(
    "div",
    {
      id: helpId,
      className: r({
        [helpText.helpText]: true,
        [helpText.helpTextColor]: !isInvalid,
        [helpText.helpTextColorInvalid]: isInvalid
      })
    },
    helpText2
  );
}
function Toggle(props) {
  const id = useId();
  const helpId = props.helpText ? `${id}__hint` : void 0;
  const isRadio = props.type === "radio";
  const isCheckbox = props.type === "checkbox";
  const isRadioButton = props.type === "radio-button";
  const isRadioGroup = isRadio || isRadioButton;
  const isIndeterminate = isCheckbox && props.indeterminate;
  const isInvalid = props.invalid;
  const isDisabled = !isRadioButton && props.disabled;
  const isControlled = props.selected !== void 0 || props.checked !== void 0;
  const labelClasses = r({
    [toggle.label]: !isRadioButton,
    [toggle.labelBefore]: !isRadioButton && !isIndeterminate,
    [toggle.checkbox]: isCheckbox && !isIndeterminate && !isInvalid && !isDisabled,
    [toggle.checkboxInvalid]: isCheckbox && !isIndeterminate && isInvalid && !isDisabled,
    [toggle.checkboxDisabled]: isCheckbox && !isIndeterminate && !isInvalid && isDisabled,
    [toggle.indeterminate]: isCheckbox && isIndeterminate && !isInvalid && !isDisabled,
    [toggle.indeterminateInvalid]: isCheckbox && isIndeterminate && isInvalid && !isDisabled,
    [toggle.indeterminateDisabled]: isCheckbox && isIndeterminate && !isInvalid && isDisabled,
    [toggle.radio]: isRadio && !isInvalid && !isDisabled,
    [toggle.radioInvalid]: isRadio && isInvalid && !isDisabled,
    [toggle.radioDisabled]: isRadio && !isInvalid && isDisabled,
    [toggle.radioButtonsLabel]: isRadioButton,
    [toggle.radioButtonsRegular]: isRadioButton && !props.small,
    [toggle.radioButtonsSmall]: isRadioButton && props.small
  });
  const inputClasses = r({
    [toggle.input]: true,
    [toggle.a11y]: true
  });
  const wrapperClasses = r(props.className, {
    [toggle.wrapper]: true,
    [toggle.wrapperRadioButtons]: isRadioButton && !props.equalWidth,
    [toggle.wrapperRadioButtonsJustified]: isRadioButton && props.equalWidth
  });
  const groupClasses = r({
    [toggle.radioButtonsGroup]: true,
    [toggle.radioButtonsGroupJustified]: props.equalWidth
  });
  return /* @__PURE__ */ React47.createElement(
    "fieldset",
    {
      role: isRadioGroup ? "radiogroup" : void 0,
      "aria-invalid": isRadioGroup ? isInvalid : void 0,
      "aria-errormessage": isRadioGroup && isInvalid ? helpId : void 0,
      "aria-describedby": helpId,
      className: toggle.field
    },
    props.title && /* @__PURE__ */ React47.createElement(Title, { id, title: props.title, optional: props.optional }),
    /* @__PURE__ */ React47.createElement("div", { className: wrapperClasses }, !props.options && props.label ? /* @__PURE__ */ React47.createElement(
      Item,
      {
        controlled: isControlled,
        label: props.label,
        inputClassName: inputClasses,
        labelClassName: labelClasses,
        checked: props.checked,
        defaultChecked: props.defaultChecked,
        indeterminate: props.indeterminate,
        onChange: (e) => props.onChange(e),
        name: `${id}:toggle`,
        key: `${id + props.type}`,
        invalid: isInvalid,
        disabled: isDisabled,
        helpId,
        type: isRadioGroup ? "radio" : "checkbox",
        noVisibleLabel: props.noVisibleLabel
      }
    ) : props.options && props.options.map((option, i2) => {
      var _a, _b;
      return /* @__PURE__ */ React47.createElement(
        Item,
        {
          controlled: isControlled,
          checked: (_a = props.selected) == null ? void 0 : _a.some((s) => s.value === option.value),
          defaultChecked: (_b = props.defaultSelected) == null ? void 0 : _b.some((s) => s.value === option.value),
          inputClassName: inputClasses,
          labelClassName: labelClasses,
          groupClassName: groupClasses,
          option,
          onChange: (e) => props.onChange(e),
          name: `${id}:toggle`,
          key: `${id + i2 + props.type}`,
          invalid: isInvalid,
          disabled: isDisabled,
          helpId,
          type: isRadioGroup ? "radio" : "checkbox",
          noVisibleLabel: props.noVisibleLabel,
          multiple: true
        }
      );
    })),
    props.helpText && /* @__PURE__ */ React47.createElement(HelpText, { helpId, helpText: props.helpText, isInvalid })
  );
}

// packages/pagination/src/Pagination.tsx
import React58 from "react";

// packages/pagination/src/CurrentPage.tsx
import React49 from "react";
import { i18n as i18n34 } from "@lingui/core";

// packages/pagination/src/PaginationContainer.tsx
import React48 from "react";
import { i18n as i18n33 } from "@lingui/core";
var PaginationContext = React48.createContext({
  currentPage: 0,
  lastPage: 0
});
var usePagination = () => React48.useContext(PaginationContext);
var PaginationContainer = React48.forwardRef(
  (_a, ref) => {
    var _b = _a, { children, className, currentPage, lastPage, "aria-labelledby": ariaLabelledBy = "pagination-heading" } = _b, props = __objRest(_b, ["children", "className", "currentPage", "lastPage", "aria-labelledby"]);
    var _a2;
    if (!Number.isInteger(currentPage)) {
      throw new TypeError(`Invalid currentPage: ${JSON.stringify(currentPage)}`);
    }
    if (!Number.isInteger(lastPage)) {
      throw new TypeError(`Invalid lastPage: ${JSON.stringify(lastPage)}`);
    }
    const context = React48.useMemo(
      () => ({
        currentPage: Math.max(1, Math.min(currentPage, lastPage)),
        lastPage: Math.max(1, lastPage)
      }),
      [currentPage, lastPage]
    );
    const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n33._({
      id: "pagination.aria.pagination",
      message: "Pages",
      comment: "Default screenreader message for pagination container in the pagination component"
    });
    return /* @__PURE__ */ React48.createElement("nav", __spreadProps(__spreadValues({}, props), { className: r(pagination.containerNav, className), "aria-labelledby": ariaLabelledBy, ref }), /* @__PURE__ */ React48.createElement("h1", { className: pagination.a11y, id: ariaLabelledBy }, ariaLabel), /* @__PURE__ */ React48.createElement(PaginationContext.Provider, { value: context }, children));
  }
);
var PaginationContainer_default = PaginationContainer;

// packages/pagination/src/CurrentPage.tsx
var CurrentPage = React49.forwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  const { currentPage } = usePagination();
  const label2 = children != null ? children : i18n34._({
    id: "pagination.label.current-page",
    message: "Page {currentPage}",
    values: { currentPage },
    comment: "Default message for current page label in the pagination component"
  });
  return /* @__PURE__ */ React49.createElement("span", __spreadProps(__spreadValues({}, props), { className: r(pagination.currentPage, className), ref }), label2);
});
var CurrentPage_default = CurrentPage;

// packages/pagination/src/FirstPage.tsx
import React51 from "react";
import { i18n as i18n36 } from "@lingui/core";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-double-left-16.js
import React50 from "react";
import { i18n as i18n211 } from "@lingui/core";
import { i18n as i18n35 } from "@lingui/core";
var __defProp12 = Object.defineProperty;
var __getOwnPropSymbols12 = Object.getOwnPropertySymbols;
var __hasOwnProp12 = Object.prototype.hasOwnProperty;
var __propIsEnum12 = Object.prototype.propertyIsEnumerable;
var __defNormalProp12 = (obj, key, value) => key in obj ? __defProp12(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues12 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp12.call(b2, prop))
      __defNormalProp12(a2, prop, b2[prop]);
  if (__getOwnPropSymbols12)
    for (var prop of __getOwnPropSymbols12(b2)) {
      if (__propIsEnum12.call(b2, prop))
        __defNormalProp12(a2, prop, b2[prop]);
    }
  return a2;
};
var messages59 = JSON.parse('{"icon.title.chevron-double-left":"Dobbel pil til venstre"}');
var messages214 = JSON.parse('{"icon.title.chevron-double-left":"Double leftward arrow"}');
var messages311 = JSON.parse('{"icon.title.chevron-double-left":"Kaksi nuolta vasemmalle"}');
var supportedLocales12 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale12 = "en";
var detectByBrand11 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost11 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale12;
  }
};
var getSupportedLocale12 = (usedLocale) => {
  return supportedLocales12.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost11();
};
function detectLocale12() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand11();
    return getSupportedLocale12(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost11();
    if (!supportedLocales12.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale12(hostLocale);
    }
    return getSupportedLocale12(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale12;
  }
}
var getMessages12 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n12 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale12();
  const messages410 = getMessages12(locale, enMessages, nbMessages, fiMessages);
  i18n35.load(locale, messages410);
  i18n35.activate(locale);
};
activateI18n12(messages214, messages59, messages311);
var title11 = i18n211.t({ message: `Double leftward arrow`, id: "icon.title.chevron-double-left", comment: "Title for chevron-double-left icon" });
var IconChevronDoubleLeft16 = (attrs) => React50.createElement("svg", __spreadValues12({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title11}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 13 2 8l5-5m7 10L9 8l5-5"></path>` } }, attrs));
var chevron_double_left_16_default = IconChevronDoubleLeft16;

// packages/pagination/src/FirstPage.tsx
var FirstPage = React51.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  var _a2;
  const { currentPage } = usePagination();
  if (currentPage <= 2) {
    return null;
  }
  const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n36._({
    id: "pagination.aria.first-page",
    message: "First page",
    comment: "Default screenreader message for first page link in the pagination component"
  });
  const iconSuffix = i18n36._({
    id: "pagination.aria.icon-suffix",
    message: "icon",
    comment: "Suffix added at the end of icon titles when img semantics are lost on an html element"
  });
  return /* @__PURE__ */ React51.createElement("a", __spreadProps(__spreadValues({ ref }, props), { className: r(className, pagination.link, pagination.icon), rel: "start" }), /* @__PURE__ */ React51.createElement("span", { className: pagination.a11y }, ariaLabel, ","), /* @__PURE__ */ React51.createElement(chevron_double_left_16_default, null), /* @__PURE__ */ React51.createElement("span", { className: pagination.a11y }, iconSuffix));
});
var FirstPage_default = FirstPage;

// packages/pagination/src/locales/en/messages.mjs
var messages60 = JSON.parse('{"pagination.aria.first-page":"First page","pagination.aria.icon-suffix":"icon","pagination.aria.next-page":"Next page","pagination.label.current-page":["Page ",["currentPage"]],"pagination.aria.page":["Page ",["currentPage"]],"pagination.aria.pagination":"Pages","pagination.aria.prev-page":"Previous page"}');

// packages/pagination/src/locales/fi/messages.mjs
var messages61 = JSON.parse('{"pagination.aria.first-page":"Ensimm\xE4inen sivu","pagination.aria.icon-suffix":"kuvake","pagination.aria.next-page":"Seuraava sivu","pagination.label.current-page":["Sivu ",["currentPage"]],"pagination.aria.page":["Sivu ",["currentPage"]],"pagination.aria.pagination":"Sivut","pagination.aria.prev-page":"Edellinen sivu"}');

// packages/pagination/src/locales/nb/messages.mjs
var messages62 = JSON.parse('{"pagination.aria.first-page":"F\xF8rste side","pagination.aria.icon-suffix":"ikon","pagination.aria.next-page":"Neste side","pagination.label.current-page":["Side ",["currentPage"]],"pagination.aria.page":["Side ",["currentPage"]],"pagination.aria.pagination":"Sider","pagination.aria.prev-page":"Forrige side"}');

// packages/pagination/src/NextPage.tsx
import React53 from "react";
import { i18n as i18n38 } from "@lingui/core";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-right-16.js
import React52 from "react";
import { i18n as i18n212 } from "@lingui/core";
import { i18n as i18n37 } from "@lingui/core";
var __defProp13 = Object.defineProperty;
var __getOwnPropSymbols13 = Object.getOwnPropertySymbols;
var __hasOwnProp13 = Object.prototype.hasOwnProperty;
var __propIsEnum13 = Object.prototype.propertyIsEnumerable;
var __defNormalProp13 = (obj, key, value) => key in obj ? __defProp13(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues13 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp13.call(b2, prop))
      __defNormalProp13(a2, prop, b2[prop]);
  if (__getOwnPropSymbols13)
    for (var prop of __getOwnPropSymbols13(b2)) {
      if (__propIsEnum13.call(b2, prop))
        __defNormalProp13(a2, prop, b2[prop]);
    }
  return a2;
};
var messages63 = JSON.parse('{"icon.title.chevron-right":"Pil til h\xF8yre"}');
var messages215 = JSON.parse('{"icon.title.chevron-right":"Rightward arrow"}');
var messages312 = JSON.parse('{"icon.title.chevron-right":"Nuoli oikealle"}');
var supportedLocales13 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale13 = "en";
var detectByBrand12 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost12 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale13;
  }
};
var getSupportedLocale13 = (usedLocale) => {
  return supportedLocales13.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost12();
};
function detectLocale13() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand12();
    return getSupportedLocale13(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost12();
    if (!supportedLocales13.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale13(hostLocale);
    }
    return getSupportedLocale13(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale13;
  }
}
var getMessages13 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n13 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale13();
  const messages410 = getMessages13(locale, enMessages, nbMessages, fiMessages);
  i18n37.load(locale, messages410);
  i18n37.activate(locale);
};
activateI18n13(messages215, messages63, messages312);
var title12 = i18n212.t({ message: `Rightward arrow`, id: "icon.title.chevron-right", comment: "Title for chevron-right icon" });
var IconChevronRight16 = (attrs) => React52.createElement("svg", __spreadValues13({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title12}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5.5 13.75 5.5-5.5-5.5-5.5"></path>` } }, attrs));
var chevron_right_16_default = IconChevronRight16;

// packages/pagination/src/NextPage.tsx
var NextPage = React53.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, noFollow } = _b, props = __objRest(_b, ["className", "noFollow"]);
    var _a2;
    const { currentPage, lastPage } = usePagination();
    if (currentPage >= lastPage) {
      return null;
    }
    const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n38._({
      id: "pagination.aria.next-page",
      message: "Next page",
      comment: "Default screenreader message for next page link in the pagination component"
    });
    const iconSuffix = i18n38._({
      id: "pagination.aria.icon-suffix",
      message: "icon",
      comment: "Suffix added at the end of icon titles when img semantics are lost on an html element"
    });
    return /* @__PURE__ */ React53.createElement(React53.Fragment, null, /* @__PURE__ */ React53.createElement(
      "a",
      __spreadProps(__spreadValues({}, props), {
        ref,
        rel: `next${noFollow ? " nofollow" : ""}`,
        className: r(className, pagination.link, pagination.icon)
      }),
      /* @__PURE__ */ React53.createElement("span", { className: pagination.a11y }, ariaLabel, ","),
      /* @__PURE__ */ React53.createElement(chevron_right_16_default, null),
      /* @__PURE__ */ React53.createElement("span", { className: pagination.a11y }, iconSuffix)
    ));
  }
);
var NextPage_default = NextPage;

// packages/pagination/src/Page.tsx
import React54 from "react";
import { i18n as i18n39 } from "@lingui/core";
var Page = React54.forwardRef(
  (_a, ref) => {
    var _b = _a, { page = 1, className, currentPage, noFollow } = _b, props = __objRest(_b, ["page", "className", "currentPage", "noFollow"]);
    var _a2;
    const isCurrentPage = page === currentPage;
    const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n39._({
      id: "pagination.aria.page",
      message: "Page {currentPage}",
      values: { currentPage: page },
      comment: "Default screenreader message for page link in the pagination component"
    });
    return /* @__PURE__ */ React54.createElement(
      "a",
      __spreadProps(__spreadValues({
        "aria-label": ariaLabel
      }, props), {
        ref,
        rel: `${noFollow ? "nofollow" : ""}`,
        "aria-current": isCurrentPage ? "page" : void 0,
        className: r(className, pagination.link, [isCurrentPage ? pagination.active : pagination.notActive])
      }),
      page
    );
  }
);
var Page_default = Page;

// packages/pagination/src/Pages.tsx
import React55 from "react";
var Pages = React55.forwardRef((_a, ref) => {
  var _b = _a, { children, numPages = 7, className } = _b, props = __objRest(_b, ["children", "numPages", "className"]);
  const { currentPage, lastPage } = usePagination();
  const from = Math.max(currentPage - 3, 0);
  const to = Math.min(from + numPages, lastPage);
  const pages = Array.from(Array(to - from).keys()).map((_, i2) => from + i2 + 1);
  return /* @__PURE__ */ React55.createElement("div", __spreadProps(__spreadValues({}, props), { className: r(pagination.pages, className), ref }), pages.map(
    (page) => React55.cloneElement(children(page), {
      key: page,
      page,
      currentPage
    })
  ));
});
var Pages_default = Pages;

// packages/pagination/src/PrevPage.tsx
import React57 from "react";
import { i18n as i18n41 } from "@lingui/core";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-left-16.js
import React56 from "react";
import { i18n as i18n213 } from "@lingui/core";
import { i18n as i18n40 } from "@lingui/core";
var __defProp14 = Object.defineProperty;
var __getOwnPropSymbols14 = Object.getOwnPropertySymbols;
var __hasOwnProp14 = Object.prototype.hasOwnProperty;
var __propIsEnum14 = Object.prototype.propertyIsEnumerable;
var __defNormalProp14 = (obj, key, value) => key in obj ? __defProp14(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues14 = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp14.call(b2, prop))
      __defNormalProp14(a2, prop, b2[prop]);
  if (__getOwnPropSymbols14)
    for (var prop of __getOwnPropSymbols14(b2)) {
      if (__propIsEnum14.call(b2, prop))
        __defNormalProp14(a2, prop, b2[prop]);
    }
  return a2;
};
var messages64 = JSON.parse('{"icon.title.chevron-left":"Pil til venstre"}');
var messages216 = JSON.parse('{"icon.title.chevron-left":"Leftward arrow"}');
var messages313 = JSON.parse('{"icon.title.chevron-left":"Nuoli vasemmalle"}');
var supportedLocales14 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale14 = "en";
var detectByBrand13 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost13 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale14;
  }
};
var getSupportedLocale14 = (usedLocale) => {
  return supportedLocales14.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost13();
};
function detectLocale14() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand13();
    return getSupportedLocale14(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost13();
    if (!supportedLocales14.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale14(hostLocale);
    }
    return getSupportedLocale14(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale14;
  }
}
var getMessages14 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n14 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale14();
  const messages410 = getMessages14(locale, enMessages, nbMessages, fiMessages);
  i18n40.load(locale, messages410);
  i18n40.activate(locale);
};
activateI18n14(messages216, messages64, messages313);
var title13 = i18n213.t({ message: `Leftward arrow`, id: "icon.title.chevron-left", comment: "Title for chevron-left icon" });
var IconChevronLeft16 = (attrs) => React56.createElement("svg", __spreadValues14({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title13}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.5 13.75 5 8.25l5.5-5.5"></path>` } }, attrs));
var chevron_left_16_default = IconChevronLeft16;

// packages/pagination/src/PrevPage.tsx
var PrevPage = React57.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, noFollow } = _b, props = __objRest(_b, ["className", "noFollow"]);
    var _a2;
    const { currentPage } = usePagination();
    if (currentPage === 1) {
      return null;
    }
    const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n41._({
      id: "pagination.aria.prev-page",
      message: "Previous page",
      comment: "Default screenreader message for previous page link in the pagination component"
    });
    const iconSuffix = i18n41._({
      id: "pagination.aria.icon-suffix",
      message: "icon",
      comment: "Suffix added at the end of icon titles when img semantics are lost on an html element"
    });
    return /* @__PURE__ */ React57.createElement(
      "a",
      __spreadProps(__spreadValues({}, props), {
        ref,
        className: r(className, pagination.link, pagination.icon),
        rel: `prev${noFollow ? " nofollow" : ""}`
      }),
      /* @__PURE__ */ React57.createElement("span", { className: pagination.a11y }, ariaLabel, ","),
      /* @__PURE__ */ React57.createElement(chevron_left_16_default, null),
      /* @__PURE__ */ React57.createElement("span", { className: pagination.a11y }, iconSuffix)
    );
  }
);
var PrevPage_default = PrevPage;

// packages/pagination/src/Pagination.tsx
var Pagination = React58.forwardRef(
  (_a, ref) => {
    var _b = _a, { currentPage, numPages, lastPage, createHref, className, onChange, noFollow } = _b, props = __objRest(_b, ["currentPage", "numPages", "lastPage", "createHref", "className", "onChange", "noFollow"]);
    activateI18n7(messages60, messages62, messages61);
    if (!createHref) {
      throw new TypeError("createHref is undefined");
    }
    const handleClick = (page) => (event) => {
      if (onChange) {
        event.preventDefault();
        onChange(page);
      }
    };
    return /* @__PURE__ */ React58.createElement(PaginationContainer_default, __spreadProps(__spreadValues({}, props), { ref, currentPage, lastPage, className }), /* @__PURE__ */ React58.createElement(FirstPage_default, { href: createHref(1), onClick: handleClick(1) }), /* @__PURE__ */ React58.createElement(PrevPage_default, { href: createHref(currentPage - 1), onClick: handleClick(currentPage - 1), noFollow }), /* @__PURE__ */ React58.createElement(Pages_default, { numPages }, (page) => /* @__PURE__ */ React58.createElement(Page_default, { href: createHref(page), onClick: handleClick(page), noFollow })), /* @__PURE__ */ React58.createElement(CurrentPage_default, null), /* @__PURE__ */ React58.createElement(NextPage_default, { href: createHref(currentPage + 1), onClick: handleClick(currentPage + 1), noFollow }));
  }
);
export {
  Affix,
  Alert,
  Attention,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Clickable,
  Combobox,
  CurrentPage_default as CurrentPage,
  DeadToggle,
  ExpandTransition,
  Expandable,
  FirstPage_default as FirstPage,
  Modal,
  NextPage_default as NextPage,
  Page_default as Page,
  Pages_default as Pages,
  Pagination,
  PaginationContainer_default as PaginationContainer,
  Pill,
  PrevPage_default as PrevPage,
  _Select as Select,
  Slider,
  Step,
  Steps,
  Switch,
  Tab,
  TabPanel,
  Tabs,
  TextArea,
  TextField,
  Toggle,
  UnstyledHeading,
  usePagination
};
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/
//# sourceMappingURL=index.js.map
